(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components'), require('react-dom'), require('downshift'), require('react-tippy')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components', 'react-dom', 'downshift', 'react-tippy'], factory) :
    (global = global || self, factory(global['fbk-components'] = {}, global.React, global.styled, global.ReactDOM, global.Downshift, global.reactTippy));
}(this, (function (exports, React$2, styled, ReactDOM, Downshift, reactTippy) { 'use strict';

    var React$2__default = 'default' in React$2 ? React$2['default'] : React$2;
    var styled__default = 'default' in styled ? styled['default'] : styled;
    ReactDOM = ReactDOM && Object.prototype.hasOwnProperty.call(ReactDOM, 'default') ? ReactDOM['default'] : ReactDOM;
    var Downshift__default = 'default' in Downshift ? Downshift['default'] : Downshift;

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    }

    function AspectRatioWrapper(_a) {
        var children = _a.children, className = _a.className, aspectRatio = _a.aspectRatio, rest = __rest(_a, ["children", "className", "aspectRatio"]);
        return (React$2__default.createElement("div", __assign({ className: className }, rest), children));
    }
    var StyledAspectRatioWrapper = styled__default(AspectRatioWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  padding-top: ", ";\n\n  .image {\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  padding-top: ",
        ";\n\n  .image {\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n"])), function (_a) {
        var _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '1 / 1' : _b;
        var _c = aspectRatio
            .split('/')
            .map(function (i) { return parseInt(i && i.trim()); }), width = _c[0], height = _c[1];
        if (!width || !height || isNaN(width) || isNaN(height)) {
            console.error('Uncorrect aspect ratio, use "x / y" format');
            return '100%';
        }
        return (height / width) * 100 + "%";
    });
    var templateObject_1;

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function unwrapExports (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
    Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
    function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
    var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
    var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
    var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

    var reactIs_production_min = {
    	AsyncMode: AsyncMode,
    	ConcurrentMode: ConcurrentMode,
    	ContextConsumer: ContextConsumer,
    	ContextProvider: ContextProvider,
    	Element: Element$1,
    	ForwardRef: ForwardRef,
    	Fragment: Fragment,
    	Lazy: Lazy,
    	Memo: Memo,
    	Portal: Portal,
    	Profiler: Profiler,
    	StrictMode: StrictMode,
    	Suspense: Suspense,
    	isAsyncMode: isAsyncMode,
    	isConcurrentMode: isConcurrentMode,
    	isContextConsumer: isContextConsumer,
    	isContextProvider: isContextProvider,
    	isElement: isElement,
    	isForwardRef: isForwardRef,
    	isFragment: isFragment,
    	isLazy: isLazy,
    	isMemo: isMemo,
    	isPortal: isPortal,
    	isProfiler: isProfiler,
    	isStrictMode: isStrictMode,
    	isSuspense: isSuspense,
    	isValidElementType: isValidElementType,
    	typeOf: typeOf
    };

    var reactIs_development = createCommonjsModule(function (module, exports) {



    if (process.env.NODE_ENV !== "production") {
      (function() {

    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }

      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
      })();
    }
    });
    var reactIs_development_1 = reactIs_development.AsyncMode;
    var reactIs_development_2 = reactIs_development.ConcurrentMode;
    var reactIs_development_3 = reactIs_development.ContextConsumer;
    var reactIs_development_4 = reactIs_development.ContextProvider;
    var reactIs_development_5 = reactIs_development.Element;
    var reactIs_development_6 = reactIs_development.ForwardRef;
    var reactIs_development_7 = reactIs_development.Fragment;
    var reactIs_development_8 = reactIs_development.Lazy;
    var reactIs_development_9 = reactIs_development.Memo;
    var reactIs_development_10 = reactIs_development.Portal;
    var reactIs_development_11 = reactIs_development.Profiler;
    var reactIs_development_12 = reactIs_development.StrictMode;
    var reactIs_development_13 = reactIs_development.Suspense;
    var reactIs_development_14 = reactIs_development.isAsyncMode;
    var reactIs_development_15 = reactIs_development.isConcurrentMode;
    var reactIs_development_16 = reactIs_development.isContextConsumer;
    var reactIs_development_17 = reactIs_development.isContextProvider;
    var reactIs_development_18 = reactIs_development.isElement;
    var reactIs_development_19 = reactIs_development.isForwardRef;
    var reactIs_development_20 = reactIs_development.isFragment;
    var reactIs_development_21 = reactIs_development.isLazy;
    var reactIs_development_22 = reactIs_development.isMemo;
    var reactIs_development_23 = reactIs_development.isPortal;
    var reactIs_development_24 = reactIs_development.isProfiler;
    var reactIs_development_25 = reactIs_development.isStrictMode;
    var reactIs_development_26 = reactIs_development.isSuspense;
    var reactIs_development_27 = reactIs_development.isValidElementType;
    var reactIs_development_28 = reactIs_development.typeOf;

    var reactIs = createCommonjsModule(function (module) {

    if (process.env.NODE_ENV === 'production') {
      module.exports = reactIs_production_min;
    } else {
      module.exports = reactIs_development;
    }
    });

    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    /* eslint-disable no-unused-vars */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;

    function toObject(val) {
    	if (val === null || val === undefined) {
    		throw new TypeError('Object.assign cannot be called with null or undefined');
    	}

    	return Object(val);
    }

    function shouldUseNative() {
    	try {
    		if (!Object.assign) {
    			return false;
    		}

    		// Detect buggy property enumeration order in older V8 versions.

    		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
    		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
    		test1[5] = 'de';
    		if (Object.getOwnPropertyNames(test1)[0] === '5') {
    			return false;
    		}

    		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
    		var test2 = {};
    		for (var i = 0; i < 10; i++) {
    			test2['_' + String.fromCharCode(i)] = i;
    		}
    		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
    			return test2[n];
    		});
    		if (order2.join('') !== '0123456789') {
    			return false;
    		}

    		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
    		var test3 = {};
    		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
    			test3[letter] = letter;
    		});
    		if (Object.keys(Object.assign({}, test3)).join('') !==
    				'abcdefghijklmnopqrst') {
    			return false;
    		}

    		return true;
    	} catch (err) {
    		// We don't expect any of the above to throw, but better to be safe.
    		return false;
    	}
    }

    var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    	var from;
    	var to = toObject(target);
    	var symbols;

    	for (var s = 1; s < arguments.length; s++) {
    		from = Object(arguments[s]);

    		for (var key in from) {
    			if (hasOwnProperty.call(from, key)) {
    				to[key] = from[key];
    			}
    		}

    		if (getOwnPropertySymbols) {
    			symbols = getOwnPropertySymbols(from);
    			for (var i = 0; i < symbols.length; i++) {
    				if (propIsEnumerable.call(from, symbols[i])) {
    					to[symbols[i]] = from[symbols[i]];
    				}
    			}
    		}
    	}

    	return to;
    };

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

    var ReactPropTypesSecret_1 = ReactPropTypesSecret;

    var printWarning = function() {};

    if (process.env.NODE_ENV !== 'production') {
      var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
      var loggedTypeFailures = {};
      var has = Function.call.bind(Object.prototype.hasOwnProperty);

      printWarning = function(text) {
        var message = 'Warning: ' + text;
        if (typeof console !== 'undefined') {
          console.error(message);
        }
        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error(
                  (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
                  'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
                );
                err.name = 'Invariant Violation';
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || 'React class') + ': type specification of ' +
                location + ' `' + typeSpecName + '` is invalid; the type checker ' +
                'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
                'You may have forgotten to pass an argument to the type checker ' +
                'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
                'shape all require an argument).'
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;

              var stack = getStack ? getStack() : '';

              printWarning(
                'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
              );
            }
          }
        }
      }
    }

    /**
     * Resets warning cache when testing.
     *
     * @private
     */
    checkPropTypes.resetWarningCache = function() {
      if (process.env.NODE_ENV !== 'production') {
        loggedTypeFailures = {};
      }
    };

    var checkPropTypes_1 = checkPropTypes;

    var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
    var printWarning$1 = function() {};

    if (process.env.NODE_ENV !== 'production') {
      printWarning$1 = function(text) {
        var message = 'Warning: ' + text;
        if (typeof console !== 'undefined') {
          console.error(message);
        }
        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    function emptyFunctionThatReturnsNull() {
      return null;
    }

    var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }

      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */

      var ANONYMOUS = '<<anonymous>>';

      // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),

        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker,
      };

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      /*eslint-disable no-self-compare*/
      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */
      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      }
      // Make `instanceof Error` still work for returned errors.
      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret_1) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              var err = new Error(
                'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
                'Use `PropTypes.checkPropTypes()` to call them. ' +
                'Read more at http://fb.me/use-check-prop-types'
              );
              err.name = 'Invariant Violation';
              throw err;
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;
              if (
                !manualPropTypeCallCache[cacheKey] &&
                // Avoid spamming the console because they are often not actionable except for lib authors
                manualPropTypeWarningCount < 3
              ) {
                printWarning$1(
                  'You are manually calling a React.PropTypes validation ' +
                  'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
                  'and will throw in the standalone `prop-types` package. ' +
                  'You may be seeing this warning due to a third-party PropTypes ' +
                  'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);

        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);

            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!reactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== 'production') {
            if (arguments.length > 1) {
              printWarning$1(
                'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
                'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
              );
            } else {
              printWarning$1('Invalid argument supplied to oneOf, expected an array.');
            }
          }
          return emptyFunctionThatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === 'symbol') {
              return String(value);
            }
            return value;
          });
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }
          for (var key in propValue) {
            if (has$1(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== 'function') {
            printWarning$1(
              'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
              'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
            );
            return emptyFunctionThatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];
            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }
        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (!checker) {
              continue;
            }
            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }

      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }
          // We need to check all keys in case some are required but missing from
          // props.
          var allKeys = objectAssign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (!checker) {
              return new PropTypeError(
                'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
                '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
                '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error) {
              return error;
            }
          }
          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (typeof propValue) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;
          case 'boolean':
            return !propValue;
          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;
          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        }

        // falsy value can't be a Symbol
        if (!propValue) {
          return false;
        }

        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        }

        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      }

      // Equivalent of `typeof` but with special handling for array and regexp.
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return 'array';
        }
        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }
        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }
        return propType;
      }

      // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.
      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }
        return propType;
      }

      // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;
          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;
          default:
            return type;
        }
      }

      // Returns class name of the object, if any.
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes_1;
      ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;

      return ReactPropTypes;
    };

    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;

    var factoryWithThrowingShims = function() {
      function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret_1) {
          // It is still safe when called from React.
          return;
        }
        var err = new Error(
          'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
          'Use PropTypes.checkPropTypes() to call them. ' +
          'Read more at http://fb.me/use-check-prop-types'
        );
        err.name = 'Invariant Violation';
        throw err;
      }  shim.isRequired = shim;
      function getShim() {
        return shim;
      }  // Important!
      // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
      var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,

        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,

        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };

      ReactPropTypes.PropTypes = ReactPropTypes;

      return ReactPropTypes;
    };

    var propTypes = createCommonjsModule(function (module) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = reactIs;

      // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod
      var throwOnDirectAccess = true;
      module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = factoryWithThrowingShims();
    }
    });

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }

    function hasClass(element, className) {
      if (element.classList) return !!className && element.classList.contains(className);
      return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
    }

    function addClass(element, className) {
      if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }

    function replaceClassName(origClass, classToRemove) {
      return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
    }

    function removeClass(element, className) {
      if (element.classList) {
        element.classList.remove(className);
      } else if (typeof element.className === 'string') {
        element.className = replaceClassName(element.className, className);
      } else {
        element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
      }
    }

    var config = {
      disabled: false
    };

    var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
      enter: propTypes.number,
      exit: propTypes.number,
      appear: propTypes.number
    }).isRequired]) : null;
    var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
      enter: propTypes.string,
      exit: propTypes.string,
      active: propTypes.string
    }), propTypes.shape({
      enter: propTypes.string,
      enterDone: propTypes.string,
      enterActive: propTypes.string,
      exit: propTypes.string,
      exitDone: propTypes.string,
      exitActive: propTypes.string
    })]) : null;

    var TransitionGroupContext = React$2__default.createContext(null);

    var UNMOUNTED = 'unmounted';
    var EXITED = 'exited';
    var ENTERING = 'entering';
    var ENTERED = 'entered';
    var EXITING = 'exiting';
    /**
     * The Transition component lets you describe a transition from one component
     * state to another _over time_ with a simple declarative API. Most commonly
     * it's used to animate the mounting and unmounting of a component, but can also
     * be used to describe in-place transition states as well.
     *
     * ---
     *
     * **Note**: `Transition` is a platform-agnostic base component. If you're using
     * transitions in CSS, you'll probably want to use
     * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
     * instead. It inherits all the features of `Transition`, but contains
     * additional features necessary to play nice with CSS transitions (hence the
     * name of the component).
     *
     * ---
     *
     * By default the `Transition` component does not alter the behavior of the
     * component it renders, it only tracks "enter" and "exit" states for the
     * components. It's up to you to give meaning and effect to those states. For
     * example we can add styles to a component when it enters or exits:
     *
     * ```jsx
     * import { Transition } from 'react-transition-group';
     *
     * const duration = 300;
     *
     * const defaultStyle = {
     *   transition: `opacity ${duration}ms ease-in-out`,
     *   opacity: 0,
     * }
     *
     * const transitionStyles = {
     *   entering: { opacity: 1 },
     *   entered:  { opacity: 1 },
     *   exiting:  { opacity: 0 },
     *   exited:  { opacity: 0 },
     * };
     *
     * const Fade = ({ in: inProp }) => (
     *   <Transition in={inProp} timeout={duration}>
     *     {state => (
     *       <div style={{
     *         ...defaultStyle,
     *         ...transitionStyles[state]
     *       }}>
     *         I'm a fade Transition!
     *       </div>
     *     )}
     *   </Transition>
     * );
     * ```
     *
     * There are 4 main states a Transition can be in:
     *  - `'entering'`
     *  - `'entered'`
     *  - `'exiting'`
     *  - `'exited'`
     *
     * Transition state is toggled via the `in` prop. When `true` the component
     * begins the "Enter" stage. During this stage, the component will shift from
     * its current transition state, to `'entering'` for the duration of the
     * transition and then to the `'entered'` stage once it's complete. Let's take
     * the following example (we'll use the
     * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
     *
     * ```jsx
     * function App() {
     *   const [inProp, setInProp] = useState(false);
     *   return (
     *     <div>
     *       <Transition in={inProp} timeout={500}>
     *         {state => (
     *           // ...
     *         )}
     *       </Transition>
     *       <button onClick={() => setInProp(true)}>
     *         Click to Enter
     *       </button>
     *     </div>
     *   );
     * }
     * ```
     *
     * When the button is clicked the component will shift to the `'entering'` state
     * and stay there for 500ms (the value of `timeout`) before it finally switches
     * to `'entered'`.
     *
     * When `in` is `false` the same thing happens except the state moves from
     * `'exiting'` to `'exited'`.
     */

    var Transition = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(Transition, _React$Component);

      function Transition(props, context) {
        var _this;

        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;

        if (props.in) {
          if (appear) {
            initialStatus = EXITED;
            _this.appearStatus = ENTERING;
          } else {
            initialStatus = ENTERED;
          }
        } else {
          if (props.unmountOnExit || props.mountOnEnter) {
            initialStatus = UNMOUNTED;
          } else {
            initialStatus = EXITED;
          }
        }

        _this.state = {
          status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
      }

      Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;

        if (nextIn && prevState.status === UNMOUNTED) {
          return {
            status: EXITED
          };
        }

        return null;
      } // getSnapshotBeforeUpdate(prevProps) {
      //   let nextStatus = null
      //   if (prevProps !== this.props) {
      //     const { status } = this.state
      //     if (this.props.in) {
      //       if (status !== ENTERING && status !== ENTERED) {
      //         nextStatus = ENTERING
      //       }
      //     } else {
      //       if (status === ENTERING || status === ENTERED) {
      //         nextStatus = EXITING
      //       }
      //     }
      //   }
      //   return { nextStatus }
      // }
      ;

      var _proto = Transition.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
      };

      _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;

        if (prevProps !== this.props) {
          var status = this.state.status;

          if (this.props.in) {
            if (status !== ENTERING && status !== ENTERED) {
              nextStatus = ENTERING;
            }
          } else {
            if (status === ENTERING || status === ENTERED) {
              nextStatus = EXITING;
            }
          }
        }

        this.updateStatus(false, nextStatus);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
      };

      _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;

        if (timeout != null && typeof timeout !== 'number') {
          exit = timeout.exit;
          enter = timeout.enter; // TODO: remove fallback for next major

          appear = timeout.appear !== undefined ? timeout.appear : enter;
        }

        return {
          exit: exit,
          enter: enter,
          appear: appear
        };
      };

      _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) {
          mounting = false;
        }

        if (nextStatus !== null) {
          // nextStatus will always be ENTERING or EXITING.
          this.cancelNextCallback();

          if (nextStatus === ENTERING) {
            this.performEnter(mounting);
          } else {
            this.performExit();
          }
        } else if (this.props.unmountOnExit && this.state.status === EXITED) {
          this.setState({
            status: UNMOUNTED
          });
        }
      };

      _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;

        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;

        var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
            maybeNode = _ref2[0],
            maybeAppearing = _ref2[1];

        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set

        if (!mounting && !enter || config.disabled) {
          this.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(maybeNode);
          });
          return;
        }

        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
          status: ENTERING
        }, function () {
          _this2.props.onEntering(maybeNode, maybeAppearing);

          _this2.onTransitionEnd(enterTimeout, function () {
            _this2.safeSetState({
              status: ENTERED
            }, function () {
              _this2.props.onEntered(maybeNode, maybeAppearing);
            });
          });
        });
      };

      _proto.performExit = function performExit() {
        var _this3 = this;

        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

        if (!exit || config.disabled) {
          this.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(maybeNode);
          });
          return;
        }

        this.props.onExit(maybeNode);
        this.safeSetState({
          status: EXITING
        }, function () {
          _this3.props.onExiting(maybeNode);

          _this3.onTransitionEnd(timeouts.exit, function () {
            _this3.safeSetState({
              status: EXITED
            }, function () {
              _this3.props.onExited(maybeNode);
            });
          });
        });
      };

      _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
          this.nextCallback.cancel();
          this.nextCallback = null;
        }
      };

      _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
      };

      _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;

        var active = true;

        this.nextCallback = function (event) {
          if (active) {
            active = false;
            _this4.nextCallback = null;
            callback(event);
          }
        };

        this.nextCallback.cancel = function () {
          active = false;
        };

        return this.nextCallback;
      };

      _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

        if (!node || doesNotHaveTimeoutOrListener) {
          setTimeout(this.nextCallback, 0);
          return;
        }

        if (this.props.addEndListener) {
          var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
              maybeNode = _ref3[0],
              maybeNextCallback = _ref3[1];

          this.props.addEndListener(maybeNode, maybeNextCallback);
        }

        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      };

      _proto.render = function render() {
        var status = this.state.status;

        if (status === UNMOUNTED) {
          return null;
        }

        var _this$props = this.props,
            children = _this$props.children,
            _in = _this$props.in,
            _mountOnEnter = _this$props.mountOnEnter,
            _unmountOnExit = _this$props.unmountOnExit,
            _appear = _this$props.appear,
            _enter = _this$props.enter,
            _exit = _this$props.exit,
            _timeout = _this$props.timeout,
            _addEndListener = _this$props.addEndListener,
            _onEnter = _this$props.onEnter,
            _onEntering = _this$props.onEntering,
            _onEntered = _this$props.onEntered,
            _onExit = _this$props.onExit,
            _onExiting = _this$props.onExiting,
            _onExited = _this$props.onExited,
            _nodeRef = _this$props.nodeRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

        return (
          /*#__PURE__*/
          // allows for nested Transitions
          React$2__default.createElement(TransitionGroupContext.Provider, {
            value: null
          }, typeof children === 'function' ? children(status, childProps) : React$2__default.cloneElement(React$2__default.Children.only(children), childProps))
        );
      };

      return Transition;
    }(React$2__default.Component);

    Transition.contextType = TransitionGroupContext;
    Transition.propTypes = process.env.NODE_ENV !== "production" ? {
      /**
       * A React reference to DOM element that need to transition:
       * https://stackoverflow.com/a/51127130/4671932
       *
       *   - When `nodeRef` prop is used, `node` is not passed to callback functions
       *      (e.g. `onEnter`) because user already has direct access to the node.
       *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
       *     `nodeRef` need to be provided to `Transition` with changed `key` prop
       *     (see
       *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
       */
      nodeRef: propTypes.shape({
        current: typeof Element === 'undefined' ? propTypes.any : propTypes.instanceOf(Element)
      }),

      /**
       * A `function` child can be used instead of a React element. This function is
       * called with the current transition status (`'entering'`, `'entered'`,
       * `'exiting'`, `'exited'`), which can be used to apply context
       * specific props to a component.
       *
       * ```jsx
       * <Transition in={this.state.in} timeout={150}>
       *   {state => (
       *     <MyComponent className={`fade fade-${state}`} />
       *   )}
       * </Transition>
       * ```
       */
      children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

      /**
       * Show the component; triggers the enter or exit states
       */
      in: propTypes.bool,

      /**
       * By default the child component is mounted immediately along with
       * the parent `Transition` component. If you want to "lazy mount" the component on the
       * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
       * mounted, even on "exited", unless you also specify `unmountOnExit`.
       */
      mountOnEnter: propTypes.bool,

      /**
       * By default the child component stays mounted after it reaches the `'exited'` state.
       * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
       */
      unmountOnExit: propTypes.bool,

      /**
       * By default the child component does not perform the enter transition when
       * it first mounts, regardless of the value of `in`. If you want this
       * behavior, set both `appear` and `in` to `true`.
       *
       * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
       * > only adds an additional enter transition. However, in the
       * > `<CSSTransition>` component that first enter transition does result in
       * > additional `.appear-*` classes, that way you can choose to style it
       * > differently.
       */
      appear: propTypes.bool,

      /**
       * Enable or disable enter transitions.
       */
      enter: propTypes.bool,

      /**
       * Enable or disable exit transitions.
       */
      exit: propTypes.bool,

      /**
       * The duration of the transition, in milliseconds.
       * Required unless `addEndListener` is provided.
       *
       * You may specify a single timeout for all transitions:
       *
       * ```jsx
       * timeout={500}
       * ```
       *
       * or individually:
       *
       * ```jsx
       * timeout={{
       *  appear: 500,
       *  enter: 300,
       *  exit: 500,
       * }}
       * ```
       *
       * - `appear` defaults to the value of `enter`
       * - `enter` defaults to `0`
       * - `exit` defaults to `0`
       *
       * @type {number | { enter?: number, exit?: number, appear?: number }}
       */
      timeout: function timeout(props) {
        var pt = timeoutsShape;
        if (!props.addEndListener) pt = pt.isRequired;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return pt.apply(void 0, [props].concat(args));
      },

      /**
       * Add a custom transition end trigger. Called with the transitioning
       * DOM node and a `done` callback. Allows for more fine grained transition end
       * logic. Timeouts are still used as a fallback if provided.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * ```jsx
       * addEndListener={(node, done) => {
       *   // use the css transitionend event to mark the finish of a transition
       *   node.addEventListener('transitionend', done, false);
       * }}
       * ```
       */
      addEndListener: propTypes.func,

      /**
       * Callback fired before the "entering" status is applied. An extra parameter
       * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement, isAppearing: bool) -> void
       */
      onEnter: propTypes.func,

      /**
       * Callback fired after the "entering" status is applied. An extra parameter
       * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEntering: propTypes.func,

      /**
       * Callback fired after the "entered" status is applied. An extra parameter
       * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement, isAppearing: bool) -> void
       */
      onEntered: propTypes.func,

      /**
       * Callback fired before the "exiting" status is applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement) -> void
       */
      onExit: propTypes.func,

      /**
       * Callback fired after the "exiting" status is applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement) -> void
       */
      onExiting: propTypes.func,

      /**
       * Callback fired after the "exited" status is applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed
       *
       * @type Function(node: HtmlElement) -> void
       */
      onExited: propTypes.func
    } : {}; // Name the function so it is clearer in the documentation

    function noop() {}

    Transition.defaultProps = {
      in: false,
      mountOnEnter: false,
      unmountOnExit: false,
      appear: false,
      enter: true,
      exit: true,
      onEnter: noop,
      onEntering: noop,
      onEntered: noop,
      onExit: noop,
      onExiting: noop,
      onExited: noop
    };
    Transition.UNMOUNTED = UNMOUNTED;
    Transition.EXITED = EXITED;
    Transition.ENTERING = ENTERING;
    Transition.ENTERED = ENTERED;
    Transition.EXITING = EXITING;

    var _addClass = function addClass$1(node, classes) {
      return node && classes && classes.split(' ').forEach(function (c) {
        return addClass(node, c);
      });
    };

    var removeClass$1 = function removeClass$1(node, classes) {
      return node && classes && classes.split(' ').forEach(function (c) {
        return removeClass(node, c);
      });
    };
    /**
     * A transition component inspired by the excellent
     * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
     * use it if you're using CSS transitions or animations. It's built upon the
     * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
     * component, so it inherits all of its props.
     *
     * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
     * and `exit` states of the transition. The first class is applied and then a
     * second `*-active` class in order to activate the CSS transition. After the
     * transition, matching `*-done` class names are applied to persist the
     * transition state.
     *
     * ```jsx
     * function App() {
     *   const [inProp, setInProp] = useState(false);
     *   return (
     *     <div>
     *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
     *         <div>
     *           {"I'll receive my-node-* classes"}
     *         </div>
     *       </CSSTransition>
     *       <button type="button" onClick={() => setInProp(true)}>
     *         Click to Enter
     *       </button>
     *     </div>
     *   );
     * }
     * ```
     *
     * When the `in` prop is set to `true`, the child component will first receive
     * the class `example-enter`, then the `example-enter-active` will be added in
     * the next tick. `CSSTransition` [forces a
     * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
     * between before adding the `example-enter-active`. This is an important trick
     * because it allows us to transition between `example-enter` and
     * `example-enter-active` even though they were added immediately one after
     * another. Most notably, this is what makes it possible for us to animate
     * _appearance_.
     *
     * ```css
     * .my-node-enter {
     *   opacity: 0;
     * }
     * .my-node-enter-active {
     *   opacity: 1;
     *   transition: opacity 200ms;
     * }
     * .my-node-exit {
     *   opacity: 1;
     * }
     * .my-node-exit-active {
     *   opacity: 0;
     *   transition: opacity 200ms;
     * }
     * ```
     *
     * `*-active` classes represent which styles you want to animate **to**, so it's
     * important to add `transition` declaration only to them, otherwise transitions
     * might not behave as intended! This might not be obvious when the transitions
     * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
     * the example above (minus `transition`), but it becomes apparent in more
     * complex transitions.
     *
     * **Note**: If you're using the
     * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
     * prop, make sure to define styles for `.appear-*` classes as well.
     */


    var CSSTransition = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(CSSTransition, _React$Component);

      function CSSTransition() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
        _this.appliedClasses = {
          appear: {},
          enter: {},
          exit: {}
        };

        _this.onEnter = function (maybeNode, maybeAppearing) {
          var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
              node = _this$resolveArgument[0],
              appearing = _this$resolveArgument[1];

          _this.removeClasses(node, 'exit');

          _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

          if (_this.props.onEnter) {
            _this.props.onEnter(maybeNode, maybeAppearing);
          }
        };

        _this.onEntering = function (maybeNode, maybeAppearing) {
          var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
              node = _this$resolveArgument2[0],
              appearing = _this$resolveArgument2[1];

          var type = appearing ? 'appear' : 'enter';

          _this.addClass(node, type, 'active');

          if (_this.props.onEntering) {
            _this.props.onEntering(maybeNode, maybeAppearing);
          }
        };

        _this.onEntered = function (maybeNode, maybeAppearing) {
          var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
              node = _this$resolveArgument3[0],
              appearing = _this$resolveArgument3[1];

          var type = appearing ? 'appear' : 'enter';

          _this.removeClasses(node, type);

          _this.addClass(node, type, 'done');

          if (_this.props.onEntered) {
            _this.props.onEntered(maybeNode, maybeAppearing);
          }
        };

        _this.onExit = function (maybeNode) {
          var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
              node = _this$resolveArgument4[0];

          _this.removeClasses(node, 'appear');

          _this.removeClasses(node, 'enter');

          _this.addClass(node, 'exit', 'base');

          if (_this.props.onExit) {
            _this.props.onExit(maybeNode);
          }
        };

        _this.onExiting = function (maybeNode) {
          var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
              node = _this$resolveArgument5[0];

          _this.addClass(node, 'exit', 'active');

          if (_this.props.onExiting) {
            _this.props.onExiting(maybeNode);
          }
        };

        _this.onExited = function (maybeNode) {
          var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
              node = _this$resolveArgument6[0];

          _this.removeClasses(node, 'exit');

          _this.addClass(node, 'exit', 'done');

          if (_this.props.onExited) {
            _this.props.onExited(maybeNode);
          }
        };

        _this.resolveArguments = function (maybeNode, maybeAppearing) {
          return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
          : [maybeNode, maybeAppearing];
        };

        _this.getClassNames = function (type) {
          var classNames = _this.props.classNames;
          var isStringClassNames = typeof classNames === 'string';
          var prefix = isStringClassNames && classNames ? classNames + "-" : '';
          var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
          var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
          var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
          return {
            baseClassName: baseClassName,
            activeClassName: activeClassName,
            doneClassName: doneClassName
          };
        };

        return _this;
      }

      var _proto = CSSTransition.prototype;

      _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];

        var _this$getClassNames = this.getClassNames('enter'),
            doneClassName = _this$getClassNames.doneClassName;

        if (type === 'appear' && phase === 'done' && doneClassName) {
          className += " " + doneClassName;
        } // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.


        if (phase === 'active') {
          /* eslint-disable no-unused-expressions */
          node && node.scrollTop;
        }

        if (className) {
          this.appliedClasses[type][phase] = className;

          _addClass(node, className);
        }
      };

      _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type],
            baseClassName = _this$appliedClasses$.base,
            activeClassName = _this$appliedClasses$.active,
            doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};

        if (baseClassName) {
          removeClass$1(node, baseClassName);
        }

        if (activeClassName) {
          removeClass$1(node, activeClassName);
        }

        if (doneClassName) {
          removeClass$1(node, doneClassName);
        }
      };

      _proto.render = function render() {
        var _this$props = this.props,
            _ = _this$props.classNames,
            props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

        return /*#__PURE__*/React$2__default.createElement(Transition, _extends({}, props, {
          onEnter: this.onEnter,
          onEntered: this.onEntered,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }));
      };

      return CSSTransition;
    }(React$2__default.Component);

    CSSTransition.defaultProps = {
      classNames: ''
    };
    CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition.propTypes, {
      /**
       * The animation classNames applied to the component as it appears, enters,
       * exits or has finished the transition. A single name can be provided, which
       * will be suffixed for each stage, e.g. `classNames="fade"` applies:
       *
       * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
       * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
       * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
       *
       * A few details to note about how these classes are applied:
       *
       * 1. They are _joined_ with the ones that are already defined on the child
       *    component, so if you want to add some base styles, you can use
       *    `className` without worrying that it will be overridden.
       *
       * 2. If the transition component mounts with `in={false}`, no classes are
       *    applied yet. You might be expecting `*-exit-done`, but if you think
       *    about it, a component cannot finish exiting if it hasn't entered yet.
       *
       * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
       *    allows you to define different behavior for when appearing is done and
       *    when regular entering is done, using selectors like
       *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
       *    an epic entrance animation when element first appears in the DOM using
       *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
       *    simply use `fade-enter-done` for defining both cases.
       *
       * Each individual classNames can also be specified independently like:
       *
       * ```js
       * classNames={{
       *  appear: 'my-appear',
       *  appearActive: 'my-active-appear',
       *  appearDone: 'my-done-appear',
       *  enter: 'my-enter',
       *  enterActive: 'my-active-enter',
       *  enterDone: 'my-done-enter',
       *  exit: 'my-exit',
       *  exitActive: 'my-active-exit',
       *  exitDone: 'my-done-exit',
       * }}
       * ```
       *
       * If you want to set these classes using CSS Modules:
       *
       * ```js
       * import styles from './styles.css';
       * ```
       *
       * you might want to use camelCase in your CSS file, that way could simply
       * spread them instead of listing them one by one:
       *
       * ```js
       * classNames={{ ...styles }}
       * ```
       *
       * @type {string | {
       *  appear?: string,
       *  appearActive?: string,
       *  appearDone?: string,
       *  enter?: string,
       *  enterActive?: string,
       *  enterDone?: string,
       *  exit?: string,
       *  exitActive?: string,
       *  exitDone?: string,
       * }}
       */
      classNames: classNamesShape,

      /**
       * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
       * applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEnter: propTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'enter-active' or
       * 'appear-active' class is applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEntering: propTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'enter' or
       * 'appear' classes are **removed** and the `done` class is added to the DOM node.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed.
       *
       * @type Function(node: HtmlElement, isAppearing: bool)
       */
      onEntered: propTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'exit' class is
       * applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed
       *
       * @type Function(node: HtmlElement)
       */
      onExit: propTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed
       *
       * @type Function(node: HtmlElement)
       */
      onExiting: propTypes.func,

      /**
       * A `<Transition>` callback fired immediately after the 'exit' classes
       * are **removed** and the `exit-done` class is added to the DOM node.
       *
       * **Note**: when `nodeRef` prop is passed, `node` is not passed
       *
       * @type Function(node: HtmlElement)
       */
      onExited: propTypes.func
    }) : {};

    var classnames = createCommonjsModule(function (module) {
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */
    /* global define */

    (function () {

    	var hasOwn = {}.hasOwnProperty;

    	function classNames () {
    		var classes = [];

    		for (var i = 0; i < arguments.length; i++) {
    			var arg = arguments[i];
    			if (!arg) continue;

    			var argType = typeof arg;

    			if (argType === 'string' || argType === 'number') {
    				classes.push(arg);
    			} else if (Array.isArray(arg) && arg.length) {
    				var inner = classNames.apply(null, arg);
    				if (inner) {
    					classes.push(inner);
    				}
    			} else if (argType === 'object') {
    				for (var key in arg) {
    					if (hasOwn.call(arg, key) && arg[key]) {
    						classes.push(key);
    					}
    				}
    			}
    		}

    		return classes.join(' ');
    	}

    	if ( module.exports) {
    		classNames.default = classNames;
    		module.exports = classNames;
    	} else {
    		window.classNames = classNames;
    	}
    }());
    });

    var noScroll = createCommonjsModule(function (module) {
    (function(root) {
      var isOn = false;
      var scrollbarSize;
      var scrollTop;

      function getScrollbarSize() {
        if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

        var doc = document.documentElement;
        var dummyScroller = document.createElement('div');
        dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
        doc.appendChild(dummyScroller);
        scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
        doc.removeChild(dummyScroller);
        return scrollbarSize;
      }

      function hasScrollbar() {
        return document.documentElement.scrollHeight > window.innerHeight;
      }

      function on(options) {
        if (typeof document === 'undefined' || isOn) return;
        var doc = document.documentElement;
        scrollTop = window.pageYOffset;
        if (hasScrollbar()) {
          doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
        } else {
          doc.style.width = '100%';
        }
        doc.style.position = 'fixed';
        doc.style.top = -scrollTop + 'px';
        doc.style.overflow = 'hidden';
        isOn = true;
      }

      function off() {
        if (typeof document === 'undefined' || !isOn) return;
        var doc = document.documentElement;
        doc.style.width = '';
        doc.style.position = '';
        doc.style.top = '';
        doc.style.overflow = '';
        window.scroll(0, scrollTop);
        isOn = false;
      }

      function toggle() {
        if (isOn) {
          off();
          return;
        }
        on();
      }

      var noScroll = {
        on: on,
        off: off,
        toggle: toggle,
      };

      {
        module.exports = noScroll;
      }
    })();
    });

    var candidateSelectors = [
      'input',
      'select',
      'textarea',
      'a[href]',
      'button',
      '[tabindex]',
      'audio[controls]',
      'video[controls]',
      '[contenteditable]:not([contenteditable="false"])',
    ];
    var candidateSelector = candidateSelectors.join(',');

    var matches = typeof Element === 'undefined'
      ? function () {}
      : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

    function tabbable(el, options) {
      options = options || {};

      var elementDocument = el.ownerDocument || el;
      var regularTabbables = [];
      var orderedTabbables = [];

      var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
      var candidates = el.querySelectorAll(candidateSelector);

      if (options.includeContainer) {
        if (matches.call(el, candidateSelector)) {
          candidates = Array.prototype.slice.apply(candidates);
          candidates.unshift(el);
        }
      }

      var i, candidate, candidateTabindex;
      for (i = 0; i < candidates.length; i++) {
        candidate = candidates[i];

        if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

        candidateTabindex = getTabindex(candidate);
        if (candidateTabindex === 0) {
          regularTabbables.push(candidate);
        } else {
          orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            node: candidate,
          });
        }
      }

      var tabbableNodes = orderedTabbables
        .sort(sortOrderedTabbables)
        .map(function(a) { return a.node })
        .concat(regularTabbables);

      return tabbableNodes;
    }

    tabbable.isTabbable = isTabbable;
    tabbable.isFocusable = isFocusable;

    function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
      if (
        !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
        || isNonTabbableRadio(node)
        || getTabindex(node) < 0
      ) {
        return false;
      }
      return true;
    }

    function isTabbable(node, untouchabilityChecker) {
      if (!node) throw new Error('No node provided');
      if (matches.call(node, candidateSelector) === false) return false;
      return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
    }

    function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
      untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
      if (
        node.disabled
        || isHiddenInput(node)
        || untouchabilityChecker.isUntouchable(node)
      ) {
        return false;
      }
      return true;
    }

    var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
    function isFocusable(node, untouchabilityChecker) {
      if (!node) throw new Error('No node provided');
      if (matches.call(node, focusableCandidateSelector) === false) return false;
      return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
    }

    function getTabindex(node) {
      var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
      if (!isNaN(tabindexAttr)) return tabindexAttr;
      // Browsers do not return `tabIndex` correctly for contentEditable nodes;
      // so if they don't have a tabindex attribute specifically set, assume it's 0.
      if (isContentEditable(node)) return 0;
      return node.tabIndex;
    }

    function sortOrderedTabbables(a, b) {
      return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
    }

    // Array.prototype.find not available in IE.
    function find(list, predicate) {
      for (var i = 0, length = list.length; i < length; i++) {
        if (predicate(list[i])) return list[i];
      }
    }

    function isContentEditable(node) {
      return node.contentEditable === 'true';
    }

    function isInput(node) {
      return node.tagName === 'INPUT';
    }

    function isHiddenInput(node) {
      return isInput(node) && node.type === 'hidden';
    }

    function isRadio(node) {
      return isInput(node) && node.type === 'radio';
    }

    function isNonTabbableRadio(node) {
      return isRadio(node) && !isTabbableRadio(node);
    }

    function getCheckedRadio(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].checked) {
          return nodes[i];
        }
      }
    }

    function isTabbableRadio(node) {
      if (!node.name) return true;
      // This won't account for the edge case where you have radio groups with the same
      // in separate forms on the same page.
      var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
      var checked = getCheckedRadio(radioSet);
      return !checked || checked === node;
    }

    // An element is "untouchable" if *it or one of its ancestors* has
    // `visibility: hidden` or `display: none`.
    function UntouchabilityChecker(elementDocument) {
      this.doc = elementDocument;
      // Node cache must be refreshed on every check, in case
      // the content of the element has changed. The cache contains tuples
      // mapping nodes to their boolean result.
      this.cache = [];
    }

    // getComputedStyle accurately reflects `visibility: hidden` of ancestors
    // but not `display: none`, so we need to recursively check parents.
    UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
      if (node.nodeType !== Node.ELEMENT_NODE) return false;

        // Search for a cached result.
        var cached = find(this.cache, function(item) {
          return item === node;
        });
        if (cached) return cached[1];

        nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

        var result = false;

        if (nodeComputedStyle.display === 'none') {
          result = true;
        } else if (node.parentNode) {
          result = this.hasDisplayNone(node.parentNode);
        }

        this.cache.push([node, result]);

        return result;
    };

    UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
      if (node === this.doc.documentElement) return false;
      var computedStyle = this.doc.defaultView.getComputedStyle(node);
      if (this.hasDisplayNone(node, computedStyle)) return true;
      return computedStyle.visibility === 'hidden';
    };

    var tabbable_1 = tabbable;

    var immutable = extend;

    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

    function extend() {
        var target = {};

        for (var i = 0; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (hasOwnProperty$1.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target
    }

    var listeningFocusTrap = null;

    function focusTrap(element, userOptions) {
      var doc = document;
      var container =
        typeof element === 'string' ? doc.querySelector(element) : element;

      var config = immutable(
        {
          returnFocusOnDeactivate: true,
          escapeDeactivates: true
        },
        userOptions
      );

      var state = {
        firstTabbableNode: null,
        lastTabbableNode: null,
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false
      };

      var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
      };

      return trap;

      function activate(activateOptions) {
        if (state.active) return;

        updateTabbableNodes();

        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;

        var onActivate =
          activateOptions && activateOptions.onActivate
            ? activateOptions.onActivate
            : config.onActivate;
        if (onActivate) {
          onActivate();
        }

        addListeners();
        return trap;
      }

      function deactivate(deactivateOptions) {
        if (!state.active) return;

        removeListeners();
        state.active = false;
        state.paused = false;

        var onDeactivate =
          deactivateOptions && deactivateOptions.onDeactivate !== undefined
            ? deactivateOptions.onDeactivate
            : config.onDeactivate;
        if (onDeactivate) {
          onDeactivate();
        }

        var returnFocus =
          deactivateOptions && deactivateOptions.returnFocus !== undefined
            ? deactivateOptions.returnFocus
            : config.returnFocusOnDeactivate;
        if (returnFocus) {
          delay(function() {
            tryFocus(state.nodeFocusedBeforeActivation);
          });
        }

        return trap;
      }

      function pause() {
        if (state.paused || !state.active) return;
        state.paused = true;
        removeListeners();
      }

      function unpause() {
        if (!state.paused || !state.active) return;
        state.paused = false;
        addListeners();
      }

      function addListeners() {
        if (!state.active) return;

        // There can be only one listening focus trap at a time
        if (listeningFocusTrap) {
          listeningFocusTrap.pause();
        }
        listeningFocusTrap = trap;

        updateTabbableNodes();

        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        delay(function() {
          tryFocus(getInitialFocusNode());
        });
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, true);
        doc.addEventListener('touchstart', checkPointerDown, true);
        doc.addEventListener('click', checkClick, true);
        doc.addEventListener('keydown', checkKey, true);

        return trap;
      }

      function removeListeners() {
        if (!state.active || listeningFocusTrap !== trap) return;

        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkKey, true);

        listeningFocusTrap = null;

        return trap;
      }

      function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) {
          return null;
        }
        if (typeof optionValue === 'string') {
          node = doc.querySelector(optionValue);
          if (!node) {
            throw new Error('`' + optionName + '` refers to no known node');
          }
        }
        if (typeof optionValue === 'function') {
          node = optionValue();
          if (!node) {
            throw new Error('`' + optionName + '` did not return a node');
          }
        }
        return node;
      }

      function getInitialFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) {
          node = getNodeForOption('initialFocus');
        } else if (container.contains(doc.activeElement)) {
          node = doc.activeElement;
        } else {
          node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
        }

        if (!node) {
          throw new Error(
            "You can't have a focus-trap without at least one focusable element"
          );
        }

        return node;
      }

      // This needs to be done on mousedown and touchstart instead of click
      // so that it precedes the focus event.
      function checkPointerDown(e) {
        if (container.contains(e.target)) return;
        if (config.clickOutsideDeactivates) {
          deactivate({
            returnFocus: !tabbable_1.isFocusable(e.target)
          });
        } else {
          e.preventDefault();
        }
      }

      // In case focus escapes the trap for some strange reason, pull it back in.
      function checkFocusIn(e) {
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (container.contains(e.target) || e.target instanceof Document) {
          return;
        }
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }

      function checkKey(e) {
        if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
          e.preventDefault();
          deactivate();
          return;
        }
        if (isTabEvent(e)) {
          checkTab(e);
          return;
        }
      }

      // Hijack Tab events on the first and last focusable nodes of the trap,
      // in order to prevent focus from escaping. If it escapes for even a
      // moment it can end up scrolling the page and causing confusion so we
      // kind of need to capture the action at the keydown phase.
      function checkTab(e) {
        updateTabbableNodes();
        if (e.shiftKey && e.target === state.firstTabbableNode) {
          e.preventDefault();
          tryFocus(state.lastTabbableNode);
          return;
        }
        if (!e.shiftKey && e.target === state.lastTabbableNode) {
          e.preventDefault();
          tryFocus(state.firstTabbableNode);
          return;
        }
      }

      function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      function updateTabbableNodes() {
        var tabbableNodes = tabbable_1(container);
        state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
        state.lastTabbableNode =
          tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
      }

      function tryFocus(node) {
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
          tryFocus(getInitialFocusNode());
          return;
        }

        node.focus();
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) {
          node.select();
        }
      }
    }

    function isSelectableInput(node) {
      return (
        node.tagName &&
        node.tagName.toLowerCase() === 'input' &&
        typeof node.select === 'function'
      );
    }

    function isEscapeEvent(e) {
      return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    }

    function isTabEvent(e) {
      return e.key === 'Tab' || e.keyCode === 9;
    }

    function delay(fn) {
      return setTimeout(fn, 0);
    }

    var focusTrap_1 = focusTrap;

    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




    var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];

    var FocusTrap = function (_React$Component) {
      _inherits(FocusTrap, _React$Component);

      function FocusTrap(props) {
        _classCallCheck(this, FocusTrap);

        var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

        _this.setNode = function (el) {
          _this.node = el;
        };

        if (typeof document !== 'undefined') {
          _this.previouslyFocusedElement = document.activeElement;
        }
        return _this;
      }

      _createClass(FocusTrap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          // We need to hijack the returnFocusOnDeactivate option,
          // because React can move focus into the element before we arrived at
          // this lifecycle hook (e.g. with autoFocus inputs). So the component
          // captures the previouslyFocusedElement in componentWillMount,
          // then (optionally) returns focus to it in componentWillUnmount.
          var specifiedFocusTrapOptions = this.props.focusTrapOptions;
          var tailoredFocusTrapOptions = {
            returnFocusOnDeactivate: false
          };
          for (var optionName in specifiedFocusTrapOptions) {
            if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
            if (optionName === 'returnFocusOnDeactivate') continue;
            tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
          }

          this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
          if (this.props.active) {
            this.focusTrap.activate();
          }
          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (prevProps.active && !this.props.active) {
            var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

            var returnFocus = returnFocusOnDeactivate || false;
            var config = { returnFocus: returnFocus };
            this.focusTrap.deactivate(config);
          } else if (!prevProps.active && this.props.active) {
            this.focusTrap.activate();
          }

          if (prevProps.paused && !this.props.paused) {
            this.focusTrap.unpause();
          } else if (!prevProps.paused && this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.focusTrap.deactivate();
          if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
            this.previouslyFocusedElement.focus();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var elementProps = {
            ref: this.setNode
          };

          // This will get id, className, style, etc. -- arbitrary element props
          for (var prop in this.props) {
            if (!this.props.hasOwnProperty(prop)) continue;
            if (checkedProps.indexOf(prop) !== -1) continue;
            elementProps[prop] = this.props[prop];
          }

          return React$2__default.createElement(this.props.tag, elementProps, this.props.children);
        }
      }]);

      return FocusTrap;
    }(React$2__default.Component);

    FocusTrap.defaultProps = {
      active: true,
      tag: 'div',
      paused: false,
      focusTrapOptions: {},
      _createFocusTrap: focusTrap_1
    };

    var focusTrapReact = FocusTrap;

    function _classCallCheck$1(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass$1(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === 'function') {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    function _inherits$1(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _possibleConstructorReturn$1(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    var CloseIcon = function CloseIcon(_ref) {
      var classes = _ref.classes,
          classNames = _ref.classNames,
          styles = _ref.styles,
          closeIconSize = _ref.closeIconSize,
          closeIconSvgPath = _ref.closeIconSvgPath,
          onClickCloseIcon = _ref.onClickCloseIcon,
          id = _ref.id;
      return React$2__default.createElement("button", {
        className: classnames(classes.closeButton, classNames.closeButton),
        style: styles.closeButton,
        onClick: onClickCloseIcon,
        id: id
      }, React$2__default.createElement("svg", {
        className: classnames(classes.closeIcon, classNames.closeIcon),
        style: styles.closeIcon,
        xmlns: "http://www.w3.org/2000/svg",
        width: closeIconSize,
        height: closeIconSize,
        viewBox: "0 0 36 36"
      }, closeIconSvgPath));
    };

    CloseIcon.propTypes = {
      classNames: propTypes.object.isRequired,
      styles: propTypes.object.isRequired,
      classes: propTypes.object.isRequired,
      closeIconSize: propTypes.number.isRequired,
      closeIconSvgPath: propTypes.node.isRequired,
      onClickCloseIcon: propTypes.func.isRequired,
      id: propTypes.string
    };
    CloseIcon.defaultProps = {
      id: null
    };

    var _modals = [];
    /**
     * Handle the order of the modals.
     * Inspired by the material-ui implementation.
     */

    var modalManager = {
      /**
       * Return the modals array
       */
      modals: function modals() {
        return _modals;
      },

      /**
       * Register a new modal
       */
      add: function add(modal) {
        if (_modals.indexOf(modal) === -1) {
          _modals.push(modal);
        }
      },

      /**
       * Remove a modal
       */
      remove: function remove(modal) {
        var index = _modals.indexOf(modal);

        if (index !== -1) {
          _modals.splice(index, 1);
        }
      },

      /**
       * Check if the modal is the first one on the screen
       */
      isTopModal: function isTopModal(modal) {
        return !!_modals.length && _modals[_modals.length - 1] === modal;
      }
    };

    function styleInject(css, ref) {
      if ( ref === void 0 ) ref = {};
      var insertAt = ref.insertAt;

      if (!css || typeof document === 'undefined') { return; }

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';

      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css = ".styles_overlay__CLSq- {\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  padding: 1.2rem;\n}\n.styles_modal__gNwvD {\n  max-width: 800px;\n  position: relative;\n  padding: 1.2rem;\n  background: #ffffff;\n  background-clip: padding-box;\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);\n  margin: 0 auto;\n}\n.styles_modalCenter__L9F2w {\n  margin: auto;\n}\n.styles_closeButton__20ID4 {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  display: flex;\n}\n.styles_closeIcon__1QwbI {\n}\n.styles_transitionEnter__3j_-a {\n  opacity: 0.01;\n}\n.styles_transitionEnterActive___eQs7 {\n  opacity: 1;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.styles_transitionExit__1KmEf {\n  opacity: 1;\n}\n.styles_transitionExitActive__1nQXw {\n  opacity: 0.01;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n";
    var cssClasses = {"overlay":"styles_overlay__CLSq-","modal":"styles_modal__gNwvD","modalCenter":"styles_modalCenter__L9F2w","closeButton":"styles_closeButton__20ID4","closeIcon":"styles_closeIcon__1QwbI","transitionEnter":"styles_transitionEnter__3j_-a","transitionEnterActive":"styles_transitionEnterActive___eQs7","transitionExit":"styles_transitionExit__1KmEf","transitionExitActive":"styles_transitionExitActive__1nQXw"};
    styleInject(css,{"insertAt":"top"});

    var isBrowser = typeof window !== 'undefined';

    var Modal =
    /*#__PURE__*/
    function (_Component) {
      _inherits$1(Modal, _Component);

      _createClass$1(Modal, null, [{
        key: "blockScroll",
        value: function blockScroll() {
          noScroll.on();
        }
      }]);

      function Modal(props) {
        var _this;

        _classCallCheck$1(this, Modal);

        _this = _possibleConstructorReturn$1(this, _getPrototypeOf(Modal).call(this, props));

        _defineProperty(_assertThisInitialized(_this), "shouldClose", null);

        _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
          modalManager.add(_assertThisInitialized(_this));

          if (isBrowser && !_this.props.container) {
            document.body.appendChild(_this.container);
          }

          if (_this.props.blockScroll) {
            Modal.blockScroll();
          }

          document.addEventListener('keydown', _this.handleKeydown);
        });

        _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
          modalManager.remove(_assertThisInitialized(_this));

          if (_this.props.blockScroll) {
            Modal.unblockScroll();
          }

          if (isBrowser && !_this.props.container) {
            document.body.removeChild(_this.container);
          }

          document.removeEventListener('keydown', _this.handleKeydown);
        });

        _defineProperty(_assertThisInitialized(_this), "handleClickOverlay", function (event) {
          if (_this.shouldClose === null) {
            _this.shouldClose = true;
          }

          if (!_this.shouldClose) {
            _this.shouldClose = null;
            return;
          }

          if (_this.props.onOverlayClick) {
            _this.props.onOverlayClick(event);
          }

          if (_this.props.closeOnOverlayClick) {
            _this.props.onClose(event);
          }

          _this.shouldClose = null;
        });

        _defineProperty(_assertThisInitialized(_this), "handleClickCloseIcon", function (event) {
          _this.props.onClose(event);
        });

        _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
          // Only the last modal need to be escaped when pressing the esc key
          if (event.keyCode !== 27 || !modalManager.isTopModal(_assertThisInitialized(_this))) {
            return;
          }

          if (_this.props.onEscKeyDown) {
            _this.props.onEscKeyDown(event);
          }

          if (_this.props.closeOnEsc) {
            _this.props.onClose(event);
          }
        });

        _defineProperty(_assertThisInitialized(_this), "handleModalEvent", function () {
          _this.shouldClose = false;
        });

        _defineProperty(_assertThisInitialized(_this), "handleEntered", function () {
          if (_this.props.onEntered) {
            _this.props.onEntered();
          }
        });

        _defineProperty(_assertThisInitialized(_this), "handleExited", function () {
          if (_this.props.onExited) {
            _this.props.onExited();
          }

          _this.setState({
            showPortal: false
          });

          if (_this.props.blockScroll) {
            Modal.unblockScroll();
          }
        });

        _this.container = isBrowser && document.createElement('div');
        _this.state = {
          showPortal: _this.props.open
        };
        return _this;
      }

      _createClass$1(Modal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          // Block scroll when initial prop is open
          if (this.props.open) {
            this.handleOpen();
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
          if (prevState.showPortal && !this.state.showPortal) {
            this.handleClose();
          } else if (!prevProps.open && this.props.open) {
            this.handleOpen();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.state.showPortal) {
            this.handleClose();
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              open = _this$props.open,
              center = _this$props.center,
              classes = _this$props.classes,
              classNames = _this$props.classNames,
              styles = _this$props.styles,
              showCloseIcon = _this$props.showCloseIcon,
              closeIconSize = _this$props.closeIconSize,
              closeIconSvgPath = _this$props.closeIconSvgPath,
              animationDuration = _this$props.animationDuration,
              focusTrapped = _this$props.focusTrapped,
              focusTrapOptions = _this$props.focusTrapOptions,
              overlayId = _this$props.overlayId,
              modalId = _this$props.modalId,
              closeIconId = _this$props.closeIconId,
              role = _this$props.role,
              ariaLabelledby = _this$props.ariaLabelledby,
              ariaDescribedby = _this$props.ariaDescribedby;
          var showPortal = this.state.showPortal;

          if (!showPortal) {
            return null;
          }

          var content = React$2__default.createElement(React$2__default.Fragment, null, this.props.children, showCloseIcon && React$2__default.createElement(CloseIcon, {
            classes: classes,
            classNames: classNames,
            styles: styles,
            closeIconSize: closeIconSize,
            closeIconSvgPath: closeIconSvgPath,
            onClickCloseIcon: this.handleClickCloseIcon,
            id: closeIconId
          }));
          return ReactDOM.createPortal(React$2__default.createElement(CSSTransition, {
            "in": open,
            appear: true,
            classNames: {
              appear: classNames.transitionEnter || classes.transitionEnter,
              appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
              enter: classNames.transitionEnter || classes.transitionEnter,
              enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
              exit: classNames.transitionExit || classes.transitionExit,
              exitActive: classNames.transitionExitActive || classes.transitionExitActive
            },
            timeout: animationDuration,
            onEntered: this.handleEntered,
            onExited: this.handleExited
          }, React$2__default.createElement("div", {
            className: classnames(classes.overlay, classNames.overlay),
            onClick: this.handleClickOverlay,
            style: styles.overlay,
            id: overlayId
          }, React$2__default.createElement("div", {
            className: classnames(classes.modal, center && classes.modalCenter, classNames.modal),
            style: styles.modal,
            onMouseDown: this.handleModalEvent,
            onMouseUp: this.handleModalEvent,
            onClick: this.handleModalEvent,
            id: modalId,
            role: role,
            "aria-modal": "true",
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby
          }, focusTrapped ? React$2__default.createElement(focusTrapReact, {
            focusTrapOptions: _objectSpread({}, {
              clickOutsideDeactivates: true
            }, focusTrapOptions)
          }, content) : content))), this.props.container || this.container);
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (!prevState.showPortal && nextProps.open) {
            return {
              showPortal: true
            };
          }

          return null;
        }
      }]);

      return Modal;
    }(React$2.Component);

    _defineProperty(Modal, "unblockScroll", function () {
      // Restore the scroll only if there is no modal on the screen
      if (modalManager.modals().length === 0) {
        noScroll.off();
      }
    });

    Modal.propTypes = {
      /**
       * Is the modal closable when user press esc key.
       */
      closeOnEsc: propTypes.bool,

      /**
       * Is the modal closable when user click on overlay.
       */
      closeOnOverlayClick: propTypes.bool,

      /**
       * Callback fired when the Modal is open and the animation is finished.
       */
      onEntered: propTypes.func,

      /**
       * Callback fired when the Modal has exited and the animation is finished.
       */
      onExited: propTypes.func,

      /**
       * Callback fired when the Modal is requested to be closed by a click on the overlay or when user press esc key.
       */
      onClose: propTypes.func.isRequired,

      /**
       * Callback fired when the escape key is pressed.
       */
      onEscKeyDown: propTypes.func,

      /**
       * Callback fired when the overlay is clicked.
       */
      onOverlayClick: propTypes.func,

      /**
       * Control if the modal is open or not.
       */
      open: propTypes.bool.isRequired,

      /**
       * An object containing classNames to style the modal, can have properties 'overlay' (classname for overlay div), 'modal' (classname for modal content div), 'closeButton' (classname for the button that contain the close icon), 'closeIcon' (classname for close icon svg). You can customize the transition with 'transitionEnter', 'transitionEnterActive', 'transitionExit', 'transitionExitActive'
       */
      classNames: propTypes.object,

      /**
       * An object containing the styles objects to style the modal, can have properties 'overlay', 'modal', 'closeButton', 'closeIcon'.
       */
      styles: propTypes.object,

      /**
       * The content of the modal.
       */
      children: propTypes.node,

      /**
       * @internal
       */
      classes: propTypes.object,

      /**
       * Should the dialog be centered.
       */
      center: propTypes.bool,

      /**
       * Show the close icon.
       */
      showCloseIcon: propTypes.bool,

      /**
       * Close icon size.
       */
      closeIconSize: propTypes.number,

      /**
       * A valid svg path to show as icon.
       */
      closeIconSvgPath: propTypes.node,

      /**
       * Animation duration in milliseconds.
       */
      animationDuration: propTypes.number,

      /**
       * You can specify a container prop which should be of type `Element`. The portal will be rendered inside that element. The default behavior will create a div node and render it at the at the end of document.body.
       */
      container: propTypes.object,
      // eslint-disable-line

      /**
       * Whether to block scrolling when dialog is open
       */
      blockScroll: propTypes.bool,

      /**
       * When the modal is open, trap focus within it
       */
      focusTrapped: propTypes.bool,

      /**
       * Options to be passed to the focus trap, details available at https://github.com/davidtheclark/focus-trap#focustrap--createfocustrapelement-createoptions
       */
      focusTrapOptions: propTypes.object,

      /**
       * id attribute for overlay
       */
      overlayId: propTypes.string,

      /**
       * id attribute for modal
       */
      modalId: propTypes.string,

      /**
       * id attribute for close icon
       */
      closeIconId: propTypes.string,

      /**
       * ARIA role for modal
       */
      role: propTypes.string,

      /**
       * ARIA label for modal
       */
      ariaLabelledby: propTypes.string,

      /**
       * ARIA description for modal
       */
      ariaDescribedby: propTypes.string
    };
    Modal.defaultProps = {
      classes: cssClasses,
      closeOnEsc: true,
      closeOnOverlayClick: true,
      onEntered: undefined,
      onExited: undefined,
      onEscKeyDown: undefined,
      onOverlayClick: undefined,
      showCloseIcon: true,
      closeIconSize: 28,
      closeIconSvgPath: React$2__default.createElement("path", {
        d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
      }),
      classNames: {},
      styles: {},
      children: null,
      center: false,
      animationDuration: 500,
      blockScroll: true,
      focusTrapped: true,
      focusTrapOptions: {},
      overlayId: undefined,
      modalId: undefined,
      closeIconId: undefined,
      role: 'dialog',
      ariaLabelledby: undefined,
      ariaDescribedby: undefined
    };

    function Modal$1(_a) {
        var children = _a.children, className = _a.className, onClose = _a.onClose, isOpen = _a.isOpen, _b = _a.modalContentClassName, modalContentClassName = _b === void 0 ? 'modal' : _b, _c = _a.overlayId, overlayId = _c === void 0 ? '' : _c, _d = _a.modalId, modalId = _d === void 0 ? '' : _d, _e = _a.closeOnEsc, closeOnEsc = _e === void 0 ? false : _e, openCallback = _a.openCallback, closeCallback = _a.closeCallback, onOverlayClick = _a.onOverlayClick, _f = _a.showCloseIcon, showCloseIcon = _f === void 0 ? false : _f;
        return (React$2__default.createElement(Modal, { onOverlayClick: onOverlayClick, onEntered: openCallback, onExited: closeCallback, closeOnEsc: closeOnEsc, overlayId: overlayId, modalId: modalId, open: isOpen, onClose: onClose, center: true, showCloseIcon: showCloseIcon, focusTrapped: false, classNames: {
                overlay: className,
                modal: modalContentClassName,
                closeButton: 'closeButton',
            } }, children({
            onClose: onClose,
        })));
    }
    var StyledModal = styled__default(Modal$1)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0;\n\n  .modal {\n    padding: 0;\n    box-shadow: none;\n\n    ", "\n\n    ", "\n\n    ", "\n  }\n"], ["\n  padding: 0;\n\n  .modal {\n    padding: 0;\n    box-shadow: none;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  }\n"])), function (_a) {
        var isFullScreen = _a.isFullScreen;
        return isFullScreen
            ? styled.css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n            width: 100%;\n            max-width: 100%;\n            min-height: 100vh;\n          "], ["\n            width: 100%;\n            max-width: 100%;\n            min-height: 100vh;\n          "]))) : null;
    }, function (_a) {
        var isFullWidth = _a.isFullWidth;
        return isFullWidth
            ? styled.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            width: 100%;\n            max-width: 100%;\n          "], ["\n            width: 100%;\n            max-width: 100%;\n          "]))) : null;
    }, function (_a) {
        var _b = _a.positionX, positionX = _b === void 0 ? 'center' : _b, _c = _a.positionY, positionY = _c === void 0 ? 'center' : _c;
        function getMarginValue(condition) {
            return condition ? 0 : 'auto';
        }
        var top = getMarginValue(positionY === 'top');
        var right = getMarginValue(positionX === 'right');
        var bottom = getMarginValue(positionY === 'bottom');
        var left = getMarginValue(positionX === 'left');
        return styled.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        margin: ", " ", " ", " ", ";\n      "], ["\n        margin: ", " ", " ", " ", ";\n      "])), top, right, bottom, left);
    });
    var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4;

    function FlashMessage(_a) {
        var className = _a.className, isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children;
        return isOpen ? (React$2__default.createElement("div", { className: className, onAnimationEnd: function () {
                onClose();
            } }, children)) : null;
    }
    var fadeOut = styled.keyframes(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));
    var StyledFlashMessage = styled__default(FlashMessage)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1111;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0;\n  margin-right: auto;\n  margin-left: auto;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #fff;\n  background-color: rgb(0, 11, 66, 0.7);\n  animation: ", " 0.5s ease;\n  animation-delay: 1s;\n\n  @media (min-width: 768px) {\n    top: 60px;\n    width: 195px;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1111;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0;\n  margin-right: auto;\n  margin-left: auto;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #fff;\n  background-color: rgb(0, 11, 66, 0.7);\n  animation: ", " 0.5s ease;\n  animation-delay: 1s;\n\n  @media (min-width: 768px) {\n    top: 60px;\n    width: 195px;\n  }\n"])), fadeOut);
    var templateObject_1$2, templateObject_2$1;

    function getCommonFieldProps(props) {
        return {
            id: props.name,
            name: props.name,
            placeholder: props.placeholder,
            disabled: props.disabled,
            autoComplete: 'randomStringForDisableAutocomplete',
            className: 'field',
        };
    }
    function FieldWrapper(_a) {
        var className = _a.className, name = _a.name, label = _a.label, description = _a.description, isBig = _a.isBig, error = _a.error, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'afterInput' : _b, children = _a.children, _c = _a.styleType;
        return (React$2__default.createElement("div", { className: className },
            label && labelPosition === 'beforeInput' ? (React$2__default.createElement("label", { htmlFor: name, className: "label" + (error ? ' label-error' : '') }, label)) : null,
            children,
            label && labelPosition === 'afterInput' ? (React$2__default.createElement("label", { htmlFor: name, className: "label" + (error ? ' label-error' : '') }, label)) : null,
            Boolean(description) ? (React$2__default.createElement("p", { className: "description" }, description)) : null,
            Boolean(error) && error !== 'empty' ? (React$2__default.createElement("p", { className: "error" }, error)) : null));
    }
    var StyledFieldWrapper = styled__default(FieldWrapper)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  position: relative;\n\n  ", "\n"], ["\n  position: relative;\n\n  ",
        "\n"])), function (_a) {
        var styleType = _a.styleType, isBig = _a.isBig;
        return (styleType === 'lightGrey' ? getLightGreyStyles(isBig) : null);
    });
    function getLightGreyStyles(isBig) {
        return styled.css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    .label {\n      position: absolute;\n      top: -8px;\n      left: ", ";\n      padding: 0 4px;\n      font-family: inherit;\n      font-size: 12px;\n      font-weight: bold;\n      line-height: 18px;\n      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgOGgxOHYxMEgweiIvPjwvc3ZnPg==);\n      background-repeat: repeat;\n    }\n\n    .input {\n      position: relative;\n      width: 100%;\n      height: ", ";\n      padding: 0 ", ";\n      font-family: inherit;\n      font-size: 15px;\n      line-height: 20px;\n      background-color: #fff;\n      border: 1px solid #dcdcdc;\n\n      &::placeholder {\n        font-size: 15px;\n        color: #9b9b9b;\n      }\n\n      &:focus {\n        padding: 0 ", ";\n        border: 2px solid #000;\n\n        ~ .label {\n          color: #000 !important;\n        }\n      }\n\n      &:disabled {\n        ", "\n      }\n\n      ", "\n    }\n\n    .description {\n      font-size: 13px;\n      line-height: 18px;\n      color: #b3b3b3;\n    }\n\n    .input-error {\n      border-color: #f30;\n    }\n\n    .label-error {\n      color: #f30;\n    }\n\n    .error {\n      position: absolute;\n      font-size: 13px;\n      line-height: 18px;\n      color: #f30;\n    }\n  "], ["\n    .label {\n      position: absolute;\n      top: -8px;\n      left: ", ";\n      padding: 0 4px;\n      font-family: inherit;\n      font-size: 12px;\n      font-weight: bold;\n      line-height: 18px;\n      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgOGgxOHYxMEgweiIvPjwvc3ZnPg==);\n      background-repeat: repeat;\n    }\n\n    .input {\n      position: relative;\n      width: 100%;\n      height: ", ";\n      padding: 0 ", ";\n      font-family: inherit;\n      font-size: 15px;\n      line-height: 20px;\n      background-color: #fff;\n      border: 1px solid #dcdcdc;\n\n      &::placeholder {\n        font-size: 15px;\n        color: #9b9b9b;\n      }\n\n      &:focus {\n        padding: 0 ", ";\n        border: 2px solid #000;\n\n        ~ .label {\n          color: #000 !important;\n        }\n      }\n\n      &:disabled {\n        ", "\n      }\n\n      ",
            "\n    }\n\n    .description {\n      font-size: 13px;\n      line-height: 18px;\n      color: #b3b3b3;\n    }\n\n    .input-error {\n      border-color: #f30;\n    }\n\n    .label-error {\n      color: #f30;\n    }\n\n    .error {\n      position: absolute;\n      font-size: 13px;\n      line-height: 18px;\n      color: #f30;\n    }\n  "])), isBig ? '14px' : '11px', isBig ? '60px' : '48px', isBig ? '18px' : '15px', isBig ? '17px' : '14px', getDisabledStyles(), function (_a) {
            var disabled = _a.disabled;
            return disabled && getDisabledStyles();
        });
    }
    function getDisabledStyles() {
        return styled.css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    background-color: rgba(213, 219, 237, 0.3);\n    box-shadow: none;\n    color: rgba(0, 0, 0, 0.3);\n\n    ::placeholder,\n    .placeholder {\n      color: rgba(155, 155, 155, 0.3);\n    }\n\n    ~ .label {\n      color: rgba(0, 0, 0, 0.3) !important;\n      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2YyZjRmYSIgZD0iTTAgOGgxOHYxMEgweiIvPjwvc3ZnPg0K);\n    }\n  "], ["\n    background-color: rgba(213, 219, 237, 0.3);\n    box-shadow: none;\n    color: rgba(0, 0, 0, 0.3);\n\n    ::placeholder,\n    .placeholder {\n      color: rgba(155, 155, 155, 0.3);\n    }\n\n    ~ .label {\n      color: rgba(0, 0, 0, 0.3) !important;\n      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2YyZjRmYSIgZD0iTTAgOGgxOHYxMEgweiIvPjwvc3ZnPg0K);\n    }\n  "])));
    }
    var templateObject_1$3, templateObject_2$2, templateObject_3$1;

    function Input(_a) {
        var className = _a.className, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f, _g = _a.description, description = _g === void 0 ? '' : _g, _h = _a.error, error = _h === void 0 ? '' : _h, labelPosition = _a.labelPosition, isBig = _a.isBig, onChange = _a.onChange, styleType = _a.styleType, disableDecimals = _a.disableDecimals, _j = _a.allowedСharacters, allowedСharacters = _j === void 0 ? / / : _j, rest = __rest(_a, ["className", "name", "placeholder", "label", "disabled", "type", "description", "error", "labelPosition", "isBig", "onChange", "styleType", "disableDecimals", "allowed\u0421haracters"]);
        return (React$2__default.createElement(StyledFieldWrapper, { className: className, name: name, label: label, isBig: isBig, labelPosition: labelPosition, description: description, error: error, styleType: styleType },
            React$2__default.createElement("input", __assign({ onChange: function (e) {
                    var value = e.currentTarget.value;
                    if (type === 'number' &&
                        (isNaN(+value.replace(allowedСharacters, '')) ||
                            (disableDecimals && value.includes('.'))))
                        return;
                    onChange && onChange(e);
                } }, getCommonFieldProps({
                name: name,
                placeholder: placeholder,
                disabled: disabled,
            }), rest, { className: "input" + (error ? ' input-error' : '') }))));
    }

    var autosize = createCommonjsModule(function (module, exports) {
    /*!
    	autosize 4.0.2
    	license: MIT
    	http://www.jacklmoore.com/autosize
    */
    (function (global, factory) {
    	{
    		factory(module, exports);
    	}
    })(commonjsGlobal, function (module, exports) {

    	var map = typeof Map === "function" ? new Map() : function () {
    		var keys = [];
    		var values = [];

    		return {
    			has: function has(key) {
    				return keys.indexOf(key) > -1;
    			},
    			get: function get(key) {
    				return values[keys.indexOf(key)];
    			},
    			set: function set(key, value) {
    				if (keys.indexOf(key) === -1) {
    					keys.push(key);
    					values.push(value);
    				}
    			},
    			delete: function _delete(key) {
    				var index = keys.indexOf(key);
    				if (index > -1) {
    					keys.splice(index, 1);
    					values.splice(index, 1);
    				}
    			}
    		};
    	}();

    	var createEvent = function createEvent(name) {
    		return new Event(name, { bubbles: true });
    	};
    	try {
    		new Event('test');
    	} catch (e) {
    		// IE does not support `new Event()`
    		createEvent = function createEvent(name) {
    			var evt = document.createEvent('Event');
    			evt.initEvent(name, true, false);
    			return evt;
    		};
    	}

    	function assign(ta) {
    		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

    		var heightOffset = null;
    		var clientWidth = null;
    		var cachedHeight = null;

    		function init() {
    			var style = window.getComputedStyle(ta, null);

    			if (style.resize === 'vertical') {
    				ta.style.resize = 'none';
    			} else if (style.resize === 'both') {
    				ta.style.resize = 'horizontal';
    			}

    			if (style.boxSizing === 'content-box') {
    				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
    			} else {
    				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    			}
    			// Fix when a textarea is not on document body and heightOffset is Not a Number
    			if (isNaN(heightOffset)) {
    				heightOffset = 0;
    			}

    			update();
    		}

    		function changeOverflow(value) {
    			{
    				// Chrome/Safari-specific fix:
    				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
    				// made available by removing the scrollbar. The following forces the necessary text reflow.
    				var width = ta.style.width;
    				ta.style.width = '0px';
    				// Force reflow:
    				/* jshint ignore:start */
    				ta.offsetWidth;
    				/* jshint ignore:end */
    				ta.style.width = width;
    			}

    			ta.style.overflowY = value;
    		}

    		function getParentOverflows(el) {
    			var arr = [];

    			while (el && el.parentNode && el.parentNode instanceof Element) {
    				if (el.parentNode.scrollTop) {
    					arr.push({
    						node: el.parentNode,
    						scrollTop: el.parentNode.scrollTop
    					});
    				}
    				el = el.parentNode;
    			}

    			return arr;
    		}

    		function resize() {
    			if (ta.scrollHeight === 0) {
    				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
    				return;
    			}

    			var overflows = getParentOverflows(ta);
    			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

    			ta.style.height = '';
    			ta.style.height = ta.scrollHeight + heightOffset + 'px';

    			// used to check if an update is actually necessary on window.resize
    			clientWidth = ta.clientWidth;

    			// prevents scroll-position jumping
    			overflows.forEach(function (el) {
    				el.node.scrollTop = el.scrollTop;
    			});

    			if (docTop) {
    				document.documentElement.scrollTop = docTop;
    			}
    		}

    		function update() {
    			resize();

    			var styleHeight = Math.round(parseFloat(ta.style.height));
    			var computed = window.getComputedStyle(ta, null);

    			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
    			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

    			// The actual height not matching the style height (set via the resize method) indicates that 
    			// the max-height has been exceeded, in which case the overflow should be allowed.
    			if (actualHeight < styleHeight) {
    				if (computed.overflowY === 'hidden') {
    					changeOverflow('scroll');
    					resize();
    					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
    				}
    			} else {
    				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
    				if (computed.overflowY !== 'hidden') {
    					changeOverflow('hidden');
    					resize();
    					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
    				}
    			}

    			if (cachedHeight !== actualHeight) {
    				cachedHeight = actualHeight;
    				var evt = createEvent('autosize:resized');
    				try {
    					ta.dispatchEvent(evt);
    				} catch (err) {
    					// Firefox will throw an error on dispatchEvent for a detached element
    					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
    				}
    			}
    		}

    		var pageResize = function pageResize() {
    			if (ta.clientWidth !== clientWidth) {
    				update();
    			}
    		};

    		var destroy = function (style) {
    			window.removeEventListener('resize', pageResize, false);
    			ta.removeEventListener('input', update, false);
    			ta.removeEventListener('keyup', update, false);
    			ta.removeEventListener('autosize:destroy', destroy, false);
    			ta.removeEventListener('autosize:update', update, false);

    			Object.keys(style).forEach(function (key) {
    				ta.style[key] = style[key];
    			});

    			map.delete(ta);
    		}.bind(ta, {
    			height: ta.style.height,
    			resize: ta.style.resize,
    			overflowY: ta.style.overflowY,
    			overflowX: ta.style.overflowX,
    			wordWrap: ta.style.wordWrap
    		});

    		ta.addEventListener('autosize:destroy', destroy, false);

    		// IE9 does not fire onpropertychange or oninput for deletions,
    		// so binding to onkeyup to catch most of those events.
    		// There is no way that I know of to detect something like 'cut' in IE9.
    		if ('onpropertychange' in ta && 'oninput' in ta) {
    			ta.addEventListener('keyup', update, false);
    		}

    		window.addEventListener('resize', pageResize, false);
    		ta.addEventListener('input', update, false);
    		ta.addEventListener('autosize:update', update, false);
    		ta.style.overflowX = 'hidden';
    		ta.style.wordWrap = 'break-word';

    		map.set(ta, {
    			destroy: destroy,
    			update: update
    		});

    		init();
    	}

    	function destroy(ta) {
    		var methods = map.get(ta);
    		if (methods) {
    			methods.destroy();
    		}
    	}

    	function update(ta) {
    		var methods = map.get(ta);
    		if (methods) {
    			methods.update();
    		}
    	}

    	var autosize = null;

    	// Do nothing in Node.js environment and IE8 (or lower)
    	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
    		autosize = function autosize(el) {
    			return el;
    		};
    		autosize.destroy = function (el) {
    			return el;
    		};
    		autosize.update = function (el) {
    			return el;
    		};
    	} else {
    		autosize = function autosize(el, options) {
    			if (el) {
    				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
    					return assign(x);
    				});
    			}
    			return el;
    		};
    		autosize.destroy = function (el) {
    			if (el) {
    				Array.prototype.forEach.call(el.length ? el : [el], destroy);
    			}
    			return el;
    		};
    		autosize.update = function (el) {
    			if (el) {
    				Array.prototype.forEach.call(el.length ? el : [el], update);
    			}
    			return el;
    		};
    	}

    	exports.default = autosize;
    	module.exports = exports['default'];
    });
    });

    // This code has been refactored for 140 bytes
    // You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
    var computedStyle = function (el, prop, getComputedStyle) {
      getComputedStyle = window.getComputedStyle;

      // In one fell swoop
      return (
        // If we have getComputedStyle
        getComputedStyle ?
          // Query it
          // TODO: From CSS-Query notes, we might need (node, null) for FF
          getComputedStyle(el) :

        // Otherwise, we are in IE and use currentStyle
          el.currentStyle
      )[
        // Switch to camelCase for CSSOM
        // DEV: Grabbed from jQuery
        // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
        // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
        prop.replace(/-(\w)/gi, function (word, letter) {
          return letter.toUpperCase();
        })
      ];
    };

    var computedStyle_commonjs = computedStyle;

    // Load in dependencies


    /**
     * Calculate the `line-height` of a given node
     * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
     * @returns {Number} `line-height` of the element in pixels
     */
    function lineHeight(node) {
      // Grab the line-height via style
      var lnHeightStr = computedStyle_commonjs(node, 'line-height');
      var lnHeight = parseFloat(lnHeightStr, 10);

      // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
      if (lnHeightStr === lnHeight + '') {
        // Save the old lineHeight style and update the em unit to the element
        var _lnHeightStyle = node.style.lineHeight;
        node.style.lineHeight = lnHeightStr + 'em';

        // Calculate the em based height
        lnHeightStr = computedStyle_commonjs(node, 'line-height');
        lnHeight = parseFloat(lnHeightStr, 10);

        // Revert the lineHeight style
        if (_lnHeightStyle) {
          node.style.lineHeight = _lnHeightStyle;
        } else {
          delete node.style.lineHeight;
        }
      }

      // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
      // DEV: `em` units are converted to `pt` in IE6
      // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
      if (lnHeightStr.indexOf('pt') !== -1) {
        lnHeight *= 4;
        lnHeight /= 3;
      // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
      } else if (lnHeightStr.indexOf('mm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 25.4;
      // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
      } else if (lnHeightStr.indexOf('cm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 2.54;
      // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
      } else if (lnHeightStr.indexOf('in') !== -1) {
        lnHeight *= 96;
      // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
      } else if (lnHeightStr.indexOf('pc') !== -1) {
        lnHeight *= 16;
      }

      // Continue our computation
      lnHeight = Math.round(lnHeight);

      // If the line-height is "normal", calculate by font-size
      if (lnHeightStr === 'normal') {
        // Create a temporary node
        var nodeName = node.nodeName;
        var _node = document.createElement(nodeName);
        _node.innerHTML = '&nbsp;';

        // If we have a text area, reset it to only 1 row
        // https://github.com/twolfson/line-height/issues/4
        if (nodeName.toUpperCase() === 'TEXTAREA') {
          _node.setAttribute('rows', '1');
        }

        // Set the font-size of the element
        var fontSizeStr = computedStyle_commonjs(node, 'font-size');
        _node.style.fontSize = fontSizeStr;

        // Remove default padding/border which can affect offset height
        // https://github.com/twolfson/line-height/issues/4
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
        _node.style.padding = '0px';
        _node.style.border = '0px';

        // Append it to the body
        var body = document.body;
        body.appendChild(_node);

        // Assume the line height of the element is the height
        var height = _node.offsetHeight;
        lnHeight = height;

        // Remove our child from the DOM
        body.removeChild(_node);
      }

      // Return the calculated height
      return lnHeight;
    }

    // Export lineHeight
    var lineHeight_1 = lineHeight;

    var TextareaAutosize = createCommonjsModule(function (module, exports) {
    var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign = (commonjsGlobal && commonjsGlobal.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    exports.__esModule = true;




    var getLineHeight = lineHeight_1;
    var RESIZED = "autosize:resized";
    /**
     * A light replacement for built-in textarea component
     * which automaticaly adjusts its height to match the content
     */
    var TextareaAutosizeClass = /** @class */ (function (_super) {
        __extends(TextareaAutosizeClass, _super);
        function TextareaAutosizeClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                lineHeight: null
            };
            _this.textarea = null;
            _this.onResize = function (e) {
                if (_this.props.onResize) {
                    _this.props.onResize(e);
                }
            };
            _this.updateLineHeight = function () {
                if (_this.textarea) {
                    _this.setState({
                        lineHeight: getLineHeight(_this.textarea)
                    });
                }
            };
            _this.onChange = function (e) {
                var onChange = _this.props.onChange;
                _this.currentValue = e.currentTarget.value;
                onChange && onChange(e);
            };
            return _this;
        }
        TextareaAutosizeClass.prototype.componentDidMount = function () {
            var _this = this;
            var _a = this.props, maxRows = _a.maxRows, async = _a.async;
            if (typeof maxRows === "number") {
                this.updateLineHeight();
            }
            if (typeof maxRows === "number" || async) {
                /*
                  the defer is needed to:
                    - force "autosize" to activate the scrollbar when this.props.maxRows is passed
                    - support StyledComponents (see #71)
                */
                setTimeout(function () { return _this.textarea && autosize(_this.textarea); });
            }
            else {
                this.textarea && autosize(this.textarea);
            }
            if (this.textarea) {
                this.textarea.addEventListener(RESIZED, this.onResize);
            }
        };
        TextareaAutosizeClass.prototype.componentWillUnmount = function () {
            if (this.textarea) {
                this.textarea.removeEventListener(RESIZED, this.onResize);
                autosize.destroy(this.textarea);
            }
        };
        TextareaAutosizeClass.prototype.render = function () {
            var _this = this;
            var _a = this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, children = _b.children, props = __rest(_b, ["onResize", "maxRows", "onChange", "style", "innerRef", "children"]), lineHeight = _a.state.lineHeight;
            var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
            return (React$2__default.createElement("textarea", __assign({}, props, { onChange: this.onChange, style: maxHeight ? __assign({}, style, { maxHeight: maxHeight }) : style, ref: function (element) {
                    _this.textarea = element;
                    if (typeof _this.props.innerRef === 'function') {
                        _this.props.innerRef(element);
                    }
                    else if (_this.props.innerRef) {
                        _this.props.innerRef.current = element;
                    }
                } }), children));
        };
        TextareaAutosizeClass.prototype.componentDidUpdate = function () {
            this.textarea && autosize.update(this.textarea);
        };
        TextareaAutosizeClass.defaultProps = {
            rows: 1,
            async: false
        };
        TextareaAutosizeClass.propTypes = {
            rows: propTypes.number,
            maxRows: propTypes.number,
            onResize: propTypes.func,
            innerRef: propTypes.any,
            async: propTypes.bool
        };
        return TextareaAutosizeClass;
    }(React$2__default.Component));
    exports.TextareaAutosize = React$2__default.forwardRef(function (props, ref) {
        return React$2__default.createElement(TextareaAutosizeClass, __assign({}, props, { innerRef: ref }));
    });
    });

    unwrapExports(TextareaAutosize);
    var TextareaAutosize_1 = TextareaAutosize.TextareaAutosize;

    var lib = createCommonjsModule(function (module, exports) {
    exports.__esModule = true;

    exports["default"] = TextareaAutosize.TextareaAutosize;
    });

    var TextareaAutosize$1 = unwrapExports(lib);

    function Textarea(_a) {
        var className = _a.className, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.type, _g = _a.description, description = _g === void 0 ? '' : _g, _h = _a.error, error = _h === void 0 ? '' : _h, labelPosition = _a.labelPosition, rest = __rest(_a, ["className", "name", "placeholder", "label", "disabled", "type", "description", "error", "labelPosition"]);
        return (React$2__default.createElement(StyledFieldWrapper, { className: className, name: name, label: label, labelPosition: labelPosition, description: description, error: error },
            React$2__default.createElement(TextareaAutosize$1, __assign({}, getCommonFieldProps({
                name: name,
                placeholder: placeholder,
                disabled: disabled,
            }), rest))));
    }
    var StyledTextarea = styled__default(Textarea)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject([""], [""])));
    var templateObject_1$4;

    var reactTextMask = createCommonjsModule(function (module, exports) {
    !function(e,t){module.exports=t(React$2__default);}(commonjsGlobal,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e;}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0, y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t);}},{key:"componentDidMount",value:function(){this.initTextMask();}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0, m.isNil)(n)&&!(0, m.isNil)(e.pipe)||!(0, m.isNil)(n)&&(0, m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask();}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e);}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e);}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}};},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return "string"==typeof e||e instanceof String}function a(e){return "number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return "undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return {maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0, i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0, i.processCaretTraps)(t).maskWithoutCaretTraps;}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0, i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g);}for(var M=e.split(s).map(function(e,t){return {char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1);}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--;}else V+=F;continue e}N=!0;}b===!1&&(V+=v.substr(A,C));break}V+=B;}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s;}return {conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s="";},function(e,t){function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else {var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o="";},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return {state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0, d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0, d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0, d.convertMaskToPlaceholder)(x,g);}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0, p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0, d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0, f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D));}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y));}function a(e){if((0, d.isString)(e))return e;if((0, d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout;},function(e,t){function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n;},function(e,t,r){function n(e,t,r,n,i,a,u,s){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation";}throw l.framesToPop=1,l}}e.exports=n;},function(e,t,r){var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r};},function(e,t,r){e.exports=r(8)();},function(e,t){var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r;},function(t,r){t.exports=e;}])});
    });

    var ReactTextMask = unwrapExports(reactTextMask);
    var reactTextMask_1 = reactTextMask.reactTextMask;

    var createAutoCorrectedDatePipe = createCommonjsModule(function (module, exports) {
    !function(e,t){module.exports=t();}(commonjsGlobal,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){e.exports=r(1);},function(e,t){function r(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"mm dd yyyy",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minYear,i=void 0===r?1:r,d=t.maxYear,u=void 0===d?9999:d,s=e.split(/[^dmyHMS]+/).sort(function(e,t){return o.indexOf(e)-o.indexOf(t)});return function(t){var r=[],o={dd:31,mm:12,yy:99,yyyy:u,HH:23,MM:59,SS:59},d={dd:1,mm:1,yy:0,yyyy:i,HH:0,MM:0,SS:0},a=t.split("");s.forEach(function(t){var n=e.indexOf(t),i=parseInt(o[t].toString().substr(0,1),10);parseInt(a[n],10)>i&&(a[n+1]=a[n],a[n]=0,r.push(n));});var y=0,f=s.some(function(r){var s=e.indexOf(r),a=r.length,f=t.substr(s,a).replace(/\D/g,""),p=parseInt(f,10);"mm"===r&&(y=p||0);var c="dd"===r?n[y]:o[r];if("yyyy"===r&&(1!==i||9999!==u)){var l=parseInt(o[r].toString().substring(0,f.length),10),m=parseInt(d[r].toString().substring(0,f.length),10);return p<m||p>l}return p>c||f.length===a&&p<d[r]});return !f&&{value:a.join(""),indexesOfPipedChars:r}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[31,31,29,31,30,31,30,31,31,30,31,30,31],o=["yyyy","yy","mm","dd","HH","MM","SS"];}])});
    });

    var createAutoCorrectedDatePipe$1 = unwrapExports(createAutoCorrectedDatePipe);
    var createAutoCorrectedDatePipe_1 = createAutoCorrectedDatePipe.createAutoCorrectedDatePipe;

    function DateInput(_a) {
        var className = _a.className, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.type, _g = _a.description, description = _g === void 0 ? '' : _g, _h = _a.error, error = _h === void 0 ? '' : _h, _j = _a.labelPosition, labelPosition = _j === void 0 ? 'beforeInput' : _j, _k = _a.minYear, minYear = _k === void 0 ? 1900 : _k, _l = _a.maxYear, maxYear = _l === void 0 ? new Date().getFullYear() : _l, rest = __rest(_a, ["className", "name", "placeholder", "label", "disabled", "type", "description", "error", "labelPosition", "minYear", "maxYear"]);
        return (React$2__default.createElement(StyledFieldWrapper, { className: className, name: name, label: label, labelPosition: labelPosition, description: description, error: error },
            React$2__default.createElement(ReactTextMask, __assign({ mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/], pipe: createAutoCorrectedDatePipe$1('dd.mm.yyyy', {
                    minYear: minYear,
                    maxYear: maxYear,
                }) }, getCommonFieldProps({
                name: name,
                placeholder: placeholder,
                disabled: disabled,
            }), rest))));
    }
    var StyledDateInput = styled__default(DateInput)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject([""], [""])));
    var templateObject_1$5;

    function useDebouncedCallback(callback, delay, options) {
        if (options === void 0) { options = {}; }
        var maxWait = options.maxWait;
        var maxWaitHandler = React$2.useRef(null);
        var maxWaitArgs = React$2.useRef([]);
        var leading = options.leading;
        var trailing = options.trailing === undefined ? true : options.trailing;
        var leadingCall = React$2.useRef(false);
        var functionTimeoutHandler = React$2.useRef(null);
        var isComponentUnmounted = React$2.useRef(false);
        var debouncedFunction = React$2.useRef(callback);
        debouncedFunction.current = callback;
        var cancelDebouncedCallback = React$2.useCallback(function () {
            clearTimeout(functionTimeoutHandler.current);
            clearTimeout(maxWaitHandler.current);
            maxWaitHandler.current = null;
            maxWaitArgs.current = [];
            functionTimeoutHandler.current = null;
            leadingCall.current = false;
        }, []);
        React$2.useEffect(function () {
            // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
            isComponentUnmounted.current = false;
            return function () {
                // we use flag, as we allow to call callPending outside the hook
                isComponentUnmounted.current = true;
            };
        }, []);
        var debouncedCallback = React$2.useCallback(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            maxWaitArgs.current = args;
            clearTimeout(functionTimeoutHandler.current);
            if (leadingCall.current) {
                leadingCall.current = false;
            }
            if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
                debouncedFunction.current.apply(debouncedFunction, args);
                leadingCall.current = true;
            }
            functionTimeoutHandler.current = setTimeout(function () {
                var shouldCallFunction = true;
                if (leading && leadingCall.current) {
                    shouldCallFunction = false;
                }
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current && trailing && shouldCallFunction) {
                    debouncedFunction.current.apply(debouncedFunction, args);
                }
            }, delay);
            if (maxWait && !maxWaitHandler.current && trailing) {
                maxWaitHandler.current = setTimeout(function () {
                    var args = maxWaitArgs.current;
                    cancelDebouncedCallback();
                    if (!isComponentUnmounted.current) {
                        debouncedFunction.current.apply(null, args);
                    }
                }, maxWait);
            }
        }, [maxWait, delay, cancelDebouncedCallback, leading, trailing]);
        var callPending = React$2.useCallback(function () {
            // Call pending callback only if we have anything in our queue
            if (!functionTimeoutHandler.current) {
                return;
            }
            debouncedFunction.current.apply(null, maxWaitArgs.current);
            cancelDebouncedCallback();
        }, [cancelDebouncedCallback]);
        // At the moment, we use 3 args array so that we save backward compatibility
        return [debouncedCallback, cancelDebouncedCallback, callPending];
    }

    var performanceNow = createCommonjsModule(function (module) {
    // Generated by CoffeeScript 1.12.2
    (function() {
      var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

      if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
        module.exports = function() {
          return performance.now();
        };
      } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
        module.exports = function() {
          return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function() {
          var hr;
          hr = hrtime();
          return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
      } else if (Date.now) {
        module.exports = function() {
          return Date.now() - loadTime;
        };
        loadTime = Date.now();
      } else {
        module.exports = function() {
          return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
      }

    }).call(commonjsGlobal);


    });

    var root = typeof window === 'undefined' ? commonjsGlobal : window
      , vendors = ['moz', 'webkit']
      , suffix = 'AnimationFrame'
      , raf = root['request' + suffix]
      , caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

    for(var i = 0; !raf && i < vendors.length; i++) {
      raf = root[vendors[i] + 'Request' + suffix];
      caf = root[vendors[i] + 'Cancel' + suffix]
          || root[vendors[i] + 'CancelRequest' + suffix];
    }

    // Some versions of FF have rAF but not cAF
    if(!raf || !caf) {
      var last = 0
        , id = 0
        , queue = []
        , frameDuration = 1000 / 60;

      raf = function(callback) {
        if(queue.length === 0) {
          var _now = performanceNow()
            , next = Math.max(0, frameDuration - (_now - last));
          last = next + _now;
          setTimeout(function() {
            var cp = queue.slice(0);
            // Clear queue here to prevent
            // callbacks from appending listeners
            // to the current frame's queue
            queue.length = 0;
            for(var i = 0; i < cp.length; i++) {
              if(!cp[i].cancelled) {
                try{
                  cp[i].callback(last);
                } catch(e) {
                  setTimeout(function() { throw e }, 0);
                }
              }
            }
          }, Math.round(next));
        }
        queue.push({
          handle: ++id,
          callback: callback,
          cancelled: false
        });
        return id
      };

      caf = function(handle) {
        for(var i = 0; i < queue.length; i++) {
          if(queue[i].handle === handle) {
            queue[i].cancelled = true;
          }
        }
      };
    }

    var raf_1 = function(fn) {
      // Wrap in a new function to prevent
      // `cancel` potentially being assigned
      // to the native rAF function
      return raf.call(root, fn)
    };
    var cancel = function() {
      caf.apply(root, arguments);
    };
    var polyfill = function(object) {
      if (!object) {
        object = root;
      }
      object.requestAnimationFrame = raf;
      object.cancelAnimationFrame = caf;
    };
    raf_1.cancel = cancel;
    raf_1.polyfill = polyfill;

    var div = null;
    var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ];

    var prefixStyle = function prefixStyle (prop) {
      // re-use a dummy div
      if (!div) {
        div = document.createElement('div');
      }

      var style = div.style;

      // prop exists without prefix
      if (prop in style) {
        return prop
      }

      // borderRadius -> BorderRadius
      var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);

      // find the vendor-prefixed prop
      for (var i = prefixes.length; i >= 0; i--) {
        var name = prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) {
          return name
        }
      }

      return false
    };

    /**
     * Export.
     */

    var toNoCase_1 = toNoCase;

    /**
     * Test whether a string is camel-case.
     */

    var hasSpace = /\s/;
    var hasSeparator = /(_|-|\.|:)/;
    var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;

    /**
     * Remove any starting case from a `string`, like camel or snake, but keep
     * spaces and punctuation that may be important otherwise.
     *
     * @param {String} string
     * @return {String}
     */

    function toNoCase(string) {
      if (hasSpace.test(string)) return string.toLowerCase()
      if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
      if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
      return string.toLowerCase()
    }

    /**
     * Separator splitter.
     */

    var separatorSplitter = /[\W_]+(.|$)/g;

    /**
     * Un-separate a `string`.
     *
     * @param {String} string
     * @return {String}
     */

    function unseparate(string) {
      return string.replace(separatorSplitter, function (m, next) {
        return next ? ' ' + next : ''
      })
    }

    /**
     * Camelcase splitter.
     */

    var camelSplitter = /(.)([A-Z]+)/g;

    /**
     * Un-camelcase a `string`.
     *
     * @param {String} string
     * @return {String}
     */

    function uncamelize(string) {
      return string.replace(camelSplitter, function (m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ')
      })
    }

    /**
     * Export.
     */

    var toSpaceCase_1 = toSpaceCase;

    /**
     * Convert a `string` to space case.
     *
     * @param {String} string
     * @return {String}
     */

    function toSpaceCase(string) {
      return toNoCase_1(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
        return match ? ' ' + match : ''
      }).trim()
    }

    /**
     * Export.
     */

    var toCamelCase_1 = toCamelCase;

    /**
     * Convert a `string` to camel case.
     *
     * @param {String} string
     * @return {String}
     */

    function toCamelCase(string) {
      return toSpaceCase_1(string).replace(/\s(\w)/g, function (matches, letter) {
        return letter.toUpperCase()
      })
    }

    /* The following list is defined in React's core */
    var IS_UNITLESS = {
      animationIterationCount: true,
      boxFlex: true,
      boxFlexGroup: true,
      boxOrdinalGroup: true,
      columnCount: true,
      flex: true,
      flexGrow: true,
      flexPositive: true,
      flexShrink: true,
      flexNegative: true,
      flexOrder: true,
      gridRow: true,
      gridColumn: true,
      fontWeight: true,
      lineClamp: true,
      lineHeight: true,
      opacity: true,
      order: true,
      orphans: true,
      tabSize: true,
      widows: true,
      zIndex: true,
      zoom: true,

      // SVG-related properties
      fillOpacity: true,
      stopOpacity: true,
      strokeDashoffset: true,
      strokeOpacity: true,
      strokeWidth: true
    };

    var addPxToStyle = function(name, value) {
      if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
        return value + 'px';
      } else {
        return value;
      }
    };

    var cache = { 'float': 'cssFloat' };


    function style (element, property, value) {
      var camel = cache[property];
      if (typeof camel === 'undefined') {
        camel = detect(property);
      }

      // may be false if CSS prop is unsupported
      if (camel) {
        if (value === undefined) {
          return element.style[camel]
        }

        element.style[camel] = addPxToStyle(camel, value);
      }
    }

    function each (element, properties) {
      for (var k in properties) {
        if (properties.hasOwnProperty(k)) {
          style(element, k, properties[k]);
        }
      }
    }

    function detect (cssProp) {
      var camel = toCamelCase_1(cssProp);
      var result = prefixStyle(camel);
      cache[camel] = cache[cssProp] = cache[result] = result;
      return result
    }

    function set () {
      if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') {
          arguments[0].style.cssText = arguments[1];
        } else {
          each(arguments[0], arguments[1]);
        }
      } else {
        style(arguments[0], arguments[1], arguments[2]);
      }
    }

    var domCss = set;
    var set_1 = set;

    var get = function (element, properties) {
      if (Array.isArray(properties)) {
        return properties.reduce(function (obj, prop) {
          obj[prop] = style(element, prop || '');
          return obj
        }, {})
      } else {
        return style(element, properties || '')
      }
    };
    domCss.set = set_1;
    domCss.get = get;

    var isString_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports["default"] = isString;
    function isString(maybe) {
        return typeof maybe === 'string';
    }
    });

    unwrapExports(isString_1);

    var getScrollbarWidth_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports["default"] = getScrollbarWidth;



    var _domCss2 = _interopRequireDefault(domCss);

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

    var scrollbarWidth = false;

    function getScrollbarWidth() {
        if (scrollbarWidth !== false) return scrollbarWidth;
        /* istanbul ignore else */
        if (typeof document !== 'undefined') {
            var div = document.createElement('div');
            (0, _domCss2["default"])(div, {
                width: 100,
                height: 100,
                position: 'absolute',
                top: -9999,
                overflow: 'scroll',
                MsOverflowStyle: 'scrollbar'
            });
            document.body.appendChild(div);
            scrollbarWidth = div.offsetWidth - div.clientWidth;
            document.body.removeChild(div);
        } else {
            scrollbarWidth = 0;
        }
        return scrollbarWidth || 0;
    }
    });

    unwrapExports(getScrollbarWidth_1);

    var returnFalse_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports["default"] = returnFalse;
    function returnFalse() {
        return false;
    }
    });

    unwrapExports(returnFalse_1);

    var getInnerWidth_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports["default"] = getInnerWidth;
    function getInnerWidth(el) {
        var clientWidth = el.clientWidth;

        var _getComputedStyle = getComputedStyle(el),
            paddingLeft = _getComputedStyle.paddingLeft,
            paddingRight = _getComputedStyle.paddingRight;

        return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
    }
    });

    unwrapExports(getInnerWidth_1);

    var getInnerHeight_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports["default"] = getInnerHeight;
    function getInnerHeight(el) {
        var clientHeight = el.clientHeight;

        var _getComputedStyle = getComputedStyle(el),
            paddingTop = _getComputedStyle.paddingTop,
            paddingBottom = _getComputedStyle.paddingBottom;

        return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
    }
    });

    unwrapExports(getInnerHeight_1);

    var styles = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var containerStyleDefault = exports.containerStyleDefault = {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: '100%'
    };

    // Overrides containerStyleDefault properties
    var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
        height: 'auto'
    };

    var viewStyleDefault = exports.viewStyleDefault = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'scroll',
        WebkitOverflowScrolling: 'touch'
    };

    // Overrides viewStyleDefault properties
    var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
        position: 'relative',
        top: undefined,
        left: undefined,
        right: undefined,
        bottom: undefined
    };

    var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
        overflow: 'hidden',
        marginRight: 0,
        marginBottom: 0
    };

    var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
        position: 'absolute',
        height: 6
    };

    var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
        position: 'absolute',
        width: 6
    };

    var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
        position: 'relative',
        display: 'block',
        height: '100%'
    };

    var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
        position: 'relative',
        display: 'block',
        width: '100%'
    };

    var disableSelectStyle = exports.disableSelectStyle = {
        userSelect: 'none'
    };

    var disableSelectStyleReset = exports.disableSelectStyleReset = {
        userSelect: ''
    };
    });

    unwrapExports(styles);
    var styles_1 = styles.containerStyleDefault;
    var styles_2 = styles.containerStyleAutoHeight;
    var styles_3 = styles.viewStyleDefault;
    var styles_4 = styles.viewStyleAutoHeight;
    var styles_5 = styles.viewStyleUniversalInitial;
    var styles_6 = styles.trackHorizontalStyleDefault;
    var styles_7 = styles.trackVerticalStyleDefault;
    var styles_8 = styles.thumbHorizontalStyleDefault;
    var styles_9 = styles.thumbVerticalStyleDefault;
    var styles_10 = styles.disableSelectStyle;
    var styles_11 = styles.disableSelectStyleReset;

    var defaultRenderElements = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

    exports.renderViewDefault = renderViewDefault;
    exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
    exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
    exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
    exports.renderThumbVerticalDefault = renderThumbVerticalDefault;



    var _react2 = _interopRequireDefault(React$2__default);

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

    function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

    /* eslint-disable react/prop-types */

    function renderViewDefault(props) {
        return _react2["default"].createElement('div', props);
    }

    function renderTrackHorizontalDefault(_ref) {
        var style = _ref.style,
            props = _objectWithoutProperties(_ref, ['style']);

        var finalStyle = _extends({}, style, {
            right: 2,
            bottom: 2,
            left: 2,
            borderRadius: 3
        });
        return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
    }

    function renderTrackVerticalDefault(_ref2) {
        var style = _ref2.style,
            props = _objectWithoutProperties(_ref2, ['style']);

        var finalStyle = _extends({}, style, {
            right: 2,
            bottom: 2,
            top: 2,
            borderRadius: 3
        });
        return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
    }

    function renderThumbHorizontalDefault(_ref3) {
        var style = _ref3.style,
            props = _objectWithoutProperties(_ref3, ['style']);

        var finalStyle = _extends({}, style, {
            cursor: 'pointer',
            borderRadius: 'inherit',
            backgroundColor: 'rgba(0,0,0,.2)'
        });
        return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
    }

    function renderThumbVerticalDefault(_ref4) {
        var style = _ref4.style,
            props = _objectWithoutProperties(_ref4, ['style']);

        var finalStyle = _extends({}, style, {
            cursor: 'pointer',
            borderRadius: 'inherit',
            backgroundColor: 'rgba(0,0,0,.2)'
        });
        return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
    }
    });

    unwrapExports(defaultRenderElements);
    var defaultRenderElements_1 = defaultRenderElements.renderViewDefault;
    var defaultRenderElements_2 = defaultRenderElements.renderTrackHorizontalDefault;
    var defaultRenderElements_3 = defaultRenderElements.renderTrackVerticalDefault;
    var defaultRenderElements_4 = defaultRenderElements.renderThumbHorizontalDefault;
    var defaultRenderElements_5 = defaultRenderElements.renderThumbVerticalDefault;

    var Scrollbars_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



    var _raf3 = _interopRequireDefault(raf_1);



    var _domCss2 = _interopRequireDefault(domCss);





    var _propTypes2 = _interopRequireDefault(propTypes);



    var _isString2 = _interopRequireDefault(isString_1);



    var _getScrollbarWidth2 = _interopRequireDefault(getScrollbarWidth_1);



    var _returnFalse2 = _interopRequireDefault(returnFalse_1);



    var _getInnerWidth2 = _interopRequireDefault(getInnerWidth_1);



    var _getInnerHeight2 = _interopRequireDefault(getInnerHeight_1);





    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

    function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

    var Scrollbars = function (_Component) {
        _inherits(Scrollbars, _Component);

        function Scrollbars(props) {
            var _ref;

            _classCallCheck(this, Scrollbars);

            for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                rest[_key - 1] = arguments[_key];
            }

            var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

            _this.getScrollLeft = _this.getScrollLeft.bind(_this);
            _this.getScrollTop = _this.getScrollTop.bind(_this);
            _this.getScrollWidth = _this.getScrollWidth.bind(_this);
            _this.getScrollHeight = _this.getScrollHeight.bind(_this);
            _this.getClientWidth = _this.getClientWidth.bind(_this);
            _this.getClientHeight = _this.getClientHeight.bind(_this);
            _this.getValues = _this.getValues.bind(_this);
            _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
            _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
            _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
            _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

            _this.scrollLeft = _this.scrollLeft.bind(_this);
            _this.scrollTop = _this.scrollTop.bind(_this);
            _this.scrollToLeft = _this.scrollToLeft.bind(_this);
            _this.scrollToTop = _this.scrollToTop.bind(_this);
            _this.scrollToRight = _this.scrollToRight.bind(_this);
            _this.scrollToBottom = _this.scrollToBottom.bind(_this);

            _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
            _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
            _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
            _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
            _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
            _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
            _this.handleWindowResize = _this.handleWindowResize.bind(_this);
            _this.handleScroll = _this.handleScroll.bind(_this);
            _this.handleDrag = _this.handleDrag.bind(_this);
            _this.handleDragEnd = _this.handleDragEnd.bind(_this);

            _this.state = {
                didMountUniversal: false
            };
            return _this;
        }

        _createClass(Scrollbars, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        }, {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;

                if (!universal) return;
                this.setState({ didMountUniversal: true });
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, raf_1.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        }, {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        }, {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        }, {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        }, {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        }, {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        }, {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        }, {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {},
                    _ref2$scrollLeft = _ref2.scrollLeft,
                    scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                    _ref2$scrollTop = _ref2.scrollTop,
                    scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                    _ref2$scrollWidth = _ref2.scrollWidth,
                    scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                    _ref2$scrollHeight = _ref2.scrollHeight,
                    scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                    _ref2$clientWidth = _ref2.clientWidth,
                    clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                    _ref2$clientHeight = _ref2.clientHeight,
                    clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        }, {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props,
                    thumbSize = _props.thumbSize,
                    thumbMinSize = _props.thumbMinSize;
                var _view = this.view,
                    scrollWidth = _view.scrollWidth,
                    clientWidth = _view.clientWidth;

                var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        }, {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props,
                    thumbSize = _props2.thumbSize,
                    thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view,
                    scrollHeight = _view2.scrollHeight,
                    clientHeight = _view2.clientHeight;

                var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        }, {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view,
                    scrollWidth = _view3.scrollWidth,
                    clientWidth = _view3.clientWidth;

                var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        }, {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view,
                    scrollHeight = _view4.scrollHeight,
                    clientHeight = _view4.clientHeight;

                var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        }, {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        }, {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

                if (!this.view) return;
                this.view.scrollTop = top;
            }
        }, {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        }, {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        }, {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        }, {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        }, {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */
                if (typeof document === 'undefined' || !this.view) return;
                var view = this.view,
                    trackHorizontal = this.trackHorizontal,
                    trackVertical = this.trackVertical,
                    thumbHorizontal = this.thumbHorizontal,
                    thumbVertical = this.thumbVertical;

                view.addEventListener('scroll', this.handleScroll);
                if (!(0, _getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        }, {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */
                if (typeof document === 'undefined' || !this.view) return;
                var view = this.view,
                    trackHorizontal = this.trackHorizontal,
                    trackVertical = this.trackVertical,
                    thumbHorizontal = this.thumbHorizontal,
                    thumbVertical = this.thumbVertical;

                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, _getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        }, {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;

                var _props3 = this.props,
                    onScroll = _props3.onScroll,
                    onScrollFrame = _props3.onScrollFrame;

                if (onScroll) onScroll(event);
                this.update(function (values) {
                    var scrollLeft = values.scrollLeft,
                        scrollTop = values.scrollTop;

                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        }, {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;

                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        }, {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;

                if (!autoHide) return;
                this.showTracks();
            }
        }, {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;

                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        }, {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;

                if (!autoHide) return;
                this.hideTracks();
            }
        }, {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                this.update();
            }
        }, {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target,
                    clientX = event.clientX;

                var _target$getBoundingCl = target.getBoundingClientRect(),
                    targetLeft = _target$getBoundingCl.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        }, {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target,
                    clientY = event.clientY;

                var _target$getBoundingCl2 = target.getBoundingClientRect(),
                    targetTop = _target$getBoundingCl2.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        }, {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target,
                    clientX = event.clientX;
                var offsetWidth = target.offsetWidth;

                var _target$getBoundingCl3 = target.getBoundingClientRect(),
                    left = _target$getBoundingCl3.left;

                this.prevPageX = offsetWidth - (clientX - left);
            }
        }, {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target,
                    clientY = event.clientY;
                var offsetHeight = target.offsetHeight;

                var _target$getBoundingCl4 = target.getBoundingClientRect(),
                    top = _target$getBoundingCl4.top;

                this.prevPageY = offsetHeight - (clientY - top);
            }
        }, {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, _domCss2["default"])(document.body, styles.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = _returnFalse2["default"];
            }
        }, {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, _domCss2["default"])(document.body, styles.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        }, {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        }, {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;

                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                        trackLeft = _trackHorizontal$getB.left;

                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;

                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                        trackTop = _trackVertical$getBou.top;

                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        }, {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        }, {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;

                if (!autoHide) return;
                this.hideTracks();
            }
        }, {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        }, {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;

                if (!autoHide) return;
                this.showTracks();
            }
        }, {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        }, {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;

                if (!autoHide) return;
                this.hideTracks();
            }
        }, {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
                (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
            }
        }, {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;

                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;

                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function () {
                    (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                    (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
                }, autoHideTimeout);
            }
        }, {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;

                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function () {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        }, {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;

                if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, _raf3["default"])(function () {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        }, {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;

                this.raf(function () {
                    return _this6._update(callback);
                });
            }
        }, {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props,
                    onUpdate = _props4.onUpdate,
                    hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

                var values = this.getValues();
                if ((0, _getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft,
                        clientWidth = values.clientWidth,
                        scrollWidth = values.scrollWidth;

                    var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop,
                        clientHeight = values.clientHeight,
                        scrollHeight = values.scrollHeight;

                    var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        }, {
            key: 'render',
            value: function render() {
                var _this7 = this;

                var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */

                var _props5 = this.props,
                    onScroll = _props5.onScroll,
                    onScrollFrame = _props5.onScrollFrame,
                    onScrollStart = _props5.onScrollStart,
                    onScrollStop = _props5.onScrollStop,
                    onUpdate = _props5.onUpdate,
                    renderView = _props5.renderView,
                    renderTrackHorizontal = _props5.renderTrackHorizontal,
                    renderTrackVertical = _props5.renderTrackVertical,
                    renderThumbHorizontal = _props5.renderThumbHorizontal,
                    renderThumbVertical = _props5.renderThumbVertical,
                    tagName = _props5.tagName,
                    hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                    autoHide = _props5.autoHide,
                    autoHideTimeout = _props5.autoHideTimeout,
                    autoHideDuration = _props5.autoHideDuration,
                    thumbSize = _props5.thumbSize,
                    thumbMinSize = _props5.thumbMinSize,
                    universal = _props5.universal,
                    autoHeight = _props5.autoHeight,
                    autoHeightMin = _props5.autoHeightMin,
                    autoHeightMax = _props5.autoHeightMax,
                    style = _props5.style,
                    children = _props5.children,
                    props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
                /* eslint-enable no-unused-vars */

                var didMountUniversal = this.state.didMountUniversal;


                var containerStyle = _extends({}, styles.containerStyleDefault, autoHeight && _extends({}, styles.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);

                var viewStyle = _extends({}, styles.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && _extends({}, styles.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && styles.viewStyleUniversalInitial);

                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };

                var trackHorizontalStyle = _extends({}, styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });

                var trackVerticalStyle = _extends({}, styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });

                return (0, React$2__default.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    } }), [(0, React$2__default.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                        _this7.view = _ref4;
                    } }, children), (0, React$2__default.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                        _this7.trackHorizontal = _ref5;
                    } }, (0, React$2__default.cloneElement)(renderThumbHorizontal({ style: styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                        _this7.thumbHorizontal = _ref6;
                    } })), (0, React$2__default.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                        _this7.trackVertical = _ref7;
                    } }, (0, React$2__default.cloneElement)(renderThumbVertical({ style: styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                        _this7.thumbVertical = _ref8;
                    } }))]);
            }
        }]);

        return Scrollbars;
    }(React$2__default.Component);

    exports["default"] = Scrollbars;


    Scrollbars.propTypes = {
        onScroll: _propTypes2["default"].func,
        onScrollFrame: _propTypes2["default"].func,
        onScrollStart: _propTypes2["default"].func,
        onScrollStop: _propTypes2["default"].func,
        onUpdate: _propTypes2["default"].func,
        renderView: _propTypes2["default"].func,
        renderTrackHorizontal: _propTypes2["default"].func,
        renderTrackVertical: _propTypes2["default"].func,
        renderThumbHorizontal: _propTypes2["default"].func,
        renderThumbVertical: _propTypes2["default"].func,
        tagName: _propTypes2["default"].string,
        thumbSize: _propTypes2["default"].number,
        thumbMinSize: _propTypes2["default"].number,
        hideTracksWhenNotNeeded: _propTypes2["default"].bool,
        autoHide: _propTypes2["default"].bool,
        autoHideTimeout: _propTypes2["default"].number,
        autoHideDuration: _propTypes2["default"].number,
        autoHeight: _propTypes2["default"].bool,
        autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
        autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
        universal: _propTypes2["default"].bool,
        style: _propTypes2["default"].object,
        children: _propTypes2["default"].node
    };

    Scrollbars.defaultProps = {
        renderView: defaultRenderElements.renderViewDefault,
        renderTrackHorizontal: defaultRenderElements.renderTrackHorizontalDefault,
        renderTrackVertical: defaultRenderElements.renderTrackVerticalDefault,
        renderThumbHorizontal: defaultRenderElements.renderThumbHorizontalDefault,
        renderThumbVertical: defaultRenderElements.renderThumbVerticalDefault,
        tagName: 'div',
        thumbMinSize: 30,
        hideTracksWhenNotNeeded: false,
        autoHide: false,
        autoHideTimeout: 1000,
        autoHideDuration: 200,
        autoHeight: false,
        autoHeightMin: 0,
        autoHeightMax: 200,
        universal: false
    };
    });

    unwrapExports(Scrollbars_1);

    var lib$1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.Scrollbars = undefined;



    var _Scrollbars2 = _interopRequireDefault(Scrollbars_1);

    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

    exports["default"] = _Scrollbars2["default"];
    exports.Scrollbars = _Scrollbars2["default"];
    });

    unwrapExports(lib$1);
    var lib_1 = lib$1.Scrollbars;

    function FiasInput(_a) {
        var path = _a.path, label = _a.label, error = _a.error, onBlur = _a.onBlur, onFocus = _a.onFocus, disabled = _a.disabled, onChange = _a.onChange, className = _a.className, styleType = _a.styleType, selectItem = _a.selectItem, description = _a.description, _b = _a.id, id = _b === void 0 ? 'address' : _b, _c = _a.name, name = _c === void 0 ? 'address' : _c, _d = _a.initialValue, initialValue = _d === void 0 ? '' : _d, _e = _a.labelPosition, labelPosition = _e === void 0 ? 'afterInput' : _e, _f = _a.url, url = _f === void 0 ? '/autocomplete/address/' : _f, _g = _a.placeholder, placeholder = _g === void 0 ? 'Начните вводить' : _g;
        var _h = React$2.useState([]), addresses = _h[0], setAddresses = _h[1];
        var _j = React$2.useState(''), fiascoRequestError = _j[0], setFiascoRequestError = _j[1];
        var _k = React$2.useState(0), ulHeight = _k[0], setUlHeight = _k[1];
        var generateRandomName = function () {
            var randomText = '';
            var possible = 'abcdefghijklmnopqrstuvwxyz';
            for (var i = 0; i < 8; i++)
                randomText += possible.charAt(Math.floor(Math.random() * possible.length));
            return randomText;
        };
        React$2.useEffect(function () {
            var listItems = Array.from(document.querySelectorAll("#" + id + "-menu li"));
            if (listItems.length > 0) {
                setUlHeight(listItems.reduce(function (acc, curr) { return acc + curr.offsetHeight; }, 0));
            }
        }, [addresses, id]);
        function request(value) {
            return __awaiter(this, void 0, void 0, function () {
                var response, json, suggestions, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!value) {
                                setAddresses([]);
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, fetch(url + "?query=" + value + (path ? "&path=" + path : ''))];
                        case 2:
                            response = _a.sent();
                            return [4 /*yield*/, response.json()];
                        case 3:
                            json = _a.sent();
                            if (!response.ok) {
                                throw new Error("\u041E\u0448\u0438\u0431\u043A\u0430 " + response.status + ": \u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0430\u0434\u0440\u0435\u0441\u043E\u0432");
                            }
                            else {
                                suggestions = json.suggestions;
                                setAddresses(suggestions);
                                if (fiascoRequestError)
                                    setFiascoRequestError('');
                            }
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _a.sent();
                            console.error(error_1);
                            setFiascoRequestError(error_1.message);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        var requestFiasco = useDebouncedCallback(function (value) {
            request(value);
        }, 250)[0];
        var fieldError = error || fiascoRequestError;
        var _l = Downshift.useCombobox({
            id: id,
            inputId: id,
            items: addresses,
            menuId: id + "-menu",
            labelId: id + "-label",
            initialInputValue: initialValue,
            itemToString: function (address) { return address.value; },
            onSelectedItemChange: function (_a) {
                var selectedItem = _a.selectedItem;
                if (typeof selectItem === 'function' && selectedItem)
                    selectItem(selectedItem);
            },
        }), isOpen = _l.isOpen, getMenuProps = _l.getMenuProps, getItemProps = _l.getItemProps, getInputProps = _l.getInputProps, getComboboxProps = _l.getComboboxProps, highlightedIndex = _l.highlightedIndex;
        return (React$2__default.createElement("div", { className: className },
            React$2__default.createElement("div", __assign({}, getComboboxProps({ className: 'combobox' })),
                React$2__default.createElement(StyledFieldWrapper, { name: name, label: label, error: !!error, styleType: styleType, description: description, labelPosition: labelPosition },
                    React$2__default.createElement("input", __assign({}, getInputProps({
                        id: id,
                        name: name,
                        placeholder: placeholder,
                        onFocus: function (e) {
                            e.currentTarget.name = generateRandomName();
                            onFocus && onFocus(e);
                        },
                        onBlur: function (e) {
                            e.currentTarget.name = generateRandomName();
                            onBlur && onBlur(e);
                        },
                        onChange: function (e) {
                            onChange && onChange(e);
                            requestFiasco(e.target.value);
                        },
                        onKeyDown: function (e) {
                            if (e.key === 'Escape') {
                                var nativeEvent = e.nativeEvent;
                                nativeEvent.preventDownshiftDefault = true;
                            }
                        },
                    }), { label: label, disabled: disabled, styleType: styleType, labelPosition: labelPosition, className: "input" + (error ? ' input-error' : '') }))),
                !fieldError && description && (React$2__default.createElement("div", { className: "description" }, description)),
                fieldError && React$2__default.createElement("div", { className: "error" }, fieldError)),
            React$2__default.createElement("ul", __assign({}, getMenuProps({
                className: 'list',
                style: {
                    display: isOpen && addresses.length > 0 ? 'block' : 'none',
                },
            })),
                React$2__default.createElement(lib_1, { universal: true, style: {
                        backgroundColor: '#fff',
                        height: ulHeight > 194 ? 194 : ulHeight,
                        willChange: 'height',
                    } }, addresses.map(function (address, index) { return (React$2__default.createElement("li", __assign({ key: "" + address + index }, getItemProps({
                    className: highlightedIndex === index ? 'selected item' : 'item',
                    item: address,
                    index: index,
                })), address.value)); })))));
    }
    var StyledFiasInput = styled__default(FiasInput)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  .combobox {\n    position: relative;\n  }\n\n  .list {\n    position: absolute;\n    top: 48px;\n    z-index: 10;\n    width: 100%;\n    max-height: 194px;\n    overflow: hidden;\n    border: 2px solid #000;\n    border-top: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .item {\n    display: flex;\n    align-items: center;\n    padding: 14.5px 14px;\n    font-size: 15px;\n    line-height: 19px;\n    color: #000;\n    cursor: pointer;\n    background-color: #fff;\n    transition: 0.2s;\n\n    &.selected {\n      background-color: #f6f6f6;\n    }\n  }\n\n  .error {\n    position: absolute;\n    font-size: 13px;\n    line-height: 18px;\n    color: #f30;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  .combobox {\n    position: relative;\n  }\n\n  .list {\n    position: absolute;\n    top: 48px;\n    z-index: 10;\n    width: 100%;\n    max-height: 194px;\n    overflow: hidden;\n    border: 2px solid #000;\n    border-top: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .item {\n    display: flex;\n    align-items: center;\n    padding: 14.5px 14px;\n    font-size: 15px;\n    line-height: 19px;\n    color: #000;\n    cursor: pointer;\n    background-color: #fff;\n    transition: 0.2s;\n\n    &.selected {\n      background-color: #f6f6f6;\n    }\n  }\n\n  .error {\n    position: absolute;\n    font-size: 13px;\n    line-height: 18px;\n    color: #f30;\n  }\n"])));
    var templateObject_1$6;

    function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(React$2__default);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r);}return e}function _extends$1(){return (_extends$1=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}function _inheritsLoose$1(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t);}function _objectWithoutPropertiesLoose$1(e,t){if(null==e)return {};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized$1(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation";}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else {var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select();}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else {var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length));}return {start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return {maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1);}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return -1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return !1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return !u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return !0;if(++s>=l.length)return !1}var t,n,a,i;return !isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return !1;var t,n;return (isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h);}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return "function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return (!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e);}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop);},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop();},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null);},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=ReactDOM.findDOMNode(_assertThisInitialized$1(_assertThisInitialized$1(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e);},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t);},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t);}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)});},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e);},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return {mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return !0}catch(r){}return !f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized$1(_assertThisInitialized$1(f)).beforePasteState,n=_assertThisInitialized$1(_assertThisInitialized$1(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection;}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end);},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else {var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection;}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end);}f.runSaveSelectionLoop();}isFunction(f.props.onFocus)&&f.props.onFocus(e);},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e);}isFunction(f.props.onBlur)&&f.props.onBlur(e);},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd();}};document.addEventListener("mouseup",r);}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e);},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""));},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e);};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value;}return f.value=l,f}_inheritsLoose$1(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value));},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p));}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection;}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end);}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate());},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop();},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose$1(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends$1({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1);}else t=React.createElement("input",_extends$1({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);var reactInputMask_production_min=InputElement;

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */

    var NODE_ENV = process.env.NODE_ENV;

    var invariant$1 = function(condition, format, a, b, c, d, e, f) {
      if (NODE_ENV !== 'production') {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      }

      if (!condition) {
        var error;
        if (format === undefined) {
          error = new Error(
            'Minified exception occurred; use the non-minified dev environment ' +
            'for the full error message and additional helpful warnings.'
          );
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(
            format.replace(/%s/g, function() { return args[argIndex++]; })
          );
          error.name = 'Invariant Violation';
        }

        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
      }
    };

    var invariant_1$1 = invariant$1;

    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    /**
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */

    var __DEV__ = process.env.NODE_ENV !== 'production';

    var warning = function() {};

    if (__DEV__) {
      var printWarning$2 = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for (var key = 1; key < len; key++) {
          args[key - 1] = arguments[key];
        }
        var argIndex = 0;
        var message = 'Warning: ' +
          format.replace(/%s/g, function() {
            return args[argIndex++];
          });
        if (typeof console !== 'undefined') {
          console.error(message);
        }
        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };

      warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for (var key = 2; key < len; key++) {
          args[key - 2] = arguments[key];
        }
        if (format === undefined) {
          throw new Error(
              '`warning(condition, format, ...args)` requires a warning ' +
              'message argument'
          );
        }
        if (!condition) {
          printWarning$2.apply(null, [format].concat(args));
        }
      };
    }

    var warning_1 = warning;

    function _interopDefault$1 (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

    var React$1 = _interopDefault$1(React$2__default);

    var invariant$2 = _interopDefault$1(invariant_1$1);
    var warning$1 = _interopDefault$1(warning_1);

    function _defaults2$1(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

    function _extends$2() {
      _extends$2 = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends$2.apply(this, arguments);
    }

    function _inheritsLoose$2(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;

      _defaults2$1(subClass, superClass);
    }

    function _objectWithoutPropertiesLoose$2(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _assertThisInitialized$2(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function setInputSelection$1(input, start, end) {
      if ('selectionStart' in input && 'selectionEnd' in input) {
        input.selectionStart = start;
        input.selectionEnd = end;
      } else {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveStart('character', start);
        range.moveEnd('character', end - start);
        range.select();
      }
    }
    function getInputSelection$1(input) {
      var start = 0;
      var end = 0;

      if ('selectionStart' in input && 'selectionEnd' in input) {
        start = input.selectionStart;
        end = input.selectionEnd;
      } else {
        var range = document.selection.createRange();

        if (range.parentElement() === input) {
          start = -range.moveStart('character', -input.value.length);
          end = -range.moveEnd('character', -input.value.length);
        }
      }

      return {
        start: start,
        end: end,
        length: end - start
      };
    }

    var defaultFormatChars$1 = {
      '9': '[0-9]',
      'a': '[A-Za-z]',
      '*': '[A-Za-z0-9]'
    };
    var defaultMaskChar$1 = '_';

    function parseMask$1 (mask, maskChar, formatChars) {
      var parsedMaskString = '';
      var prefix = '';
      var lastEditablePosition = null;
      var permanents = [];

      if (maskChar === undefined) {
        maskChar = defaultMaskChar$1;
      }

      if (formatChars == null) {
        formatChars = defaultFormatChars$1;
      }

      if (!mask || typeof mask !== 'string') {
        return {
          maskChar: maskChar,
          formatChars: formatChars,
          mask: null,
          prefix: null,
          lastEditablePosition: null,
          permanents: []
        };
      }

      var isPermanent = false;
      mask.split('').forEach(function (character) {
        if (!isPermanent && character === '\\') {
          isPermanent = true;
        } else {
          if (isPermanent || !formatChars[character]) {
            permanents.push(parsedMaskString.length);

            if (parsedMaskString.length === permanents.length - 1) {
              prefix += character;
            }
          } else {
            lastEditablePosition = parsedMaskString.length + 1;
          }

          parsedMaskString += character;
          isPermanent = false;
        }
      });
      return {
        maskChar: maskChar,
        formatChars: formatChars,
        prefix: prefix,
        mask: parsedMaskString,
        lastEditablePosition: lastEditablePosition,
        permanents: permanents
      };
    }

    /* eslint no-use-before-define: ["error", { functions: false }] */
    function isPermanentCharacter$1(maskOptions, pos) {
      return maskOptions.permanents.indexOf(pos) !== -1;
    }
    function isAllowedCharacter$1(maskOptions, pos, character) {
      var mask = maskOptions.mask,
          formatChars = maskOptions.formatChars;

      if (!character) {
        return false;
      }

      if (isPermanentCharacter$1(maskOptions, pos)) {
        return mask[pos] === character;
      }

      var ruleChar = mask[pos];
      var charRule = formatChars[ruleChar];
      return new RegExp(charRule).test(character);
    }
    function isEmpty$1(maskOptions, value) {
      return value.split('').every(function (character, i) {
        return isPermanentCharacter$1(maskOptions, i) || !isAllowedCharacter$1(maskOptions, i, character);
      });
    }
    function getFilledLength$1(maskOptions, value) {
      var maskChar = maskOptions.maskChar,
          prefix = maskOptions.prefix;

      if (!maskChar) {
        while (value.length > prefix.length && isPermanentCharacter$1(maskOptions, value.length - 1)) {
          value = value.slice(0, value.length - 1);
        }

        return value.length;
      }

      var filledLength = prefix.length;

      for (var i = value.length; i >= prefix.length; i--) {
        var character = value[i];
        var isEnteredCharacter = !isPermanentCharacter$1(maskOptions, i) && isAllowedCharacter$1(maskOptions, i, character);

        if (isEnteredCharacter) {
          filledLength = i + 1;
          break;
        }
      }

      return filledLength;
    }
    function isFilled$1(maskOptions, value) {
      return getFilledLength$1(maskOptions, value) === maskOptions.mask.length;
    }
    function formatValue$1(maskOptions, value) {
      var maskChar = maskOptions.maskChar,
          mask = maskOptions.mask,
          prefix = maskOptions.prefix;

      if (!maskChar) {
        value = insertString$1(maskOptions, '', value, 0);

        if (value.length < prefix.length) {
          value = prefix;
        }

        while (value.length < mask.length && isPermanentCharacter$1(maskOptions, value.length)) {
          value += mask[value.length];
        }

        return value;
      }

      if (value) {
        var emptyValue = formatValue$1(maskOptions, '');
        return insertString$1(maskOptions, emptyValue, value, 0);
      }

      for (var i = 0; i < mask.length; i++) {
        if (isPermanentCharacter$1(maskOptions, i)) {
          value += mask[i];
        } else {
          value += maskChar;
        }
      }

      return value;
    }
    function clearRange$1(maskOptions, value, start, len) {
      var end = start + len;
      var maskChar = maskOptions.maskChar,
          mask = maskOptions.mask,
          prefix = maskOptions.prefix;
      var arrayValue = value.split('');

      if (!maskChar) {
        // remove any permanent chars after clear range, they will be added back by formatValue
        for (var i = end; i < arrayValue.length; i++) {
          if (isPermanentCharacter$1(maskOptions, i)) {
            arrayValue[i] = '';
          }
        }

        start = Math.max(prefix.length, start);
        arrayValue.splice(start, end - start);
        value = arrayValue.join('');
        return formatValue$1(maskOptions, value);
      }

      return arrayValue.map(function (character, i) {
        if (i < start || i >= end) {
          return character;
        }

        if (isPermanentCharacter$1(maskOptions, i)) {
          return mask[i];
        }

        return maskChar;
      }).join('');
    }
    function insertString$1(maskOptions, value, insertStr, insertPosition) {
      var mask = maskOptions.mask,
          maskChar = maskOptions.maskChar,
          prefix = maskOptions.prefix;
      var arrayInsertStr = insertStr.split('');
      var isInputFilled = isFilled$1(maskOptions, value);

      var isUsablePosition = function isUsablePosition(pos, character) {
        return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
      };

      var isUsableCharacter = function isUsableCharacter(character, pos) {
        return !maskChar || !isPermanentCharacter$1(maskOptions, pos) || character !== maskChar;
      };

      if (!maskChar && insertPosition > value.length) {
        value += mask.slice(value.length, insertPosition);
      }

      arrayInsertStr.every(function (insertCharacter) {
        while (!isUsablePosition(insertPosition, insertCharacter)) {
          if (insertPosition >= value.length) {
            value += mask[insertPosition];
          }

          if (!isUsableCharacter(insertCharacter, insertPosition)) {
            return true;
          }

          insertPosition++; // stop iteration if maximum value length reached

          if (insertPosition >= mask.length) {
            return false;
          }
        }

        var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

        if (!isAllowed) {
          return true;
        }

        if (insertPosition < value.length) {
          if (maskChar || isInputFilled || insertPosition < prefix.length) {
            value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
          } else {
            value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
            value = formatValue$1(maskOptions, value);
          }
        } else if (!maskChar) {
          value += insertCharacter;
        }

        insertPosition++; // stop iteration if maximum value length reached

        return insertPosition < mask.length;
      });
      return value;
    }
    function getInsertStringLength$1(maskOptions, value, insertStr, insertPosition) {
      var mask = maskOptions.mask,
          maskChar = maskOptions.maskChar;
      var arrayInsertStr = insertStr.split('');
      var initialInsertPosition = insertPosition;

      var isUsablePosition = function isUsablePosition(pos, character) {
        return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
      };

      arrayInsertStr.every(function (insertCharacter) {
        while (!isUsablePosition(insertPosition, insertCharacter)) {
          insertPosition++; // stop iteration if maximum value length reached

          if (insertPosition >= mask.length) {
            return false;
          }
        }

        var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

        if (isAllowed) {
          insertPosition++;
        } // stop iteration if maximum value length reached


        return insertPosition < mask.length;
      });
      return insertPosition - initialInsertPosition;
    }
    function getLeftEditablePosition$1(maskOptions, pos) {
      for (var i = pos; i >= 0; --i) {
        if (!isPermanentCharacter$1(maskOptions, i)) {
          return i;
        }
      }

      return null;
    }
    function getRightEditablePosition$1(maskOptions, pos) {
      var mask = maskOptions.mask;

      for (var i = pos; i < mask.length; ++i) {
        if (!isPermanentCharacter$1(maskOptions, i)) {
          return i;
        }
      }

      return null;
    }
    function getStringValue$1(value) {
      return !value && value !== 0 ? '' : value + '';
    }

    function processChange$1(maskOptions, value, selection, previousValue, previousSelection) {
      var mask = maskOptions.mask,
          prefix = maskOptions.prefix,
          lastEditablePosition = maskOptions.lastEditablePosition;
      var newValue = value;
      var enteredString = '';
      var formattedEnteredStringLength = 0;
      var removedLength = 0;
      var cursorPosition = Math.min(previousSelection.start, selection.start);

      if (selection.end > previousSelection.start) {
        enteredString = newValue.slice(previousSelection.start, selection.end);
        formattedEnteredStringLength = getInsertStringLength$1(maskOptions, previousValue, enteredString, cursorPosition);

        if (!formattedEnteredStringLength) {
          removedLength = 0;
        } else {
          removedLength = previousSelection.length;
        }
      } else if (newValue.length < previousValue.length) {
        removedLength = previousValue.length - newValue.length;
      }

      newValue = previousValue;

      if (removedLength) {
        if (removedLength === 1 && !previousSelection.length) {
          var deleteFromRight = previousSelection.start === selection.start;
          cursorPosition = deleteFromRight ? getRightEditablePosition$1(maskOptions, selection.start) : getLeftEditablePosition$1(maskOptions, selection.start);
        }

        newValue = clearRange$1(maskOptions, newValue, cursorPosition, removedLength);
      }

      newValue = insertString$1(maskOptions, newValue, enteredString, cursorPosition);
      cursorPosition = cursorPosition + formattedEnteredStringLength;

      if (cursorPosition >= mask.length) {
        cursorPosition = mask.length;
      } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
        cursorPosition = prefix.length;
      } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
        cursorPosition = getRightEditablePosition$1(maskOptions, cursorPosition);
      }

      newValue = formatValue$1(maskOptions, newValue);

      if (!enteredString) {
        enteredString = null;
      }

      return {
        value: newValue,
        enteredString: enteredString,
        selection: {
          start: cursorPosition,
          end: cursorPosition
        }
      };
    }

    function isWindowsPhoneBrowser$1() {
      var windows = new RegExp('windows', 'i');
      var phone = new RegExp('phone', 'i');
      var ua = navigator.userAgent;
      return windows.test(ua) && phone.test(ua);
    }

    function isFunction$1(value) {
      return typeof value === 'function';
    }

    function getRequestAnimationFrame$1() {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
    }

    function getCancelAnimationFrame$1() {
      return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
    }

    function defer$1(fn) {
      var hasCancelAnimationFrame = !!getCancelAnimationFrame$1();
      var deferFn;

      if (hasCancelAnimationFrame) {
        deferFn = getRequestAnimationFrame$1();
      } else {
        deferFn = function deferFn() {
          return setTimeout(fn, 1000 / 60);
        };
      }

      return deferFn(fn);
    }
    function cancelDefer$1(deferId) {
      var cancelFn = getCancelAnimationFrame$1() || clearTimeout;
      cancelFn(deferId);
    }

    var InputElement$1 =
    /*#__PURE__*/
    function (_React$Component) {
      _inheritsLoose$2(InputElement, _React$Component);

      function InputElement(props) {
        var _this;

        _this = _React$Component.call(this, props) || this;
        _this.focused = false;
        _this.mounted = false;
        _this.previousSelection = null;
        _this.selectionDeferId = null;
        _this.saveSelectionLoopDeferId = null;

        _this.saveSelectionLoop = function () {
          _this.previousSelection = _this.getSelection();
          _this.saveSelectionLoopDeferId = defer$1(_this.saveSelectionLoop);
        };

        _this.runSaveSelectionLoop = function () {
          if (_this.saveSelectionLoopDeferId === null) {
            _this.saveSelectionLoop();
          }
        };

        _this.stopSaveSelectionLoop = function () {
          if (_this.saveSelectionLoopDeferId !== null) {
            cancelDefer$1(_this.saveSelectionLoopDeferId);
            _this.saveSelectionLoopDeferId = null;
            _this.previousSelection = null;
          }
        };

        _this.getInputDOMNode = function () {
          if (!_this.mounted) {
            return null;
          }

          var input = ReactDOM.findDOMNode(_assertThisInitialized$2(_assertThisInitialized$2(_this)));
          var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
          // https://github.com/sanniassin/react-input-mask/issues/147

          if (input && !isDOMNode) {
            return null;
          }

          if (input.nodeName !== 'INPUT') {
            input = input.querySelector('input');
          }

          if (!input) {
            throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
          }

          return input;
        };

        _this.getInputValue = function () {
          var input = _this.getInputDOMNode();

          if (!input) {
            return null;
          }

          return input.value;
        };

        _this.setInputValue = function (value) {
          var input = _this.getInputDOMNode();

          if (!input) {
            return;
          }

          _this.value = value;
          input.value = value;
        };

        _this.setCursorToEnd = function () {
          var filledLength = getFilledLength$1(_this.maskOptions, _this.value);
          var pos = getRightEditablePosition$1(_this.maskOptions, filledLength);

          if (pos !== null) {
            _this.setCursorPosition(pos);
          }
        };

        _this.setSelection = function (start, end, options) {
          if (options === void 0) {
            options = {};
          }

          var input = _this.getInputDOMNode();

          var isFocused = _this.isFocused(); // don't change selection on unfocused input
          // because Safari sets focus on selection change (#154)


          if (!input || !isFocused) {
            return;
          }

          var _options = options,
              deferred = _options.deferred;

          if (!deferred) {
            setInputSelection$1(input, start, end);
          }

          if (_this.selectionDeferId !== null) {
            cancelDefer$1(_this.selectionDeferId);
          } // deferred selection update is required for pre-Lollipop Android browser,
          // but for consistent behavior we do it for all browsers


          _this.selectionDeferId = defer$1(function () {
            _this.selectionDeferId = null;
            setInputSelection$1(input, start, end);
          });
          _this.previousSelection = {
            start: start,
            end: end,
            length: Math.abs(end - start)
          };
        };

        _this.getSelection = function () {
          var input = _this.getInputDOMNode();

          return getInputSelection$1(input);
        };

        _this.getCursorPosition = function () {
          return _this.getSelection().start;
        };

        _this.setCursorPosition = function (pos) {
          _this.setSelection(pos, pos);
        };

        _this.isFocused = function () {
          return _this.focused;
        };

        _this.getBeforeMaskedValueChangeConfig = function () {
          var _this$maskOptions = _this.maskOptions,
              mask = _this$maskOptions.mask,
              maskChar = _this$maskOptions.maskChar,
              permanents = _this$maskOptions.permanents,
              formatChars = _this$maskOptions.formatChars;
          var alwaysShowMask = _this.props.alwaysShowMask;
          return {
            mask: mask,
            maskChar: maskChar,
            permanents: permanents,
            alwaysShowMask: !!alwaysShowMask,
            formatChars: formatChars
          };
        };

        _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
          var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
          // in case of autofill simulation in tests
          //
          // input.matches throws an exception if selector isn't supported


          try {
            if (input.matches(':-webkit-autofill')) {
              return true;
            }
          } catch (e) {} // if input isn't focused then change event must have been triggered
          // either by autofill or event simulation in tests


          if (!_this.focused) {
            return true;
          } // if cursor has moved to the end while previousSelection forbids it
          // then it must be autofill


          return previousSelection.end < previousValue.length && selection.end === value.length;
        };

        _this.onChange = function (event) {
          var _assertThisInitialize = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
              beforePasteState = _assertThisInitialize.beforePasteState;

          var _assertThisInitialize2 = _assertThisInitialized$2(_assertThisInitialized$2(_this)),
              previousSelection = _assertThisInitialize2.previousSelection;

          var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

          var value = _this.getInputValue();

          var previousValue = _this.value;

          var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
          // https://github.com/sanniassin/react-input-mask/issues/113


          if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
            previousValue = formatValue$1(_this.maskOptions, '');
            previousSelection = {
              start: 0,
              end: 0,
              length: 0
            };
          } // set value and selection as if we haven't
          // cleared input in onPaste handler


          if (beforePasteState) {
            previousSelection = beforePasteState.selection;
            previousValue = beforePasteState.value;
            selection = {
              start: previousSelection.start + value.length,
              end: previousSelection.start + value.length,
              length: 0
            };
            value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
            _this.beforePasteState = null;
          }

          var changedState = processChange$1(_this.maskOptions, value, selection, previousValue, previousSelection);
          var enteredString = changedState.enteredString;
          var newSelection = changedState.selection;
          var newValue = changedState.value;

          if (isFunction$1(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({
              value: newValue,
              selection: newSelection
            }, {
              value: previousValue,
              selection: previousSelection
            }, enteredString, _this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
            newSelection = modifiedValue.selection;
          }

          _this.setInputValue(newValue);

          if (isFunction$1(_this.props.onChange)) {
            _this.props.onChange(event);
          }

          if (_this.isWindowsPhoneBrowser) {
            _this.setSelection(newSelection.start, newSelection.end, {
              deferred: true
            });
          } else {
            _this.setSelection(newSelection.start, newSelection.end);
          }
        };

        _this.onFocus = function (event) {
          var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
          var _this$maskOptions2 = _this.maskOptions,
              mask = _this$maskOptions2.mask,
              prefix = _this$maskOptions2.prefix;
          _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

          _this.mounted = true;

          if (mask) {
            if (!_this.value) {
              var emptyValue = formatValue$1(_this.maskOptions, prefix);
              var newValue = formatValue$1(_this.maskOptions, emptyValue);
              var filledLength = getFilledLength$1(_this.maskOptions, newValue);
              var cursorPosition = getRightEditablePosition$1(_this.maskOptions, filledLength);
              var newSelection = {
                start: cursorPosition,
                end: cursorPosition
              };

              if (isFunction$1(beforeMaskedValueChange)) {
                var modifiedValue = beforeMaskedValueChange({
                  value: newValue,
                  selection: newSelection
                }, {
                  value: _this.value,
                  selection: null
                }, null, _this.getBeforeMaskedValueChangeConfig());
                newValue = modifiedValue.value;
                newSelection = modifiedValue.selection;
              }

              var isInputValueChanged = newValue !== _this.getInputValue();

              if (isInputValueChanged) {
                _this.setInputValue(newValue);
              }

              if (isInputValueChanged && isFunction$1(_this.props.onChange)) {
                _this.props.onChange(event);
              }

              _this.setSelection(newSelection.start, newSelection.end);
            } else if (getFilledLength$1(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
              _this.setCursorToEnd();
            }

            _this.runSaveSelectionLoop();
          }

          if (isFunction$1(_this.props.onFocus)) {
            _this.props.onFocus(event);
          }
        };

        _this.onBlur = function (event) {
          var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
          var mask = _this.maskOptions.mask;

          _this.stopSaveSelectionLoop();

          _this.focused = false;

          if (mask && !_this.props.alwaysShowMask && isEmpty$1(_this.maskOptions, _this.value)) {
            var newValue = '';

            if (isFunction$1(beforeMaskedValueChange)) {
              var modifiedValue = beforeMaskedValueChange({
                value: newValue,
                selection: null
              }, {
                value: _this.value,
                selection: _this.previousSelection
              }, null, _this.getBeforeMaskedValueChangeConfig());
              newValue = modifiedValue.value;
            }

            var isInputValueChanged = newValue !== _this.getInputValue();

            if (isInputValueChanged) {
              _this.setInputValue(newValue);
            }

            if (isInputValueChanged && isFunction$1(_this.props.onChange)) {
              _this.props.onChange(event);
            }
          }

          if (isFunction$1(_this.props.onBlur)) {
            _this.props.onBlur(event);
          }
        };

        _this.onMouseDown = function (event) {
          // tiny unintentional mouse movements can break cursor
          // position on focus, so we have to restore it in that case
          //
          // https://github.com/sanniassin/react-input-mask/issues/108
          if (!_this.focused && document.addEventListener) {
            _this.mouseDownX = event.clientX;
            _this.mouseDownY = event.clientY;
            _this.mouseDownTime = new Date().getTime();

            var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
              document.removeEventListener('mouseup', mouseUpHandler);

              if (!_this.focused) {
                return;
              }

              var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
              var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
              var axisDelta = Math.max(deltaX, deltaY);

              var timeDelta = new Date().getTime() - _this.mouseDownTime;

              if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
                _this.setCursorToEnd();
              }
            };

            document.addEventListener('mouseup', mouseUpHandler);
          }

          if (isFunction$1(_this.props.onMouseDown)) {
            _this.props.onMouseDown(event);
          }
        };

        _this.onPaste = function (event) {
          if (isFunction$1(_this.props.onPaste)) {
            _this.props.onPaste(event);
          } // event.clipboardData might not work in Android browser
          // cleaning input to get raw text inside onChange handler


          if (!event.defaultPrevented) {
            _this.beforePasteState = {
              value: _this.getInputValue(),
              selection: _this.getSelection()
            };

            _this.setInputValue('');
          }
        };

        _this.handleRef = function (ref) {
          if (_this.props.children == null && isFunction$1(_this.props.inputRef)) {
            _this.props.inputRef(ref);
          }
        };

        var _mask = props.mask,
            _maskChar = props.maskChar,
            _formatChars = props.formatChars,
            _alwaysShowMask = props.alwaysShowMask,
            _beforeMaskedValueChange = props.beforeMaskedValueChange;
        var defaultValue = props.defaultValue,
            _value = props.value;
        _this.maskOptions = parseMask$1(_mask, _maskChar, _formatChars);

        if (defaultValue == null) {
          defaultValue = '';
        }

        if (_value == null) {
          _value = defaultValue;
        }

        var _newValue = getStringValue$1(_value);

        if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
          _newValue = formatValue$1(_this.maskOptions, _newValue);

          if (isFunction$1(_beforeMaskedValueChange)) {
            var oldValue = props.value;

            if (props.value == null) {
              oldValue = defaultValue;
            }

            oldValue = getStringValue$1(oldValue);

            var modifiedValue = _beforeMaskedValueChange({
              value: _newValue,
              selection: null
            }, {
              value: oldValue,
              selection: null
            }, null, _this.getBeforeMaskedValueChangeConfig());

            _newValue = modifiedValue.value;
          }
        }

        _this.value = _newValue;
        return _this;
      }

      var _proto = InputElement.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this.mounted = true; // workaround for react-test-renderer
        // https://github.com/sanniassin/react-input-mask/issues/147

        if (!this.getInputDOMNode()) {
          return;
        }

        this.isWindowsPhoneBrowser = isWindowsPhoneBrowser$1();

        if (this.maskOptions.mask && this.getInputValue() !== this.value) {
          this.setInputValue(this.value);
        }
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        var previousSelection = this.previousSelection;
        var _this$props = this.props,
            beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
            alwaysShowMask = _this$props.alwaysShowMask,
            mask = _this$props.mask,
            maskChar = _this$props.maskChar,
            formatChars = _this$props.formatChars;
        var previousMaskOptions = this.maskOptions;
        var showEmpty = alwaysShowMask || this.isFocused();
        var hasValue = this.props.value != null;
        var newValue = hasValue ? getStringValue$1(this.props.value) : this.value;
        var cursorPosition = previousSelection ? previousSelection.start : null;
        this.maskOptions = parseMask$1(mask, maskChar, formatChars);

        if (!this.maskOptions.mask) {
          if (previousMaskOptions.mask) {
            this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
            // call forceUpdate to keep it in sync

            this.forceUpdate();
          }

          return;
        } else if (!previousMaskOptions.mask && this.isFocused()) {
          this.runSaveSelectionLoop();
        }

        var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

        if (!previousMaskOptions.mask && !hasValue) {
          newValue = this.getInputValue();
        }

        if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
          newValue = formatValue$1(this.maskOptions, newValue);
        }

        if (isMaskChanged) {
          var filledLength = getFilledLength$1(this.maskOptions, newValue);

          if (cursorPosition === null || filledLength < cursorPosition) {
            if (isFilled$1(this.maskOptions, newValue)) {
              cursorPosition = filledLength;
            } else {
              cursorPosition = getRightEditablePosition$1(this.maskOptions, filledLength);
            }
          }
        }

        if (this.maskOptions.mask && isEmpty$1(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
          newValue = '';
        }

        var newSelection = {
          start: cursorPosition,
          end: cursorPosition
        };

        if (isFunction$1(beforeMaskedValueChange)) {
          var modifiedValue = beforeMaskedValueChange({
            value: newValue,
            selection: newSelection
          }, {
            value: this.value,
            selection: this.previousSelection
          }, null, this.getBeforeMaskedValueChangeConfig());
          newValue = modifiedValue.value;
          newSelection = modifiedValue.selection;
        }

        this.value = newValue;
        var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
        // call forceUpdate to keep it in sync

        if (isValueChanged) {
          this.setInputValue(this.value);
          this.forceUpdate();
        } else if (isMaskChanged) {
          this.forceUpdate();
        }

        var isSelectionChanged = false;

        if (newSelection.start != null && newSelection.end != null) {
          isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
        }

        if (isSelectionChanged || isValueChanged) {
          this.setSelection(newSelection.start, newSelection.end);
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;

        if (this.selectionDeferId !== null) {
          cancelDefer$1(this.selectionDeferId);
        }

        this.stopSaveSelectionLoop();
      };

      _proto.render = function render() {
        var _this$props2 = this.props,
            mask = _this$props2.mask,
            alwaysShowMask = _this$props2.alwaysShowMask,
            maskChar = _this$props2.maskChar,
            formatChars = _this$props2.formatChars,
            inputRef = _this$props2.inputRef,
            beforeMaskedValueChange = _this$props2.beforeMaskedValueChange,
            children = _this$props2.children,
            restProps = _objectWithoutPropertiesLoose$2(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

        var inputElement;
        process.env.NODE_ENV !== "production" ? warning$1( // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !restProps.maxLength || !parseMask$1(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

        if (children) {
          !isFunction$1(children) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'react-input-mask: children must be a function') : invariant$2(false) : void 0;
          var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

          var childrenProps = _extends$2({}, restProps);

          controlledProps.forEach(function (propId) {
            return delete childrenProps[propId];
          });
          inputElement = children(childrenProps);
          var conflictProps = controlledProps.filter(function (propId) {
            return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
          });
          !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant$2(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant$2(false) : void 0;
          process.env.NODE_ENV !== "production" ? warning$1(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
        } else {
          inputElement = React$1.createElement("input", _extends$2({
            ref: this.handleRef
          }, restProps));
        }

        var changedProps = {
          onFocus: this.onFocus,
          onBlur: this.onBlur
        };

        if (this.maskOptions.mask) {
          if (!restProps.disabled && !restProps.readOnly) {
            changedProps.onChange = this.onChange;
            changedProps.onPaste = this.onPaste;
            changedProps.onMouseDown = this.onMouseDown;
          }

          if (restProps.value != null) {
            changedProps.value = this.value;
          }
        }

        inputElement = React$1.cloneElement(inputElement, changedProps);
        return inputElement;
      };

      return InputElement;
    }(React$1.Component);

    var reactInputMask_development = InputElement$1;

    var reactInputMask = createCommonjsModule(function (module) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = reactInputMask_production_min;
    } else {
      module.exports = reactInputMask_development;
    }
    });

    function MaskedInput(_a) {
        var className = _a.className, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.type, type = _f === void 0 ? 'tel' : _f, _g = _a.description, description = _g === void 0 ? '' : _g, _h = _a.error, error = _h === void 0 ? '' : _h, _j = _a.labelPosition, labelPosition = _j === void 0 ? 'beforeInput' : _j, _k = _a.mask, mask = _k === void 0 ? '' : _k, rest = __rest(_a, ["className", "name", "placeholder", "label", "disabled", "type", "description", "error", "labelPosition", "mask"]);
        return (React$2__default.createElement(StyledFieldWrapper, { className: className, name: name, label: label, labelPosition: labelPosition, description: description, error: error },
            React$2__default.createElement(reactInputMask, __assign({ type: type, mask: mask }, getCommonFieldProps({
                name: name,
                placeholder: placeholder,
                disabled: disabled,
            }), rest))));
    }
    var StyledMaskedInput = styled__default(MaskedInput)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject([""], [""])));
    var templateObject_1$7;

    function RadioButton(_a) {
        var className = _a.className, label = _a.label, rest = __rest(_a, ["className", "label"]);
        return (React$2__default.createElement("div", { className: className },
            React$2__default.createElement("input", __assign({ type: "radio" }, rest)),
            label ? (React$2__default.createElement("label", { htmlFor: rest.id },
                React$2__default.createElement("span", null),
                label)) : null));
    }
    var StyledRadioButton = styled__default(RadioButton)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  ", ";\n\n  input[type='radio'] {\n    display: none;\n\n    + label {\n      position: relative;\n      display: flex;\n      font-size: 15px;\n      line-height: 22px;\n      color: #000;\n      cursor: pointer;\n\n      span {\n        display: inline-block;\n        width: 24px;\n        min-width: 24px;\n        height: 24px;\n        min-height: 24px;\n        margin-right: 12px;\n        background-color: #fff;\n        border: 1px solid #dcdcdc;\n        border-radius: 50%;\n        transition: 0.2s;\n      }\n    }\n\n    &:checked {\n      + label span {\n        border: 2px solid palevioletred;\n\n        &::after {\n          position: absolute;\n          top: 7px;\n          left: 7px;\n          width: 10px;\n          height: 10px;\n          content: '';\n          background-color: palevioletred;\n          border-radius: 50%;\n        }\n      }\n    }\n  }\n\n  &:hover {\n    input[type='radio'] + label span {\n      border: 2px solid palevioletred;\n    }\n  }\n"], ["\n  ",
        ";\n\n  input[type='radio'] {\n    display: none;\n\n    + label {\n      position: relative;\n      display: flex;\n      font-size: 15px;\n      line-height: 22px;\n      color: #000;\n      cursor: pointer;\n\n      span {\n        display: inline-block;\n        width: 24px;\n        min-width: 24px;\n        height: 24px;\n        min-height: 24px;\n        margin-right: 12px;\n        background-color: #fff;\n        border: 1px solid #dcdcdc;\n        border-radius: 50%;\n        transition: 0.2s;\n      }\n    }\n\n    &:checked {\n      + label span {\n        border: 2px solid palevioletred;\n\n        &::after {\n          position: absolute;\n          top: 7px;\n          left: 7px;\n          width: 10px;\n          height: 10px;\n          content: '';\n          background-color: palevioletred;\n          border-radius: 50%;\n        }\n      }\n    }\n  }\n\n  &:hover {\n    input[type='radio'] + label span {\n      border: 2px solid palevioletred;\n    }\n  }\n"])), function (props) {
        return props.disabled && styled.css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n      pointer-events: none;\n\n      label {\n        opacity: 0.4;\n      }\n\n      span {\n        background-color: #f7f7f7;\n      }\n    "], ["\n      pointer-events: none;\n\n      label {\n        opacity: 0.4;\n      }\n\n      span {\n        background-color: #f7f7f7;\n      }\n    "])));
    });
    var templateObject_1$8, templateObject_2$3;

    function RadioGroup(_a) {
        var className = _a.className, group = _a.group, title = _a.title, description = _a.description;
        return (React$2__default.createElement("div", { className: className },
            Boolean(title) && (React$2__default.createElement("div", { className: "header" },
                title ? React$2__default.createElement("h3", { className: "title" }, title) : null,
                description ? React$2__default.createElement("p", { className: "description" }, description) : null)),
            React$2__default.createElement("div", { className: "radio-group" }, group.map(function (item, index) { return (React$2__default.createElement(StyledRadioButton, __assign({ key: index }, item))); }))));
    }
    var StyledRadioGroup = styled__default(RadioGroup)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  .header {\n    margin-bottom: 19px;\n  }\n\n  .description {\n    margin-top: 8px;\n    font-size: 15px;\n    line-height: 24px;\n    color: rgba(0, 0, 0, 0.4);\n  }\n\n  .radio-group {\n    display: flex;\n    flex-direction: ", ";\n    flex-wrap: wrap;\n  }\n\n  ", ";\n"], ["\n  .header {\n    margin-bottom: 19px;\n  }\n\n  .description {\n    margin-top: 8px;\n    font-size: 15px;\n    line-height: 24px;\n    color: rgba(0, 0, 0, 0.4);\n  }\n\n  .radio-group {\n    display: flex;\n    flex-direction: ",
        ";\n    flex-wrap: wrap;\n  }\n\n  ",
        ";\n"])), function (_a) {
        var _b = _a.horizontal, horizontal = _b === void 0 ? false : _b;
        return horizontal ? 'row' : 'column';
    }, function (_a) {
        var horizontal = _a.horizontal;
        return !horizontal
            ? styled.css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n          .radio-group > div {\n            margin-bottom: 16px;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n        "], ["\n          .radio-group > div {\n            margin-bottom: 16px;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n        "]))) : styled.css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n          .radio-group > div {\n            flex: 1;\n          }\n        "], ["\n          .radio-group > div {\n            flex: 1;\n          }\n        "])));
    });
    var templateObject_1$9, templateObject_2$4, templateObject_3$2;

    function Checkbox(_a) {
        var className = _a.className, _b = _a.checked, checked = _b === void 0 ? false : _b, children = _a.children, onChange = _a.onChange, error = _a.error, checkMarkIcon = _a.checkMarkIcon;
        return (React$2__default.createElement("div", { className: className },
            React$2__default.createElement("div", { className: "checkbox " + (checked ? 'checked' : '') + " " + (error ? 'checkbox-error' : ''), role: "checkbox", "aria-checked": checked, onClick: onChange },
                React$2__default.createElement("div", { className: "check-area" }, checked && !error && React$2__default.createElement("img", { src: checkMarkIcon, alt: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E" })),
                children ? React$2__default.createElement("p", { className: "label" }, children) : null)));
    }
    var StyledCheckbox = styled__default(Checkbox)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  .check-area {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    min-width: 24px;\n    height: 24px;\n    min-height: 24px;\n    margin-right: 12px;\n    background-color: #fff;\n    border: 1px solid #dcdcdc;\n    transition: 0.2s ease;\n  }\n\n  .label {\n    font-size: 15px;\n    line-height: 1.6;\n    color: #000;\n  }\n\n  .checkbox {\n    display: flex;\n    align-items: flex-start;\n    cursor: pointer;\n\n    &:hover {\n      .check-area {\n        border: 2px solid ", ";\n      }\n    }\n\n    &.checked {\n      > .check-area {\n        border: 2px solid ", ";\n      }\n    }\n\n    &:not(.checked).checkbox-error {\n      > .check-area {\n        border: 1px solid #f30;\n      }\n\n      &:hover {\n        .check-area {\n          border: 2px solid #f30;\n        }\n      }\n    }\n  }\n"], ["\n  .check-area {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    min-width: 24px;\n    height: 24px;\n    min-height: 24px;\n    margin-right: 12px;\n    background-color: #fff;\n    border: 1px solid #dcdcdc;\n    transition: 0.2s ease;\n  }\n\n  .label {\n    font-size: 15px;\n    line-height: 1.6;\n    color: #000;\n  }\n\n  .checkbox {\n    display: flex;\n    align-items: flex-start;\n    cursor: pointer;\n\n    &:hover {\n      .check-area {\n        border: 2px solid ", ";\n      }\n    }\n\n    &.checked {\n      > .check-area {\n        border: 2px solid ", ";\n      }\n    }\n\n    &:not(.checked).checkbox-error {\n      > .check-area {\n        border: 1px solid #f30;\n      }\n\n      &:hover {\n        .check-area {\n          border: 2px solid #f30;\n        }\n      }\n    }\n  }\n"])), function (props) { return props.theme.cyan; }, function (props) { return props.theme.cyan; });
    var templateObject_1$a;

    function List(_a) {
        var id = _a.id, name = _a.name, items = _a.items, className = _a.className, renderItem = _a.renderItem, getMenuProps = _a.getMenuProps, getItemProps = _a.getItemProps, listMaxHeight = _a.listMaxHeight, highlightedIndex = _a.highlightedIndex;
        var _b = React$2.useState(0), menuHeight = _b[0], setMenuHeight = _b[1];
        React$2.useEffect(function () {
            var getHeight = function () {
                var liElements = Array.from(document.querySelectorAll("#" + id + "-menu li"));
                if (liElements.length > 0) {
                    var allItemsHeight = liElements
                        .map(function (li) { return li.offsetHeight; })
                        .reduce(function (a, b) { return a + b; }, 0);
                    setMenuHeight(allItemsHeight);
                }
            };
            getHeight();
        }, [items, id]);
        return (React$2__default.createElement("ul", __assign({}, getMenuProps({
            id: id + "-menu",
            className: className + " list",
        }, { suppressRefError: true })),
            React$2__default.createElement(lib_1, { style: {
                    backgroundColor: '#fff',
                    height: menuHeight > listMaxHeight ? listMaxHeight : menuHeight,
                } }, items.map(function (item, index) { return (React$2__default.createElement("li", __assign({}, getItemProps({
                item: item,
                index: index,
                key: name + "-" + index,
                className: "item " + (highlightedIndex === index ? 'selected' : ''),
            })), renderItem
                ? renderItem({ label: item.label, value: item.value })
                : item.label)); }))));
    }
    var StyledList = styled__default(List)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
        "\n"])), function (_a) {
        var styleType = _a.styleType;
        return styleType === 'lightGrey' ? getLightGreyStyles$1() : null;
    });
    function getLightGreyStyles$1() {
        return styled.css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n    position: absolute;\n    top: 48px;\n    z-index: 10;\n    width: 100%;\n    max-height: 194px;\n    overflow: hidden;\n    border: 2px solid #000;\n    border-top: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    li {\n      display: flex;\n      align-items: center;\n      padding: 14.5px 14px;\n      font-size: 15px;\n      line-height: 19px;\n      color: #000;\n      cursor: pointer;\n      background-color: #fff;\n      transition: 0.2s;\n\n      &.selected {\n        background-color: #f6f6f6;\n      }\n    }\n  "], ["\n    position: absolute;\n    top: 48px;\n    z-index: 10;\n    width: 100%;\n    max-height: 194px;\n    overflow: hidden;\n    border: 2px solid #000;\n    border-top: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    li {\n      display: flex;\n      align-items: center;\n      padding: 14.5px 14px;\n      font-size: 15px;\n      line-height: 19px;\n      color: #000;\n      cursor: pointer;\n      background-color: #fff;\n      transition: 0.2s;\n\n      &.selected {\n        background-color: #f6f6f6;\n      }\n    }\n  "])));
    }
    var templateObject_1$b, templateObject_2$5;

    function Select(_a) {
        var items = _a.items, name = _a.name, countReset = _a.countReset, OpenIcon = _a.OpenIcon, className = _a.className, styleType = _a.styleType, CloseIcon = _a.CloseIcon, _b = _a.error, error = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, selectItem = _a.selectItem, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.description, description = _e === void 0 ? '' : _e, isBig = _a.isBig, _f = _a.listMaxHeight, listMaxHeight = _f === void 0 ? 194 : _f, labelPosition = _a.labelPosition, initialValue = _a.initialValue, disabled = _a.disabled;
        var renderIcons = function () {
            if (isOpen) {
                return OpenIcon ? (OpenIcon) : (React$2__default.createElement("img", { alt: "", src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOCAxNEwxMiA4TDYgMTQiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPg0KPC9zdmc+DQo=" }));
            }
            return CloseIcon ? (CloseIcon) : (React$2__default.createElement("img", { alt: "", src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik02IDEwTDEyIDE2TDE4IDEwIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4NCjwvc3ZnPg0K" }));
        };
        var _g = Downshift.useSelect({
            items: items,
            onSelectedItemChange: function (_a) {
                var selectedItem = _a.selectedItem;
                if (typeof selectItem === 'function' && selectedItem)
                    selectItem(selectedItem);
            },
        }), isOpen = _g.isOpen, selectedItem = _g.selectedItem, getMenuProps = _g.getMenuProps, getItemProps = _g.getItemProps, highlightedIndex = _g.highlightedIndex, getToggleButtonProps = _g.getToggleButtonProps, reset = _g.reset;
        React$2.useEffect(function () {
            countReset && reset();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [countReset]);
        return (React$2__default.createElement(StyledFieldWrapper, { className: className, name: name, label: label, isBig: isBig, labelPosition: labelPosition, description: description, error: error, styleType: styleType, disabled: disabled },
            React$2__default.createElement("a", __assign({ role: "button", className: "input select-button" + (isOpen ? ' active' : '') }, getToggleButtonProps()),
                selectedItem
                    ? selectedItem.label
                    : initialValue || React$2__default.createElement("div", { className: "placeholder" }, placeholder),
                renderIcons()),
            isOpen && (React$2__default.createElement(StyledList, { id: name, name: name, items: items, styleType: styleType, getMenuProps: getMenuProps, getItemProps: getItemProps, listMaxHeight: listMaxHeight, highlightedIndex: highlightedIndex }))));
    }
    var StyledSelect = styled__default(Select)(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  pointer-events: ", ";\n  cursor: pointer;\n  user-select: none;\n\n  .select-button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n  }\n\n  ", "\n"], ["\n  pointer-events: ", ";\n  cursor: pointer;\n  user-select: none;\n\n  .select-button {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n  }\n\n  ",
        "\n"])), function (_a) {
        var disabled = _a.disabled;
        return (disabled ? 'none' : 'initial');
    }, function (_a) {
        var styleType = _a.styleType, isBig = _a.isBig;
        return styleType === 'lightGrey' ? getLightGreyStyles$2(isBig) : null;
    });
    function getLightGreyStyles$2(isBig) {
        return styled.css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n    .select-button {\n      position: relative;\n      width: 100%;\n      text-align: left;\n      cursor: pointer;\n    }\n\n    .active {\n      box-sizing: border-box;\n      padding: 0 17px;\n      border: 2px solid #000 !important;\n    }\n\n    .placeholder {\n      font-size: 15px;\n      color: #9b9b9b;\n      text-align: left;\n    }\n\n    .list {\n      top: ", ";\n      max-height: ", ";\n\n      li {\n        height: ", ";\n        padding: 0 ", ";\n      }\n    }\n  "], ["\n    .select-button {\n      position: relative;\n      width: 100%;\n      text-align: left;\n      cursor: pointer;\n    }\n\n    .active {\n      box-sizing: border-box;\n      padding: 0 17px;\n      border: 2px solid #000 !important;\n    }\n\n    .placeholder {\n      font-size: 15px;\n      color: #9b9b9b;\n      text-align: left;\n    }\n\n    .list {\n      top: ", ";\n      max-height: ", ";\n\n      li {\n        height: ", ";\n        padding: 0 ", ";\n      }\n    }\n  "])), isBig ? '60px' : '48px', isBig ? '240px' : '194px', isBig ? '60px' : '48px', isBig ? '18px' : '14px');
    }
    var templateObject_1$c, templateObject_2$6;

    var defaultFilterFn = function (label, value) {
        return label.toLowerCase().includes(value.toLowerCase());
    };
    var defaultItemToString = function (item) { return (item ? item.label : ''); };
    function Autocomplete(_a) {
        var name = _a.name, items = _a.items, className = _a.className, styleType = _a.styleType, _b = _a.label, label = _b === void 0 ? '' : _b, selectItem = _a.selectItem, isBig = _a.isBig, _c = _a.error, error = _c === void 0 ? '' : _c, renderItem = _a.renderItem, labelPosition = _a.labelPosition, _d = _a.description, description = _d === void 0 ? '' : _d, _e = _a.id, id = _e === void 0 ? 'autocomplete' : _e, _f = _a.listMaxHeight, listMaxHeight = _f === void 0 ? 194 : _f, _g = _a.withoutFilters, withoutFilters = _g === void 0 ? false : _g, _h = _a.filterFn, filterFn = _h === void 0 ? defaultFilterFn : _h, _j = _a.initialSelectedItem, initialSelectedItem = _j === void 0 ? null : _j, inputValueFromProps = _a.inputValue, _k = _a.itemToString, itemToString = _k === void 0 ? defaultItemToString : _k, rest = __rest(_a, ["name", "items", "className", "styleType", "label", "selectItem", "isBig", "error", "renderItem", "labelPosition", "description", "id", "listMaxHeight", "withoutFilters", "filterFn", "initialSelectedItem", "inputValue", "itemToString"]);
        var generateRandomName = function () {
            var randomText = '';
            var possible = 'abcdefghijklmnopqrstuvwxyz';
            for (var i = 0; i < 8; i++)
                randomText += possible.charAt(Math.floor(Math.random() * possible.length));
            return randomText;
        };
        var getFilteredItems = function (value, cb) {
            if (withoutFilters)
                return items;
            var filteredItems = items;
            if (value)
                filteredItems = items.filter(function (item) { return filterFn(itemToString(item), value); });
            if (typeof cb === 'function')
                cb(filteredItems);
            return filteredItems;
        };
        return (React$2__default.createElement("div", { className: className },
            React$2__default.createElement(Downshift__default, { onSelect: selectItem, itemToString: itemToString, initialSelectedItem: initialSelectedItem, id: id, labelId: name + "-label", inputId: name }, function (_a) {
                var isOpen = _a.isOpen, openMenu = _a.openMenu, inputValue = _a.inputValue, getMenuProps = _a.getMenuProps, getItemProps = _a.getItemProps, getInputProps = _a.getInputProps, highlightedIndex = _a.highlightedIndex;
                return (React$2__default.createElement("div", { className: "root" },
                    React$2__default.createElement(StyledFieldWrapper, { name: name, isBig: isBig, label: label, error: error, styleType: styleType, description: description, labelPosition: labelPosition },
                        React$2__default.createElement("input", __assign({}, getInputProps(__assign(__assign({}, rest), { id: id,
                            name: name, className: 'input', autoComplete: 'fuck', value: typeof inputValueFromProps === 'string'
                                ? inputValueFromProps // Если пункт введен в инпут
                                : inputValueFromProps && inputValueFromProps.label, onBlur: function (e) {
                                e.currentTarget.name = generateRandomName();
                                if (typeof rest.onBlur === 'function')
                                    rest.onBlur(e);
                            }, onFocus: function (e) {
                                e.currentTarget.name = generateRandomName();
                                if (typeof rest.onFocus === 'function')
                                    rest.onFocus(e);
                                openMenu();
                            }, onKeyDown: function (e) {
                                if (e.key === 'Escape')
                                    e.nativeEvent['preventDownshiftEvent'] = true;
                            } }))))),
                    isOpen && inputValue && getFilteredItems(inputValue).length > 0 ? (React$2__default.createElement(StyledList, { getMenuProps: getMenuProps, getItemProps: getItemProps, items: getFilteredItems(inputValue), highlightedIndex: highlightedIndex, name: name, id: id, listMaxHeight: listMaxHeight, renderItem: renderItem })) : null));
            })));
    }
    var StyledAutocomplete = styled__default(Autocomplete)(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  ul {\n    position: absolute;\n    top: ", ";\n    z-index: 10;\n    width: 100%;\n    max-height: ", ";\n    overflow: hidden;\n    border: 2px solid #000;\n    border-top: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    height: ", ";\n    padding: 0 ", ";\n    font-size: 15px;\n    line-height: 19px;\n    color: #000;\n    cursor: pointer;\n    background-color: #fff;\n    transition: 0.2s;\n\n    &.selected {\n      background-color: #f6f6f6;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  ul {\n    position: absolute;\n    top: ", ";\n    z-index: 10;\n    width: 100%;\n    max-height: ", ";\n    overflow: hidden;\n    border: 2px solid #000;\n    border-top: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    height: ", ";\n    padding: 0 ", ";\n    font-size: 15px;\n    line-height: 19px;\n    color: #000;\n    cursor: pointer;\n    background-color: #fff;\n    transition: 0.2s;\n\n    &.selected {\n      background-color: #f6f6f6;\n    }\n  }\n"])), function (_a) {
        var isBig = _a.isBig;
        return (isBig ? '60px' : '48px');
    }, function (_a) {
        var isBig = _a.isBig;
        return (isBig ? '240px' : '194px');
    }, function (_a) {
        var isBig = _a.isBig;
        return (isBig ? '60px' : '48px');
    }, function (_a) {
        var isBig = _a.isBig;
        return (isBig ? '18px' : '14px');
    });
    var templateObject_1$d;

    var Spinner = function (_a) {
        var color = _a.color, className = _a.className, rest = __rest(_a, ["color", "className"]);
        return (React$2__default.createElement("svg", __assign({ className: className, viewBox: "0 0 50 50" }, rest),
            React$2__default.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "2" })));
    };
    var StyledSpinner = styled__default(Spinner)(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  ", "\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 150;\n      stroke-dashoffset: 0;\n    }\n\n    50% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -35;\n    }\n\n    100% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -124;\n    }\n  }\n"], ["\n  ",
        "\n\n  @keyframes rotate {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 150;\n      stroke-dashoffset: 0;\n    }\n\n    50% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -35;\n    }\n\n    100% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -124;\n    }\n  }\n"])), function (_a) {
        var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.width, width = _c === void 0 ? 8 : _c, _d = _a.color, color = _d === void 0 ? '#fff' : _d;
        return styled.css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    margin: 8px;\n    animation: rotate 2s linear infinite;\n\n    .path {\n      stroke-width: ", "px;\n      stroke: ", ";\n      stroke-linecap: round;\n      animation: dash 1.5s ease-in-out infinite;\n    }\n  "], ["\n    width: ", "px;\n    height: ", "px;\n    margin: 8px;\n    animation: rotate 2s linear infinite;\n\n    .path {\n      stroke-width: ", "px;\n      stroke: ", ";\n      stroke-linecap: round;\n      animation: dash 1.5s ease-in-out infinite;\n    }\n  "])), size, size, width, color);
    });
    var templateObject_1$e, templateObject_2$7;

    var Button = React$2.forwardRef(function (_a, ref) {
        var children = _a.children, className = _a.className, width = _a.width, size = _a.size, isLoader = _a.isLoader, disabled = _a.disabled, isLink = _a.isLink, href = _a.href, loaderText = _a.loaderText, rest = __rest(_a, ["children", "className", "width", "size", "isLoader", "disabled", "isLink", "href", "loaderText"]);
        if (isLink) {
            if (href) {
                return (React$2__default.createElement("a", __assign({ href: href, className: className }, rest), children));
            }
            else {
                return (React$2__default.createElement("a", __assign({ className: className }, rest), children));
            }
        }
        return (React$2__default.createElement("button", __assign({ ref: ref, className: className, disabled: disabled || isLoader }, rest), isLoader ? (React$2__default.createElement(React$2__default.Fragment, null,
            React$2__default.createElement(StyledSpinner, null),
            loaderText || 'Загружаем...')) : (children)));
    });
    var fixedWidth = function (width) { return styled.css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  width: ", "px;\n  padding: 0;\n"], ["\n  width: ", "px;\n  padding: 0;\n"])), width); };
    var dynamicWidth = function (size) { return styled.css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  padding: 0 ", ";\n\n  @media (max-width: 767px) {\n    width: 100%;\n  }\n"], ["\n  padding: 0 ", ";\n\n  @media (max-width: 767px) {\n    width: 100%;\n  }\n"])), size === 'large' ? '40px' : size === 'medium' ? '30px' : '12px'); };
    var primaryColorPressed = function () { return styled.css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  color: #fff;\n  background: ", " !important;\n"], ["\n  color: #fff;\n  background: ", " !important;\n"])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primaryPressed;
    }); };
    var primaryColor = function () { return styled.css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  color: ", ";\n  border: 2px solid ", ";\n\n  :hover {\n    color: #fff;\n    background: ", ";\n  }\n\n  :active {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  border: 2px solid ", ";\n\n  :hover {\n    color: #fff;\n    background: ", ";\n  }\n\n  :active {\n    ", "\n  }\n\n  ", "\n"])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, primaryColorPressed(), function (_a) {
        var isLoader = _a.isLoader;
        return isLoader && primaryColorPressed();
    }); };
    var accentColorPressed = function () { return styled.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", " !important;\n"], ["\n  background: ", " !important;\n"])), function (_a) {
        var theme = _a.theme;
        return theme.colors.accentPressed;
    }); };
    var accentColor = function () { return styled.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: #fff;\n  background: ", ";\n\n  :hover {\n    background: ", ";\n  }\n\n  :active {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: #fff;\n  background: ", ";\n\n  :hover {\n    background: ", ";\n  }\n\n  :active {\n    ", "\n  }\n\n  ", "\n"])), function (_a) {
        var theme = _a.theme;
        return theme.colors.accent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.accentHover;
    }, accentColorPressed(), function (_a) {
        var isLoader = _a.isLoader;
        return isLoader && accentColorPressed();
    }); };
    var StyledButton = styled__default(Button)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  font-family: ", ";\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 18px;\n  cursor: ", ";\n  transition: 0.2s ease;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ",
        ";\n  font-family: ", ";\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 18px;\n  cursor: ",
        ";\n  transition: 0.2s ease;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"])), function (_a) {
        var size = _a.size;
        if (size === 'large')
            return '60px';
        else if (size === 'medium')
            return '48px';
        else if (size === 'small')
            return '40px';
        else
            return '48px';
    }, function (_a) {
        var theme = _a.theme;
        return theme.fonts.main;
    }, function (_a) {
        var disabled = _a.disabled, isLoader = _a.isLoader;
        return disabled || isLoader ? 'initial' : 'pointer';
    }, function (_a) {
        var _b = _a.width, width = _b === void 0 ? 'dynamic' : _b, _c = _a.size, size = _c === void 0 ? 'large' : _c;
        if (width === 'dynamic')
            return dynamicWidth(size);
        else
            return fixedWidth(width);
    }, function (_a) {
        var color = _a.color;
        if (color === 'accent')
            return accentColor();
        if (color === 'primary')
            return primaryColor();
        return styled.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      color: #000;\n    "], ["\n      color: #000;\n    "])));
    }, function (_a) {
        var disabled = _a.disabled;
        return disabled && styled.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      opacity: 0.4;\n      pointer-events: none;\n    "], ["\n      opacity: 0.4;\n      pointer-events: none;\n    "])));
    }, function (_a) {
        var href = _a.href;
        return href && styled.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-decoration: none;\n    "], ["\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-decoration: none;\n    "])));
    });
    var templateObject_1$f, templateObject_2$8, templateObject_3$3, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

    function TooltipFbk(_a) {
        var position = _a.position, popperOptions = _a.popperOptions, children = _a.children, rest = __rest(_a, ["position", "popperOptions", "children"]);
        var options = __assign({ placement: position || 'top-start', modifiers: {
                preventOverflow: {
                    boundariesElement: 'viewport',
                    enabled: false,
                },
                hide: { enabled: false },
                flip: { enabled: false },
            } }, popperOptions);
        return (React$2__default.createElement(reactTippy.Tooltip, __assign({ popperOptions: options }, rest), children));
    }

    var getYoutubeId = createCommonjsModule(function (module, exports) {
    (function (root, factory) {
      {
        module.exports = factory();
      }
    }(commonjsGlobal, function (exports) {

      return function (url, opts) {
        if (opts == undefined) {
          opts = {fuzzy: true};
        }

        if (/youtu\.?be/.test(url)) {

          // Look first for known patterns
          var i;
          var patterns = [
            /youtu\.be\/([^#\&\?]{11})/,  // youtu.be/<id>
            /\?v=([^#\&\?]{11})/,         // ?v=<id>
            /\&v=([^#\&\?]{11})/,         // &v=<id>
            /embed\/([^#\&\?]{11})/,      // embed/<id>
            /\/v\/([^#\&\?]{11})/         // /v/<id>
          ];

          // If any pattern matches, return the ID
          for (i = 0; i < patterns.length; ++i) {
            if (patterns[i].test(url)) {
              return patterns[i].exec(url)[1];
            }
          }

          if (opts.fuzzy) {
            // If that fails, break it apart by certain characters and look 
            // for the 11 character key
            var tokens = url.split(/[\/\&\?=#\.\s]/g);
            for (i = 0; i < tokens.length; ++i) {
              if (/^[^#\&\?]{11}$/.test(tokens[i])) {
                return tokens[i];
              }
            }
          }
        }

        return null;
      };

    }));
    });

    function getYouTubeThumbnail(url, size) {
        if (size === void 0) { size = 'maxres'; }
        var id = getYoutubeId(url);
        if (!id && url.length === 11) {
            id = url;
        }
        var base = 'https://i3.ytimg.com/vi/' + id;
        return base + "/" + size + "default.jpg";
    }
    function VideoThumbnail(_a) {
        var className = _a.className, url = _a.url, size = _a.size, _b = _a.openVideo, openVideo = _b === void 0 ? function () { } : _b;
        return (React$2__default.createElement("div", { className: className, onClick: openVideo },
            React$2__default.createElement(StyledAspectRatioWrapper, { aspectRatio: "16 / 9", className: "cover-wrapper" },
                React$2__default.createElement("div", { className: "image", style: {
                        backgroundImage: "url(" + getYouTubeThumbnail(url, size) + ")",
                    } }))));
    }
    var StyledVideoThumbnail = styled__default(VideoThumbnail)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  width: 100%;\n  cursor: pointer;\n\n  .cover-wrapper {\n    &::after {\n      position: absolute;\n      top: calc(50% - 30px);\n      left: calc(50% - 30px);\n      display: ", ";\n      width: 60px;\n      height: 60px;\n      content: '';\n      background: #fff;\n      background-image: ", ";\n      background-repeat: no-repeat;\n      background-position: 23px center;\n      border-radius: 50%;\n      box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);\n    }\n  }\n"], ["\n  width: 100%;\n  cursor: pointer;\n\n  .cover-wrapper {\n    &::after {\n      position: absolute;\n      top: calc(50% - 30px);\n      left: calc(50% - 30px);\n      display: ",
        ";\n      width: 60px;\n      height: 60px;\n      content: '';\n      background: #fff;\n      background-image: ",
        ";\n      background-repeat: no-repeat;\n      background-position: 23px center;\n      border-radius: 50%;\n      box-shadow: 0 6px 30px rgba(0, 0, 0, 0.2);\n    }\n  }\n"])), function (_a) {
        var hiddenPlayIcon = _a.hiddenPlayIcon;
        return hiddenPlayIcon ? 'none' : 'block';
    }, function (_a) {
        var _b = _a.playIconSrc, playIconSrc = _b === void 0 ? 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3IDEwTDAgMjBWMGwxNyAxMHoiIGZpbGw9IiNGRjQzNDMiLz48L3N2Zz4=' : _b;
        return "url(" + playIconSrc + ")";
    });
    var templateObject_1$g;

    function getSrcVideo(url) {
        if (!url)
            return;
        var id = getYoutubeId(url);
        if (url.length === 11)
            id = url;
        return 'https://www.youtube.com/embed/' + id + '?autoplay=1';
    }
    function VideoInModal(_a) {
        var url = _a.url, isModalOpen = _a.isModalOpen, closeVideo = _a.closeVideo, className = _a.className, _b = _a.closeIconSrc, closeIconSrc = _b === void 0 ? 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgMThMMTggNk0xOCAxOEw2IDYiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+' : _b;
        return (React$2__default.createElement(StyledModal, { className: className, isOpen: isModalOpen, onClose: closeVideo }, function () { return (React$2__default.createElement("div", null,
            React$2__default.createElement("button", { type: "button", className: "close", onClick: closeVideo },
                React$2__default.createElement("img", { className: "close-icon", src: closeIconSrc, alt: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" })),
            React$2__default.createElement(StyledAspectRatioWrapper, { aspectRatio: "16 / 9" },
                React$2__default.createElement("iframe", { title: "video", width: "100%", height: "100%", frameBorder: "0", src: getSrcVideo(url) })))); }));
    }
    var StyledModal$1 = styled__default(VideoInModal)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  background-color: rgba(0, 5, 31, 0.5);\n\n  .modal {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n\n    @media (min-width: 768px) {\n      max-width: 688px;\n    }\n\n    @media (min-width: 1200px) {\n      max-width: 960px;\n    }\n  }\n\n  .close {\n    position: absolute;\n    top: calc(-48px - 16px);\n    right: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    cursor: pointer;\n    background-color: rgba(0, 5, 31, 0.5);\n    border: none;\n    outline: transparent;\n\n    @media (min-width: 768px) {\n      right: 0;\n    }\n\n    @media (min-width: 1200px) {\n      top: 0;\n      right: calc(-48px - 52px);\n    }\n\n    .close-icon {\n      min-width: 26px;\n      min-height: 26px;\n    }\n  }\n"], ["\n  background-color: rgba(0, 5, 31, 0.5);\n\n  .modal {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n\n    @media (min-width: 768px) {\n      max-width: 688px;\n    }\n\n    @media (min-width: 1200px) {\n      max-width: 960px;\n    }\n  }\n\n  .close {\n    position: absolute;\n    top: calc(-48px - 16px);\n    right: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    cursor: pointer;\n    background-color: rgba(0, 5, 31, 0.5);\n    border: none;\n    outline: transparent;\n\n    @media (min-width: 768px) {\n      right: 0;\n    }\n\n    @media (min-width: 1200px) {\n      top: 0;\n      right: calc(-48px - 52px);\n    }\n\n    .close-icon {\n      min-width: 26px;\n      min-height: 26px;\n    }\n  }\n"])));
    var templateObject_1$h;

    var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

    function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

    function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

    function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

    // require('hammerjs') when in a browser. This is safe because Hammer is only
    // invoked in componentDidMount, which is not executed on the server.
    var Hammer = typeof window !== 'undefined' ? require('hammerjs') : undefined;

    var privateProps = {
    	children: true,
    	direction: true,
    	options: true,
    	recognizeWith: true,
    	vertical: true
    };

    /**
     * Hammer Component
     * ================
     */

    var handlerToEvent = {
    	action: 'tap press',
    	onDoubleTap: 'doubletap',
    	onPan: 'pan',
    	onPanCancel: 'pancancel',
    	onPanEnd: 'panend',
    	onPanStart: 'panstart',
    	onPinch: 'pinch',
    	onPinchCancel: 'pinchcancel',
    	onPinchEnd: 'pinchend',
    	onPinchIn: 'pinchin',
    	onPinchOut: 'pinchout',
    	onPinchStart: 'pinchstart',
    	onPress: 'press',
    	onPressUp: 'pressup',
    	onRotate: 'rotate',
    	onRotateCancel: 'rotatecancel',
    	onRotateEnd: 'rotateend',
    	onRotateMove: 'rotatemove',
    	onRotateStart: 'rotatestart',
    	onSwipe: 'swipe',
    	onSwipeRight: 'swiperight',
    	onSwipeLeft: 'swipeleft',
    	onSwipeUp: 'swipeup',
    	onSwipeDown: 'swipedown',
    	onTap: 'tap'
    };

    Object.keys(handlerToEvent).forEach(function (i) {
    	privateProps[i] = true;
    });

    function updateHammer(hammer, props) {
    	if (props.hasOwnProperty('vertical')) {
    		console.warn('vertical is deprecated, please use `direction` instead');
    	}

    	var directionProp = props.direction;
    	if (directionProp || props.hasOwnProperty('vertical')) {
    		var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
    		hammer.get('pan').set({ direction: Hammer[direction] });
    		hammer.get('swipe').set({ direction: Hammer[direction] });
    	}

    	if (props.options) {
    		Object.keys(props.options).forEach(function (option) {
    			if (option === 'recognizers') {
    				Object.keys(props.options.recognizers).forEach(function (gesture) {
    					var recognizer = hammer.get(gesture);
    					recognizer.set(props.options.recognizers[gesture]);
    					if (props.options.recognizers[gesture].requireFailure) {
    						recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
    					}
    				}, this);
    			} else {
    				var key = option;
    				var optionObj = {};
    				optionObj[key] = props.options[option];
    				hammer.set(optionObj);
    			}
    		}, this);
    	}

    	if (props.recognizeWith) {
    		Object.keys(props.recognizeWith).forEach(function (gesture) {
    			var recognizer = hammer.get(gesture);
    			recognizer.recognizeWith(props.recognizeWith[gesture]);
    		}, this);
    	}

    	Object.keys(props).forEach(function (p) {
    		var e = handlerToEvent[p];
    		if (e) {
    			hammer.off(e);
    			hammer.on(e, props[p]);
    		}
    	});
    }

    var HammerComponent = function (_React$Component) {
    	_inherits$2(HammerComponent, _React$Component);

    	function HammerComponent() {
    		_classCallCheck$2(this, HammerComponent);

    		return _possibleConstructorReturn$2(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
    	}

    	_createClass$2(HammerComponent, [{
    		key: 'componentDidMount',
    		value: function componentDidMount() {
    			this.hammer = new Hammer(this.domElement);
    			updateHammer(this.hammer, this.props);
    		}
    	}, {
    		key: 'componentDidUpdate',
    		value: function componentDidUpdate() {
    			if (this.hammer) {
    				updateHammer(this.hammer, this.props);
    			}
    		}
    	}, {
    		key: 'componentWillUnmount',
    		value: function componentWillUnmount() {
    			if (this.hammer) {
    				this.hammer.stop();
    				this.hammer.destroy();
    			}
    			this.hammer = null;
    		}
    	}, {
    		key: 'render',
    		value: function render() {
    			var props = {};

    			Object.keys(this.props).forEach(function (i) {
    				if (!privateProps[i]) {
    					props[i] = this.props[i];
    				}
    			}, this);

    			var self = this;
    			props.ref = function (domElement) {
    				if (self.props.ref) {
    					self.props.ref(domElement);
    				}
    				self.domElement = domElement;
    			};

    			// Reuse the child provided
    			// This makes it flexible to use whatever element is wanted (div, ul, etc)
    			return React$2__default.cloneElement(React$2__default.Children.only(this.props.children), props);
    		}
    	}]);

    	return HammerComponent;
    }(React$2__default.Component);

    HammerComponent.displayName = 'Hammer';
    HammerComponent.propTypes = {
    	className: propTypes.string
    };

    var Zoomer = /** @class */ (function () {
        function Zoomer() {
            this.posX = 0;
            this.posY = 0;
            this.scale = 1;
            this.lastScale = 1;
            this.lastPosX = 0;
            this.lastPosY = 0;
            this.maxPosX = 0;
            this.maxPosY = 0;
            this.transform = '';
        }
        Zoomer.prototype.pinch = function (e) {
            this.pan(e);
            this.scale = Math.max(0.999, Math.min(this.lastScale * e.scale, 4));
            this.zoom(e);
        };
        Zoomer.prototype.pinchEnd = function (e) {
            this.pan(e);
            this.lastScale = this.scale;
        };
        Zoomer.prototype.doobleTap = function (e) {
            var imgEl = e.target;
            this.transform = 'translate3d(0, 0, 0) scale3d(2, 2, 1)';
            this.scale = 2;
            this.lastScale = 2;
            try {
                if (window
                    .getComputedStyle(imgEl, null)
                    .getPropertyValue('transform')
                    .toString() !== 'matrix(1, 0, 0, 1, 0, 0)') {
                    this.transform = 'translate3d(0, 0, 0) scale3d(1, 1, 1)';
                    this.scale = 1;
                    this.lastScale = 1;
                }
            }
            catch (err) {
                console.error(err);
            }
            imgEl.style.transform = this.transform;
            this.transform = '';
            this.pan(e);
            this.zoom(e);
        };
        Zoomer.prototype.panEnd = function (e) {
            this.lastPosX = this.posX < this.maxPosX ? this.posX : this.maxPosX;
            this.lastPosY = this.posY < this.maxPosY ? this.posY : this.maxPosY;
        };
        Zoomer.prototype.pan = function (e) {
            if (this.scale !== 1) {
                var imgEl = e.target;
                this.posX = this.lastPosX + e.deltaX;
                this.posY = this.lastPosY + e.deltaY;
                this.maxPosX = Math.ceil(((this.scale - 1) * imgEl.clientWidth) / 2);
                this.maxPosY = Math.ceil(((this.scale - 1) * imgEl.clientHeight) / 2);
                if (this.posX > this.maxPosX) {
                    this.posX = this.maxPosX;
                }
                if (this.posX < -this.maxPosX) {
                    this.posX = -this.maxPosX;
                }
                if (this.posY > this.maxPosY) {
                    this.posY = this.maxPosY;
                }
                if (this.posY < -this.maxPosY) {
                    this.posY = -this.maxPosY;
                }
            }
            this.zoom(e);
        };
        Zoomer.prototype.zoom = function (e) {
            var imgEl = e.target;
            if (this.scale !== 1) {
                this.transform =
                    'translate3d(' +
                        this.posX +
                        'px,' +
                        this.posY +
                        'px, 0) ' +
                        'scale3d(' +
                        this.scale +
                        ', ' +
                        this.scale +
                        ', 1)';
            }
            if (imgEl && this.transform) {
                imgEl.style.transform = this.transform;
            }
        };
        return Zoomer;
    }());

    function ImageInModal(_a) {
        var url = _a.url, isModalOpen = _a.isModalOpen, className = _a.className, closeImage = _a.closeImage, _b = _a.closeIconSrc, closeIconSrc = _b === void 0 ? 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgMThMMTggNk0xOCAxOEw2IDYiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+' : _b;
        return (React$2__default.createElement(StyledModal, { className: className, isOpen: isModalOpen, onClose: closeImage }, function () {
            var zoomer = new Zoomer();
            return (React$2__default.createElement(React$2__default.Fragment, null,
                React$2__default.createElement("div", { className: "button-wrap" },
                    React$2__default.createElement("button", { type: "button", onClick: closeImage },
                        React$2__default.createElement("img", { src: closeIconSrc, alt: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }))),
                React$2__default.createElement(HammerComponent, { onPan: function (e) { return zoomer.pan(e); }, onPinch: function (e) { return zoomer.pinch(e); }, onPanEnd: function (e) { return zoomer.panEnd(e); }, onPinchEnd: function (e) { return zoomer.pinchEnd(e); }, onDoubleTap: function (e) { return zoomer.doobleTap(e); }, options: {
                        recognizers: {
                            pinch: { enable: true },
                        },
                    } },
                    React$2__default.createElement("figure", { className: "wrapper" },
                        React$2__default.createElement("img", { src: url, alt: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435" })))));
        }));
    }
    var StyledImageInModal = styled__default(ImageInModal)(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  background: rgb(0, 0, 0);\n\n  .modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    background: rgba(0, 5, 31, 0.5);\n  }\n\n  .wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100vh;\n\n    img {\n      max-width: 100vw;\n      max-height: 100vh;\n    }\n  }\n\n  .button-wrap {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    height: 60px;\n    padding: 0 10px;\n    background: rgba(0, 0, 0, 0.6);\n\n    button {\n      width: 40px;\n      min-width: 40px;\n      height: 40px;\n      line-height: 1;\n      cursor: pointer;\n      border: none;\n    }\n\n    img {\n      position: relative;\n      top: 2px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .button-wrap {\n      top: 40px;\n      right: 40px;\n      width: 60px;\n      height: 60px;\n      padding: 0;\n      background: rgba(0, 0, 0, 0.8);\n\n      button {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n"], ["\n  background: rgb(0, 0, 0);\n\n  .modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    background: rgba(0, 5, 31, 0.5);\n  }\n\n  .wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100vh;\n\n    img {\n      max-width: 100vw;\n      max-height: 100vh;\n    }\n  }\n\n  .button-wrap {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    height: 60px;\n    padding: 0 10px;\n    background: rgba(0, 0, 0, 0.6);\n\n    button {\n      width: 40px;\n      min-width: 40px;\n      height: 40px;\n      line-height: 1;\n      cursor: pointer;\n      border: none;\n    }\n\n    img {\n      position: relative;\n      top: 2px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .button-wrap {\n      top: 40px;\n      right: 40px;\n      width: 60px;\n      height: 60px;\n      padding: 0;\n      background: rgba(0, 0, 0, 0.8);\n\n      button {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n"])), function (_a) {
        var theme = _a.theme;
        return theme.zIndex.header;
    });
    var templateObject_1$i;

    function Section(_a) {
        var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
        return (React$2__default.createElement("section", __assign({ className: className }, rest), children));
    }
    var StyledSection = styled__default(Section)(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  width: ", ";\n  padding: ", "\n    16px;\n  margin: 0 auto;\n\n  @media (min-width: 768px) {\n    max-width: ", ";\n    padding: ", "\n      0;\n  }\n\n  @media (min-width: 1200px) {\n    max-width: ", ";\n    padding: ", "\n      0;\n  }\n"], ["\n  width: ", ";\n  padding: ",
        "\n    16px;\n  margin: 0 auto;\n\n  @media (min-width: 768px) {\n    max-width: ", ";\n    padding: ",
        "\n      0;\n  }\n\n  @media (min-width: 1200px) {\n    max-width: ", ";\n    padding: ",
        "\n      0;\n  }\n"])), function (_a) {
        var theme = _a.theme;
        return theme.containerWidth.mobile;
    }, function (_a) {
        var space = _a.space, theme = _a.theme;
        return space ? theme.space.mobile[space] : 0;
    }, function (_a) {
        var theme = _a.theme;
        return theme.containerWidth.tablet;
    }, function (_a) {
        var space = _a.space, theme = _a.theme;
        return space ? theme.space.tablet[space] : 0;
    }, function (_a) {
        var theme = _a.theme;
        return theme.containerWidth.desktop;
    }, function (_a) {
        var space = _a.space, theme = _a.theme;
        return space ? theme.space.desktop[space] : 0;
    });
    var templateObject_1$j;

    function BackgroundSection(_a) {
        var children = _a.children, className = _a.className, space = _a.space, rest = __rest(_a, ["children", "className", "space"]);
        return (React$2__default.createElement("section", __assign({ className: className }, rest),
            React$2__default.createElement(StyledSection, { space: space, as: "div" }, children)));
    }
    var StyledBackgroundSection = styled__default(BackgroundSection)(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  width: 100%;\n  ", ";\n"], ["\n  width: 100%;\n  ",
        ";\n"])), function (_a) {
        var backgroundColor = _a.backgroundColor;
        return !!backgroundColor && styled.css(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), backgroundColor);
    });
    var templateObject_1$k, templateObject_2$9;

    var isBrowser$1 = typeof document !== 'undefined';

    var supportsPassiveEvents;
    function arePassiveEventsSupported() {
      if (supportsPassiveEvents !== undefined) {
        return supportsPassiveEvents;
      }

      if (!(isBrowser$1)) {
        supportsPassiveEvents = false;
        return false;
      }

      var passive = false;
      var options = {
        // @ts-ignore: this is a temporary object, it doesn't have to return anything
        get passive() {
          passive = true;
        }

      };

      var noop = function noop() {};

      window.addEventListener('t', noop, options);
      window.removeEventListener('t', noop, options);
      supportsPassiveEvents = passive;
      return passive;
    }

    var index = typeof document !== 'undefined' ? React$2.useLayoutEffect : React$2.useEffect;

    var useLatest = function useLatest(value) {
      var ref = React$2.useRef(value);
      index(function () {
        ref.current = value;
      });
      return ref;
    };

    var isBrowser$2 = typeof document !== 'undefined';

    var MOUSEDOWN = 'mousedown';
    var TOUCHSTART = 'touchstart';
    var events = [MOUSEDOWN, TOUCHSTART];

    var getOptions = function getOptions(event) {
      if (event !== TOUCHSTART) {
        return;
      }

      if (arePassiveEventsSupported()) {
        return {
          passive: true
        };
      }
    };

    function useOnClickOutside(ref, handler) {
      if (!(isBrowser$2)) {
        return;
      }

      var handlerRef = useLatest(handler);
      React$2.useEffect(function () {
        if (!handler) {
          return;
        }

        var listener = function listener(event) {
          if (!ref.current || !handlerRef.current || ref.current.contains(event.target)) {
            return;
          }

          handlerRef.current(event);
        };

        events.forEach(function (event) {
          document.addEventListener(event, listener, getOptions(event));
        });
        return function () {
          events.forEach(function (event) {
            document.removeEventListener(event, listener, getOptions(event));
          });
        };
      }, [!handler]);
    }

    var Popover = React$2.forwardRef(function (_a, ref) {
        var isOpen = _a.isOpen, content = _a.content, children = _a.children, onRequestClose = _a.onRequestClose, _b = _a.positionY, positionY = _b === void 0 ? 'bottom' : _b, _c = _a.positionX, positionX = _c === void 0 ? 'left' : _c, className = _a.className, rest = __rest(_a, ["isOpen", "content", "children", "onRequestClose", "positionY", "positionX", "className"]);
        var contentRef = React$2.useRef(null);
        var contentClass = 'popover-content';
        useOnClickOutside(contentRef, function (e) {
            var target = e.target;
            if (!target)
                return;
            var parent = target.parentElement;
            if (target.classList.contains(contentClass) ||
                (parent && parent.classList.contains(contentClass))) {
                return;
            }
            onRequestClose && onRequestClose();
        });
        return (React$2__default.createElement("div", __assign({ ref: ref, className: className }, rest),
            children,
            isOpen && (React$2__default.createElement("div", { className: contentClass, style: {
                    top: positionY === 'top' ? '0' : 'auto',
                    right: positionX === 'right' ? '0' : 'auto',
                    bottom: positionY === 'bottom' ? '0' : 'auto',
                    left: positionX === 'left' ? '0' : 'auto',
                }, ref: contentRef }, content))));
    });
    var StyledPopover = styled__default(Popover)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  position: relative;\n  width: max-content;\n\n  @keyframes appearance {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .popover-content {\n    position: absolute;\n    animation: appearance 0.2s ease-in-out;\n\n    @media (min-width: 768px) {\n      width: inherit;\n    }\n  }\n"], ["\n  position: relative;\n  width: max-content;\n\n  @keyframes appearance {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .popover-content {\n    position: absolute;\n    animation: appearance 0.2s ease-in-out;\n\n    @media (min-width: 768px) {\n      width: inherit;\n    }\n  }\n"])));
    var templateObject_1$l;

    var getSharingData = function (_a) {
        var title = _a.title, text = _a.text, twitter = _a.twitter, url = _a.url, socials = _a.socials;
        var socialsData = {
            vk: {
                href: "https://vk.com/share.php?url=" + url + "&title=" + title + "&utm_source=share2",
                title: 'Поделиться через ВКонтакте',
            },
            twitter: {
                href: "https://twitter.com/intent/tweet/?text=" + twitter + "&url=" + url,
                title: 'Поделиться через Twitter',
            },
            facebook: {
                href: "https://www.facebook.com/sharer/sharer.php?u=" + url + "&t=" + title,
                title: 'Поделиться через Facebook',
            },
            telegram: {
                href: "tg://msg_url?url=" + url,
                title: 'Поделиться через Telegram',
            },
            ok: {
                href: "https://connect.ok.ru/offer?url=" + url + "&title=" + title + "&utm_source=share2",
                title: 'Поделиться через Одноклассники',
            },
            whatsApp: {
                href: "whatsapp://send?text=" + encodeURIComponent(text + ". \u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C: " + url),
                title: 'Поделиться через whatsApp',
            },
            viber: {
                href: "viber://forward?text=" + encodeURIComponent(text + ". \u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C: " + url),
                title: 'Поделиться через Viber',
            },
        };
        return socials.map(function (_a) {
            var type = _a.type, icon = _a.icon, IconComponent = _a.IconComponent, backgroundColor = _a.backgroundColor;
            return (__assign(__assign({}, socialsData[type]), { icon: icon,
                IconComponent: IconComponent,
                backgroundColor: backgroundColor }));
        });
    };

    var Sharing = function (_a) {
        var title = _a.title, text = _a.text, twitter = _a.twitter, url = _a.url, socials = _a.socials, className = _a.className;
        return (React$2__default.createElement("ul", { className: className }, getSharingData({ title: title, text: text, twitter: twitter, url: url, socials: socials }).map(function (_a, index) {
            var title = _a.title, icon = _a.icon, href = _a.href, backgroundColor = _a.backgroundColor, IconComponent = _a.IconComponent;
            return (React$2__default.createElement("li", { key: index },
                React$2__default.createElement("a", { className: "sharing-item", href: href, target: "_blank", rel: "noopener noreferrer", title: title, style: { background: backgroundColor } },
                    icon && React$2__default.createElement("img", { src: icon, alt: title }),
                    IconComponent && React$2__default.createElement(IconComponent, null))));
        })));
    };
    var StyledSharing = styled__default(Sharing)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  max-width: max-content;\n\n  .sharing-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: 0.2s ease;\n\n    :hover {\n      filter: brightness(120%);\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  max-width: max-content;\n\n  .sharing-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: 0.2s ease;\n\n    :hover {\n      filter: brightness(120%);\n    }\n  }\n"])));
    var templateObject_1$m;

    exports.AspectRatioWrapper = StyledAspectRatioWrapper;
    exports.Autocomplete = StyledAutocomplete;
    exports.BackgroundSection = StyledBackgroundSection;
    exports.Button = StyledButton;
    exports.Checkbox = StyledCheckbox;
    exports.DateInput = StyledDateInput;
    exports.FiasInput = StyledFiasInput;
    exports.FlashMessage = StyledFlashMessage;
    exports.ImageInModal = StyledImageInModal;
    exports.Input = Input;
    exports.MaskedInput = StyledMaskedInput;
    exports.Modal = StyledModal;
    exports.Popover = StyledPopover;
    exports.RadioGroup = StyledRadioGroup;
    exports.Section = StyledSection;
    exports.Select = StyledSelect;
    exports.Sharing = StyledSharing;
    exports.Spinner = StyledSpinner;
    exports.Textarea = StyledTextarea;
    exports.Tooltip = TooltipFbk;
    exports.VideoInModal = StyledModal$1;
    exports.VideoThumbnail = StyledVideoThumbnail;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map
